import { c as tr } from "../_commonjsHelpers-B4e78b8K.js";
function Cp(a) {
  return !(typeof a != "object" || a instanceof Array);
}
class Ep {
  filterOutNonSupportedKeys(i, u) {
    const s = /* @__PURE__ */ Object.create({});
    return Cp(i) ? (Object.keys(i).forEach((c) => {
      u.indexOf(c) >= 0 ? s[c] = i[c] : console.warn("Warning - unsupported key provided to configuration: ", c);
    }), s) : /* @__PURE__ */ Object.create({});
  }
}
const Nu = [
  "cname",
  "secureDistribution",
  "privateCdn",
  "signUrl",
  "longUrlSignature",
  "shorten",
  "useRootPath",
  "secure",
  "forceVersion",
  "analytics",
  "queryParams"
];
class fo extends Ep {
  /**
   * @param {IURLConfig} userURLConfig
   */
  constructor(i) {
    super();
    const u = this.filterOutNonSupportedKeys(i, Nu);
    Object.assign(this, {
      secure: !0
    }, u);
  }
  extend(i) {
    const u = this.filterOutNonSupportedKeys(i, Nu);
    return new fo(Object.assign({}, this, u));
  }
  /**
   * @param {string} value Sets the cname
   */
  setCname(i) {
    return this.cname = i, this;
  }
  /**
   * @param {string} value Sets the secureDistribution
   */
  setSecureDistribution(i) {
    return this.secureDistribution = i, this;
  }
  /**
   * @param {boolean} value Sets whether to use a private CDN (Removes cloudName from URL)
   */
  setPrivateCdn(i) {
    return this.privateCdn = i, this;
  }
  /**
   * @param value Sets whether or not to sign the URL
   */
  setSignUrl(i) {
    return this.signUrl = i, this;
  }
  /**
   * @param value Sets whether or not to use a long signature
   */
  setLongUrlSignature(i) {
    return this.longUrlSignature = i, this;
  }
  /**
   * @param value Sets whether or not to shorten the URL
   */
  setShorten(i) {
    return this.shorten = i, this;
  }
  /**
   * @param value Sets whether or not to use a root path
   */
  setUseRootPath(i) {
    return this.useRootPath = i, this;
  }
  /**
   * @param value Sets whether or not to deliver the asset through https
   */
  setSecure(i) {
    return this.secure = i, this;
  }
  /**
   * @param value Sets whether to force a version in the URL
   */
  setForceVersion(i) {
    return this.forceVersion = i, this;
  }
  /**
   * @param params Sets additional params
   */
  setQueryParams(i) {
    return this.queryParams = i, this;
  }
}
class be {
  /**
   *
   * @param {QualifierValue | QualifierValue[] | any[] | string | number}qualifierValue
   */
  constructor(i) {
    this.values = [], this.delimiter = ":", this.hasValue(i) && this.addValue(i);
  }
  /**
   * @description Joins the provided values with the provided delimiter
   */
  toString() {
    return this.values.join(this.delimiter);
  }
  /**
   * @description Checks if the provided argument has a value
   * @param {any} v
   * @private
   * @return {boolean}
   */
  hasValue(i) {
    return typeof i < "u" && i !== null && i !== "";
  }
  /**
   * @desc Adds a value for the this qualifier instance
   * @param {any} value
   * @return {this}
   */
  addValue(i) {
    return Array.isArray(i) ? this.values = this.values.concat(i) : this.values.push(i), this.values = this.values.filter((u) => this.hasValue(u)), this;
  }
  /**
   * @description Sets the delimiter for this instance
   * @param delimiter
   */
  setDelimiter(i) {
    return this.delimiter = i, this;
  }
}
class Rp extends Error {
  constructor(i = "Unsupported") {
    super(i);
  }
}
function lo(a) {
  return new Rp(a);
}
function jp() {
  return this._qualifierModel || { error: lo(`unsupported qualifier ${this.constructor.name}`) };
}
class Dp {
  constructor() {
    this._qualifierModel = {};
  }
  toJson() {
    return jp.apply(this);
  }
}
class ir extends Dp {
  constructor(i, u) {
    super(), this.delimiter = "_", this.key = i, u instanceof be ? this.qualifierValue = u : (this.qualifierValue = new be(), this.qualifierValue.addValue(u));
  }
  toString() {
    const { key: i, delimiter: u, qualifierValue: s } = this;
    return `${i}${u}${s.toString()}`;
  }
  addValue(i) {
    return this.qualifierValue.addValue(i), this;
  }
}
class Tt extends ir {
  constructor(i, u) {
    let s;
    u ? s = new be([i, `${u}`]).setDelimiter(":") : s = i, super("fl", s), this.flagValue = u;
  }
  toString() {
    return super.toString().replace(/\./g, "%2E");
  }
  getFlagValue() {
    return this.flagValue;
  }
}
function xp(a, i) {
  const u = Array.from(a.entries());
  return i.forEach((s) => {
    u.push(["fl", s]);
  }), u.sort().map((s) => s[1]);
}
function Ip() {
  var a, i, u;
  const s = this._actionModel && Object.keys(this._actionModel).length, c = (u = (i = (a = this._actionModel) === null || a === void 0 ? void 0 : a.source) === null || i === void 0 ? void 0 : i.transformation) === null || u === void 0 ? void 0 : u.error;
  return c && c instanceof Error ? { error: c } : s ? this._actionModel : { error: lo(`unsupported action ${this.constructor.name}`) };
}
class Fp {
  constructor() {
    this._actionModel = {};
  }
  toJson() {
    return Ip.apply(this);
  }
}
class ho extends Fp {
  constructor() {
    super(...arguments), this.qualifiers = /* @__PURE__ */ new Map(), this.flags = [], this.delimiter = ",", this.actionTag = "";
  }
  prepareQualifiers() {
  }
  /**
   * @description Returns the custom name tag that was given to this action
   * @return {string}
   */
  getActionTag() {
    return this.actionTag;
  }
  /**
   * @description Sets the custom name tag for this action
   * @return {this}
   */
  setActionTag(i) {
    return this.actionTag = i, this;
  }
  /**
   * @description Calls toString() on all child qualifiers (implicitly by using .join()).
   * @return {string}
   */
  toString() {
    return this.prepareQualifiers(), xp(this.qualifiers, this.flags).join(this.delimiter);
  }
  /**
   * @description Adds the parameter to the action.
   * @param {SDK.Qualifier} qualifier
   * @return {this}
   */
  addQualifier(i) {
    if (typeof i == "string") {
      const [u, s] = i.toLowerCase().split("_");
      u === "fl" ? this.flags.push(new Tt(s)) : this.qualifiers.set(u, new ir(u, s));
    } else
      this.qualifiers.set(i.key, i);
    return this;
  }
  /**
   * @description Adds a flag to the current action.
   * @param {Qualifiers.Flag} flag
   * @return {this}
   */
  addFlag(i) {
    return typeof i == "string" ? this.flags.push(new Tt(i)) : i instanceof Tt && this.flags.push(i), this;
  }
  addValueToQualifier(i, u) {
    return this.qualifiers.get(i).addValue(u), this;
  }
}
function Bp(a) {
  return a && (a.match(/^#/) ? `rgb:${a.substr(1)}` : a);
}
class kp extends ho {
  constructor(i) {
    super(), this._actionModel = {}, this.addQualifier(new ir("b", new be(Bp(i)).setDelimiter("_"))), this._actionModel.color = i, this._actionModel.actionType = "backgroundColor";
  }
  static fromJson(i) {
    const { color: u } = i;
    return new this(u);
  }
}
class Uu {
  constructor(i) {
    this.raw = i;
  }
  toString() {
    return this.raw;
  }
  toJson() {
    return { error: lo(`unsupported action ${this.constructor.name}`) };
  }
}
function qp(a) {
  const i = a;
  return "error" in i && !!i.error;
}
function Lp() {
  return new Tt("lossy");
}
function Mp() {
  return new Tt("preserve_transparency");
}
function Vp(a) {
  return new Tt("progressive", a);
}
class Np extends be {
  constructor(i) {
    super(i), this.val = i;
  }
  getValue() {
    return this.val;
  }
}
function jt(a) {
  const i = {};
  return Object.keys(a).forEach((u) => {
    i[a[u]] = u;
  }), i;
}
const Up = {
  limitFit: "limit",
  limitFill: "lfill",
  minimumFit: "mfit",
  thumbnail: "thumb",
  limitPad: "lpad",
  minimumPad: "mpad",
  autoPad: "auto_pad"
}, zp = {
  colorSpace: "cs",
  dpr: "dpr",
  density: "dn",
  defaultImage: "d",
  format: "f",
  quality: "q"
}, Hp = {
  redEye: "redeye",
  advancedRedEye: "adv_redeye",
  oilPaint: "oil_paint",
  unsharpMask: "unsharp_mask",
  makeTransparent: "make_transparent",
  generativeRestore: "gen_restore",
  upscale: "upscale"
}, Kp = {
  autoBest: "auto:best",
  autoEco: "auto:eco",
  autoGood: "auto:good",
  autoLow: "auto:low",
  jpegminiHigh: "jpegmini:1",
  jpegminiMedium: "jpegmini:2",
  jpegminiBest: "jpegmini:0"
}, Gp = {
  fullHd: "full_hd",
  fullHdWifi: "full_hd_wifi",
  fullHdLean: "full_hd_lean",
  hdLean: "hd_lean"
}, $p = {
  444: "CHROMA_444",
  420: "CHROMA_420"
}, Wp = {
  noCmyk: "no_cmyk",
  keepCmyk: "keep_cmyk",
  tinySrgb: "tinysrgb",
  srgbTrueColor: "srgb:truecolor"
};
jt($p);
jt(Wp);
jt(Up);
const Yp = jt(zp);
jt(Hp);
jt(Kp);
jt(Gp);
class Qp extends ho {
  /**
   * @param {string} deliveryKey A generic Delivery Action Key (such as q, f, dn, etc.)
   * @param {string} deliveryType A Format Qualifiers for the action, such as Quality.auto()
   * @param {string} modelProperty internal model property of the action, for example quality uses `level` while dpr uses `density`
   * @see Visit {@link Actions.Delivery|Delivery} for an example
   */
  constructor(i, u, s) {
    super(), this._actionModel = {};
    let c;
    u instanceof Np ? c = u.getValue() : c = u, this._actionModel.actionType = Yp[i], this._actionModel[s] = c, this.addQualifier(new ir(i, u));
  }
}
class Jp extends Tt {
  constructor(i) {
    super("progressive", i);
  }
}
class rr extends Qp {
  constructor(i, u) {
    super(i, u, "formatType");
  }
  /**
   * @description Uses lossy compression when delivering animated GIF files.
   * @return {this}
   */
  lossy() {
    return this._actionModel.lossy = !0, this.addFlag(Lp()), this;
  }
  /**
   * @description Uses progressive compression when delivering JPG file format.
   * @return {this}
   */
  progressive(i) {
    return i instanceof Jp ? (this._actionModel.progressive = { mode: i.getFlagValue() }, this.addFlag(i)) : (this._actionModel.progressive = { mode: i }, this.addFlag(Vp(i))), this;
  }
  /**
   * @description Ensures that images with a transparency channel are delivered in PNG format.
   */
  preserveTransparency() {
    return this._actionModel.preserveTransparency = !0, this.addFlag(Mp()), this;
  }
  static fromJson(i) {
    const { formatType: u, lossy: s, progressive: c, preserveTransparency: l } = i;
    let d;
    return u ? d = new this("f", u) : d = new this("f"), c && (c.mode ? d.progressive(c.mode) : d.progressive()), s && d.lossy(), l && d.preserveTransparency(), d;
  }
}
class ar {
  constructor() {
    this.actions = [];
  }
  /**
   * @param {SDK.Action | string} action
   * @return {this}
   */
  addAction(i) {
    let u;
    if (typeof i == "string") {
      if (i.indexOf("/") >= 0)
        throw "addAction cannot accept a string with a forward slash in it - /, use .addTransformation() instead";
      u = new Uu(i);
    } else
      u = i;
    return this.actions.push(u), this;
  }
  /**
   * @description Allows the injection of a raw transformation as a string into the transformation, or a Transformation instance that was previously created
   * @param {string | SDK.Transformation} tx
   * @example
   * import {Transformation} from "@cloudinary/url-gen";
   *
   * const transformation = new Transformation();
   * transformation.addTransformation('w_100/w_200/w_300');
   * @return {this}
   */
  addTransformation(i) {
    return i instanceof ar ? this.actions = this.actions.concat(i.actions) : this.actions.push(new Uu(i)), this;
  }
  /**
   * @return {string}
   */
  toString() {
    return this.actions.map((i) => i.toString()).filter((i) => i).join("/");
  }
  /**
   * @description Delivers an animated GIF.
   * @param {AnimatedAction} animatedAction
   * @return {this}
   */
  animated(i) {
    return this.addAction(i);
  }
  /**
   * @description Adds a border around the image.
   * @param {Border} borderAction
   * @return {this}
   */
  border(i) {
    return this.addAction(i);
  }
  /**
   * @description Adjusts the shape of the delivered image. </br>
   * <b>Learn more:</b> {@link https://cloudinary.com/documentation/effects_and_artistic_enhancements#distort|Shape changes and distortion effects}
   * @param {IReshape} reshapeAction
   * @return {this}
   */
  reshape(i) {
    return this.addAction(i);
  }
  /**
   * @description Resize the asset using provided resize action
   * @param {ResizeSimpleAction} resizeAction
   * @return {this}
   */
  resize(i) {
    return this.addAction(i);
  }
  /**
   * @desc An alias to Action Delivery.quality
   * @param {string|number} quality
   * @return {this}
   */
  quality(i) {
    return this.addAction(new rr("q", i)), this;
  }
  /**
   * @desc An alias to Action Delivery.format
   * @param {string} format
   * @return {this}
   */
  format(i) {
    return this.addAction(new rr("f", i)), this;
  }
  /**
   * @description Rounds the specified corners of an image.
   * @param roundCornersAction
   * @return {this}
   */
  roundCorners(i) {
    return this.addAction(i);
  }
  /**
   * @description Adds an overlay over the base image.
   * @param {LayerAction} overlayAction
   * @return {this}
   */
  overlay(i) {
    return this.addAction(i);
  }
  /**
   * @description Adds an underlay under the base image.
   * @param {LayerAction} underlayAction
   * @return {this}
   */
  underlay(i) {
    return i.setLayerType("u"), this.addAction(i);
  }
  /**
   * @description Defines an new user variable.
   * @param {VariableAction} variableAction
   * @return {this}
   */
  addVariable(i) {
    return this.addAction(i);
  }
  /**
   * @description Specifies a condition to be met before applying a transformation.
   * @param {ConditionalAction} conditionAction
   * @return {this}
   */
  conditional(i) {
    return this.addAction(i);
  }
  /**
   * @description Applies a filter or an effect on an asset.
   * @param {SimpleEffectAction} effectAction
   * @return {this}
   */
  effect(i) {
    return this.addAction(i);
  }
  /**
   * @description Applies adjustment effect on an asset.
   * @param action
   * @return {this}
   */
  adjust(i) {
    return this.addAction(i);
  }
  /**
   * @description Rotates the asset by the given angle.
   * @param {RotateAction} rotateAction
   * @return {this}
   */
  rotate(i) {
    return this.addAction(i);
  }
  /**
   * @description Applies a pre-defined named transformation of the given name.
   * @param {NamedTransformation} namedTransformation
   * @return {this}
   */
  namedTransformation(i) {
    return this.addAction(i);
  }
  /**
   * @description Applies delivery action.
   * @param deliveryAction
   * @return {this}
   */
  delivery(i) {
    return this.addAction(i);
  }
  /**
   * @description Sets the color of the background.
   * @param {Qualifiers.Color} color
   * @return {this}
   */
  backgroundColor(i) {
    return this.addAction(new kp(i));
  }
  /**
   * @description Adds a layer in a Photoshop document.
   * @param action
   * @return {this}
   */
  psdTools(i) {
    return this.addAction(i);
  }
  /**
   * @description Extracts an image or a page using an index, a range, or a name from a layered media asset.
   * @param action
   * @return {this}
   */
  extract(i) {
    return this.addAction(i);
  }
  /**
   * @description Adds a flag as a separate action.
   * @param {Qualifiers.Flag | string} flagQualifier
   * @return {this}
   */
  addFlag(i) {
    const u = new ho();
    let s = i;
    return typeof i == "string" && (s = new Tt(i)), u.addQualifier(s), this.addAction(u);
  }
  /**
   * @description Inject a custom function into the image transformation pipeline.
   * @return {this}
   */
  customFunction(i) {
    return this.addAction(i);
  }
  /**
   * Transcodes the video (or audio) to another format.
   * @param {Action} action
   * @return {this}
   */
  transcode(i) {
    return this.addAction(i);
  }
  /**
   * Applies the specified video edit action.
   *
   * @param {videoEditType} action
   * @return {this}
   */
  videoEdit(i) {
    return this.addAction(i);
  }
  toJson() {
    const i = [];
    for (const u of this.actions) {
      const s = u.toJson();
      if (qp(s))
        return s;
      i.push(s);
    }
    return { actions: i };
  }
}
class Xp extends ar {
}
class Zp extends ar {
}
function tv(a) {
  return a.match(/^https?:\//);
}
function ev(a) {
  return a.indexOf("/") < 0;
}
function rv(a) {
  return a.match(/^v[0-9]+/);
}
function nv(a, i) {
  const u = i.secure, s = i.privateCdn, c = i.cname, l = i.secureDistribution;
  return !u && !c ? `http://res.cloudinary.com/${a}` : u && !l && s ? `https://${a}-res.cloudinary.com` : u && !l ? `https://res.cloudinary.com/${a}` : u && l && s ? `https://${l}` : u && l ? `https://${l}/${a}` : !u && c ? `http://${c}/${a}` : "ERROR";
}
function iv(a) {
  return a || "image";
}
function av(a) {
  return a || "upload";
}
function ov(a, i, u) {
  const s = u !== !1;
  return i ? `v${i}` : rv(a) || tv(a) || ev(a) ? "" : s ? "v1" : "";
}
function yo(a, i, u) {
  let s = i >> 0, c = String(u);
  return a.length > s ? String(a) : (s = s - a.length, s > c.length && (c += uv(c, s / c.length)), c.slice(0, s) + String(a));
}
function uv(a, i) {
  let u = i, s = "";
  for (; u > 0; )
    s += a, u--;
  return s;
}
const sv = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", nr = {};
let zu = 0;
sv.split("").forEach((a) => {
  let i = zu.toString(2);
  i = yo(i, 6, "0"), nr[i] = a, zu++;
});
function cv(a) {
  if (a.split(".").length < 2)
    throw new Error("invalid semVer, must have at least two segments");
  return a.split(".").reverse().join(".");
}
function fv(a) {
  if (a.split(".").length < 2)
    throw new Error("invalid semVer, must have at least two segments");
  return a.split(".").map((i) => {
    const u = +i;
    if (isNaN(u) || u < 0)
      throw "Invalid version number provided";
    return yo(i, 2, "0");
  }).join(".");
}
function Hu(a) {
  let i = "";
  const s = a.split(".").length * 6, c = cv(a), l = fv(c);
  let p = parseInt(l.split(".").join("")).toString(2);
  if (p = yo(p, s, "0"), p.length % 6 !== 0)
    throw "Version must be smaller than 43.21.26)";
  return p.match(/.{1,6}/g).forEach((b) => {
    i += nr[b];
  }), i;
}
function lv(a) {
  const i = {
    sdkSemver: a.sdkSemver,
    techVersion: a.techVersion,
    sdkCode: a.sdkCode,
    product: a.product,
    feature: "0",
    osType: a.osType,
    osVersion: a.osVersion
  };
  return a.accessibility && (i.feature = "D"), a.lazyload && (i.feature = "C"), a.responsive && (i.feature = "A"), a.placeholder && (i.feature = "B"), i;
}
const hv = "1.21.0";
function dv(a) {
  const [i, u] = a.split("."), s = parseInt(i).toString(2), c = parseInt(u).toString(2), l = s.padStart(6, "0"), d = c.padStart(6, "0");
  return nr[l] + nr[d];
}
function yv() {
  const a = "0.0.0";
  if (typeof window < "u")
    return a;
  try {
    return process.versions.node || a;
  } catch {
    return a;
  }
}
function pv(a) {
  const i = {
    techVersion: yv(),
    sdkCode: "T",
    sdkSemver: hv.split("-")[0],
    product: "A",
    osType: "Z",
    osVersion: "0.0",
    responsive: !1,
    placeholder: !1,
    lazyload: !1,
    accessibility: !1
  };
  return a ? Object.assign(Object.assign({}, i), a) : i;
}
function Ku(a) {
  const i = pv(a), u = lv(i);
  try {
    const s = vv(u.techVersion), c = Hu(u.sdkSemver), l = Hu(s), d = dv(u.osVersion), p = u.feature, b = u.sdkCode, { product: m, osType: A } = u;
    return `D${m}${b}${c}${l}${A}${d}${p}`;
  } catch {
    return "E";
  }
}
function vv(a) {
  const i = a.split(".");
  return `${i[0]}.${i[1]}`;
}
const Gu = {
  "image/upload": "images",
  "image/private": "private_images",
  "image/authenticated": "authenticated_images",
  "raw/upload": "files",
  "video/upload": "videos"
};
class gv {
  constructor(i, u = {}, s) {
    this.setPublicID(i), this.setCloudConfig(u), this.setURLConfig(s);
  }
  /**
   * @description Sets the URL Config for this asset
   * @param urlConfig
   * @return {this}
   */
  setURLConfig(i) {
    return this.urlConfig = new fo(i), this;
  }
  /**
   * @description Sets the Cloud Config for this asset
   * @param urlConfig
   * @return {this}
   */
  setCloudConfig(i) {
    return this.cloudName = i.cloudName, this.apiKey = i.apiKey, this.apiSecret = i.apiSecret, this.authToken = i.authToken, this;
  }
  /**
   * @description Sets the public ID of the asset.
   * @param {string} publicID The public ID of the asset.
   * @return {this}
   */
  setPublicID(i) {
    return this.publicID = i ? i.toString() : "", this;
  }
  /**
   * @description Sets the delivery type of the asset.
   * @param {DELIVERY_TYPE | string} newType The type of the asset.
   * @return {this}
   */
  setDeliveryType(i) {
    return this.deliveryType = i, this;
  }
  /**
   * @description Sets the URL SEO suffix of the asset.
   * @param {string} newSuffix The SEO suffix.
   * @return {this}
   */
  setSuffix(i) {
    return this.suffix = i, this;
  }
  /**
   * @description Sets the signature of the asset.
   * @param {string} signature The signature.
   * @return {this}
   */
  setSignature(i) {
    return this.signature = i, this;
  }
  /**
   * @description Sets the version of the asset.
   * @param {string} newVersion The version of the asset.
   * @return {this}
   */
  setVersion(i) {
    return i && (this.version = i), this;
  }
  /**
   * @description Sets the asset type.
   * @param {string} newType The type of the asset.
   * @return {this}
   */
  setAssetType(i) {
    return i && (this.assetType = i), this;
  }
  sign() {
    return this;
  }
  /**
   * @description Serializes to URL string
   * @param overwriteOptions
   */
  toURL(i = {}) {
    return this.createCloudinaryURL(null, i.trackedAnalytics);
  }
  /**
   * @description Validate various options before attempting to create a URL
   * The function will throw in case a violation
   * @throws Validation errors
   */
  validateAssetForURLCreation() {
    if (typeof this.cloudName > "u")
      throw "You must supply a cloudName when initializing the asset";
    const i = this.suffix && this.suffix.indexOf(".") >= 0, u = this.suffix && this.suffix.indexOf("/") >= 0;
    if (i || u)
      throw "`suffix`` should not include . or /";
  }
  /**
   * @description return an SEO friendly name for a combination of asset/delivery, some examples:
   * * image/upload -> images
   * * video/upload -> videos
   * If no match is found, return `{asset}/{delivery}`
   */
  getResourceType() {
    const i = iv(this.assetType), u = av(this.deliveryType), s = !!this.suffix, c = `${i}/${u}`, l = Gu[`${i}/${u}`], d = this.urlConfig.useRootPath, p = this.urlConfig.shorten;
    if (d) {
      if (c === "image/upload")
        return "";
      throw new Error(`useRootPath can only be used with assetType: 'image' and deliveryType: 'upload'. Provided: ${c} instead`);
    }
    if (p && c === "image/upload")
      return "iu";
    if (s) {
      if (l)
        return l;
      throw new Error(`URL Suffix only supported for ${Object.keys(Gu).join(", ")}, Provided: ${c} instead`);
    }
    return c;
  }
  getSignature() {
    return this.signature ? `s--${this.signature}--` : "";
  }
  /**
   *
   * @description Creates a fully qualified CloudinaryURL
   * @return {string} CloudinaryURL
   * @throws Validation Errors
   */
  createCloudinaryURL(i, u) {
    if (!this.publicID)
      return "";
    this.validateAssetForURLCreation();
    const s = nv(this.cloudName, this.urlConfig), c = i ? i.toString() : "", l = ov(this.publicID, this.version, this.urlConfig.forceVersion), d = this.publicID;
    if (typeof i == "string")
      return [s, this.getResourceType(), this.getSignature(), c, l, d.replace(/,/g, "%2C"), this.suffix].filter((b) => b).join("/");
    {
      const p = [
        encodeURI(s),
        this.getResourceType(),
        this.getSignature(),
        encodeURI(c),
        l,
        encodeURI(d).replace(/,/g, "%2C"),
        this.suffix && encodeURI(this.suffix)
      ].filter((A) => A).join("/").replace(/\?/g, "%3F").replace(/=/g, "%3D"), b = this.urlConfig.analytics !== !1 && !d.includes("?");
      let m = "";
      if (typeof this.urlConfig.queryParams == "object")
        try {
          const A = new URLSearchParams(this.urlConfig.queryParams);
          b && A.set("_a", Ku(u)), m = A.toString();
        } catch {
          console.error("Error: URLSearchParams is not available so the queryParams object cannot be parsed, please try passing as an already parsed string");
        }
      else
        m = this.urlConfig.queryParams || "", b && (m += `${m.length > 0 ? "&" : ""}_a=${Ku(u)}`);
      return m ? `${p}?${m}` : p;
    }
  }
}
class rl extends gv {
  constructor(i, u, s, c) {
    super(i, u, s), this.transformation = c;
  }
  /**
   * @desc A proxy to {@link SDK.Transformation| Transformation} - Calls the same method contained in this.transformation
   * @param {Actions.Animated} animated
   * @return {this}
   */
  animated(i) {
    return this.transformation.animated(i), this;
  }
  /**
   * @desc A proxy to {@link SDK.Transformation| Transformation} - Calls the same method contained in this.transformation
   * @param {Actions.Border} border
   * @return {this}
   */
  border(i) {
    return this.transformation.border(i), this;
  }
  /**
   * @desc A proxy to {@link SDK.Transformation| Transformation} - Calls the same method contained in this.transformation
   * @param {Actions.Reshape} reshape
   * @return {this}
   */
  reshape(i) {
    return this.transformation.reshape(i), this;
  }
  /**
   * @desc A proxy to {@link SDK.Transformation| Transformation} - Calls the same method contained in this.transformation
   * @param {Actions.Resize} resize
   * @return {this}
   */
  resize(i) {
    return this.transformation.resize(i), this;
  }
  /**
   * @desc An alias to Action Delivery.quality
   * @param {string|number} quality
   * @return {this}
   */
  quality(i) {
    return this.addAction(new rr("q", i)), this;
  }
  /**
   * @desc An alias to Action Delivery.format
   * @param {string} format
   * @return {this}
   */
  format(i) {
    return this.addAction(new rr("f", i)), this;
  }
  /**
   * @desc A proxy to {@link SDK.Transformation| Transformation} - Calls the same method contained in this.transformation
   * @param {Actions.RoundCorners} roundCorners
   * @return {this}
   */
  roundCorners(i) {
    return this.transformation.roundCorners(i), this;
  }
  /**
   * @desc A proxy to {@link SDK.Transformation| Transformation} - Calls the same method contained in this.transformation
   * @return {this}
   */
  overlay(i) {
    return this.transformation.overlay(i), this;
  }
  /**
   * @desc A proxy to {@link SDK.Transformation| Transformation} - Calls the same method contained in this.transformation
   * @param {Actions.Variable} variableAction
   * @return {this}
   */
  addVariable(i) {
    return this.transformation.addVariable(i), this;
  }
  /**
   * @desc A proxy to {@link SDK.Transformation| Transformation} - Calls the same method contained in this.transformation
   * @param {Actions.Condition} conditionalAction
   * @return {this}
   */
  conditional(i) {
    return this.transformation.conditional(i), this;
  }
  /**
   * @desc A proxy to {@link SDK.Transformation| Transformation} - Calls the same method contained in this.transformation
   * @param {Actions.Effect} effect
   * @return {this}
   */
  effect(i) {
    return this.transformation.effect(i), this;
  }
  /**
   * @desc A proxy to {@link SDK.Transformation| Transformation} - Calls the same method contained in this.transformation
   * @param {Actions.Adjust} action
   * @return {this}
   */
  adjust(i) {
    return this.transformation.adjust(i), this;
  }
  /**
   * @desc A proxy to {@link SDK.Transformation| Transformation} - Calls the same method contained in this.transformation
   * @param {Actions.Rotate} rotate
   * @return {this}
   */
  rotate(i) {
    return this.transformation.rotate(i), this;
  }
  /**
   * @desc A proxy to {@link SDK.Transformation| Transformation} - Calls the same method contained in this.transformation
   * @param {Actions.NamedTransformation} namedTransformation
   * @return {this}
   */
  namedTransformation(i) {
    return this.transformation.namedTransformation(i), this;
  }
  /**
   * @desc A proxy to {@link SDK.Transformation| Transformation} - Calls the same method contained in this.transformation
   * @param {Actions.Delivery} deliveryAction
   * @return {this}
   */
  delivery(i) {
    return this.transformation.delivery(i), this;
  }
  /**
   * @desc A proxy to {@link SDK.Transformation| Transformation} - Calls the same method contained in this.transformation
   * @param {Qualifiers.color} color
   * @return {this}
   */
  backgroundColor(i) {
    return this.transformation.backgroundColor(i), this;
  }
  /**
   * @desc A proxy to {@link SDK.Transformation| Transformation} - Calls the same method contained in this.transformation
   * @param {Actions.PSDTools} action
   * @return {this}
   */
  psdTools(i) {
    return this.transformation.psdTools(i), this;
  }
  /**
   * @desc A proxy to {@link SDK.Transformation| Transformation} - Calls the same method contained in this.transformation
   * @param {Actions.Extract} action
   * @return {this}
   */
  extract(i) {
    return this.transformation.extract(i), this;
  }
  /**
   * @desc A proxy to {@link SDK.Transformation| Transformation} - Calls the same method contained in this.transformation
   * @param {Qualifiers.Flag | string} flagQualifier
   * @return {this}
   */
  addFlag(i) {
    return this.transformation.addFlag(i), this;
  }
  /**
   * @desc A proxy to {@link SDK.Transformation| Transformation} - Calls the same method contained in this.transformation
   * @param {Actions.CustomFunction} customFunction
   * @return {this}
   */
  customFunction(i) {
    return this.transformation.customFunction(i), this;
  }
  /**
   * @desc A proxy to {@link SDK.Transformation| Transformation} - Calls the same method contained in this.transformation
   * @param {SDK.Action | string} action
   * @return {this}
   */
  addAction(i) {
    return this.transformation.addAction(i), this;
  }
  /**
   * @description Extend your transformation with another transformation
   * @param { string | SDK.Transformation } tx
   */
  addTransformation(i) {
    return this.transformation.addTransformation(i), this;
  }
  /**
   * @desc A proxy to {@link SDK.Transformation| Transformation} - Calls the same method contained in this.transformation
   * @return {string}
   */
  toString() {
    return this.transformation.toString();
  }
  /**
   * @desc A proxy to {@link SDK.Transformation| Transformation} - Calls the same method contained in this.transformation
   * @return {this}
   */
  underlay(i) {
    return this.transformation.underlay(i), this;
  }
  toURL(i = {}) {
    return this.createCloudinaryURL(this.transformation, i == null ? void 0 : i.trackedAnalytics);
  }
}
class mv extends rl {
  constructor(i, u, s) {
    super(i, u, s, new Xp());
  }
}
class bv extends rl {
  constructor(i, u, s) {
    super(i, u, s, new Zp()), this.assetType = "video";
  }
  /**
   * @desc A proxy to {@link SDK.Transformation| Transformation} - Calls the same method contained in this.transformation
   * @param {Actions.Transcode} action
   * @return {this}
   */
  transcode(i) {
    return this.transformation.transcode(i), this;
  }
  /**
   * @desc A proxy to {@link SDK.Transformation| Transformation} - Calls the same method contained in this.transformation
   * @param {Actions.VideoEdit} action
   * @return {this}
   */
  videoEdit(i) {
    return this.transformation.videoEdit(i), this;
  }
}
class _v {
  constructor(i) {
    i && (this.cloudinaryConfig = i);
  }
  image(i) {
    return new mv(i, this.cloudinaryConfig.cloud, this.cloudinaryConfig.url);
  }
  video(i) {
    return new bv(i, this.cloudinaryConfig.cloud, this.cloudinaryConfig.url);
  }
  setConfig(i) {
    return this.cloudinaryConfig = i, this;
  }
  getConfig() {
    return this.cloudinaryConfig;
  }
  extendConfig() {
  }
}
var er = { exports: {} }, on, $u;
function nl() {
  if ($u) return on;
  $u = 1;
  var a = typeof tr == "object" && tr && tr.Object === Object && tr;
  return on = a, on;
}
var un, Wu;
function st() {
  if (Wu) return un;
  Wu = 1;
  var a = nl(), i = typeof self == "object" && self && self.Object === Object && self, u = a || i || Function("return this")();
  return un = u, un;
}
var sn, Yu;
function _e() {
  if (Yu) return sn;
  Yu = 1;
  var a = st(), i = a.Symbol;
  return sn = i, sn;
}
var cn, Qu;
function Sv() {
  if (Qu) return cn;
  Qu = 1;
  var a = _e(), i = Object.prototype, u = i.hasOwnProperty, s = i.toString, c = a ? a.toStringTag : void 0;
  function l(d) {
    var p = u.call(d, c), b = d[c];
    try {
      d[c] = void 0;
      var m = !0;
    } catch {
    }
    var A = s.call(d);
    return m && (p ? d[c] = b : delete d[c]), A;
  }
  return cn = l, cn;
}
var fn, Ju;
function Av() {
  if (Ju) return fn;
  Ju = 1;
  var a = Object.prototype, i = a.toString;
  function u(s) {
    return i.call(s);
  }
  return fn = u, fn;
}
var ln, Xu;
function Dt() {
  if (Xu) return ln;
  Xu = 1;
  var a = _e(), i = Sv(), u = Av(), s = "[object Null]", c = "[object Undefined]", l = a ? a.toStringTag : void 0;
  function d(p) {
    return p == null ? p === void 0 ? c : s : l && l in Object(p) ? i(p) : u(p);
  }
  return ln = d, ln;
}
var hn, Zu;
function mt() {
  if (Zu) return hn;
  Zu = 1;
  function a(i) {
    var u = typeof i;
    return i != null && (u == "object" || u == "function");
  }
  return hn = a, hn;
}
var dn, ts;
function Se() {
  if (ts) return dn;
  ts = 1;
  var a = Dt(), i = mt(), u = "[object AsyncFunction]", s = "[object Function]", c = "[object GeneratorFunction]", l = "[object Proxy]";
  function d(p) {
    if (!i(p))
      return !1;
    var b = a(p);
    return b == s || b == c || b == u || b == l;
  }
  return dn = d, dn;
}
var yn, es;
function Ov() {
  if (es) return yn;
  es = 1;
  var a = st(), i = a["__core-js_shared__"];
  return yn = i, yn;
}
var pn, rs;
function Tv() {
  if (rs) return pn;
  rs = 1;
  var a = Ov(), i = function() {
    var s = /[^.]+$/.exec(a && a.keys && a.keys.IE_PROTO || "");
    return s ? "Symbol(src)_1." + s : "";
  }();
  function u(s) {
    return !!i && i in s;
  }
  return pn = u, pn;
}
var vn, ns;
function il() {
  if (ns) return vn;
  ns = 1;
  var a = Function.prototype, i = a.toString;
  function u(s) {
    if (s != null) {
      try {
        return i.call(s);
      } catch {
      }
      try {
        return s + "";
      } catch {
      }
    }
    return "";
  }
  return vn = u, vn;
}
var gn, is;
function wv() {
  if (is) return gn;
  is = 1;
  var a = Se(), i = Tv(), u = mt(), s = il(), c = /[\\^$.*+?()[\]{}|]/g, l = /^\[object .+?Constructor\]$/, d = Function.prototype, p = Object.prototype, b = d.toString, m = p.hasOwnProperty, A = RegExp(
    "^" + b.call(m).replace(c, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  );
  function w(R) {
    if (!u(R) || i(R))
      return !1;
    var F = a(R) ? A : l;
    return F.test(s(R));
  }
  return gn = w, gn;
}
var mn, as;
function Pv() {
  if (as) return mn;
  as = 1;
  function a(i, u) {
    return i == null ? void 0 : i[u];
  }
  return mn = a, mn;
}
var bn, os;
function xt() {
  if (os) return bn;
  os = 1;
  var a = wv(), i = Pv();
  function u(s, c) {
    var l = i(s, c);
    return a(l) ? l : void 0;
  }
  return bn = u, bn;
}
var _n, us;
function al() {
  if (us) return _n;
  us = 1;
  var a = xt(), i = function() {
    try {
      var u = a(Object, "defineProperty");
      return u({}, "", {}), u;
    } catch {
    }
  }();
  return _n = i, _n;
}
var Sn, ss;
function po() {
  if (ss) return Sn;
  ss = 1;
  var a = al();
  function i(u, s, c) {
    s == "__proto__" && a ? a(u, s, {
      configurable: !0,
      enumerable: !0,
      value: c,
      writable: !0
    }) : u[s] = c;
  }
  return Sn = i, Sn;
}
var An, cs;
function or() {
  if (cs) return An;
  cs = 1;
  function a(i, u) {
    return i === u || i !== i && u !== u;
  }
  return An = a, An;
}
var On, fs;
function vo() {
  if (fs) return On;
  fs = 1;
  var a = po(), i = or(), u = Object.prototype, s = u.hasOwnProperty;
  function c(l, d, p) {
    var b = l[d];
    (!(s.call(l, d) && i(b, p)) || p === void 0 && !(d in l)) && a(l, d, p);
  }
  return On = c, On;
}
var Tn, ls;
function ee() {
  if (ls) return Tn;
  ls = 1;
  var a = vo(), i = po();
  function u(s, c, l, d) {
    var p = !l;
    l || (l = {});
    for (var b = -1, m = c.length; ++b < m; ) {
      var A = c[b], w = d ? d(l[A], s[A], A, l, s) : void 0;
      w === void 0 && (w = s[A]), p ? i(l, A, w) : a(l, A, w);
    }
    return l;
  }
  return Tn = u, Tn;
}
var wn, hs;
function go() {
  if (hs) return wn;
  hs = 1;
  function a(i) {
    return i;
  }
  return wn = a, wn;
}
var Pn, ds;
function Cv() {
  if (ds) return Pn;
  ds = 1;
  function a(i, u, s) {
    switch (s.length) {
      case 0:
        return i.call(u);
      case 1:
        return i.call(u, s[0]);
      case 2:
        return i.call(u, s[0], s[1]);
      case 3:
        return i.call(u, s[0], s[1], s[2]);
    }
    return i.apply(u, s);
  }
  return Pn = a, Pn;
}
var Cn, ys;
function Ev() {
  if (ys) return Cn;
  ys = 1;
  var a = Cv(), i = Math.max;
  function u(s, c, l) {
    return c = i(c === void 0 ? s.length - 1 : c, 0), function() {
      for (var d = arguments, p = -1, b = i(d.length - c, 0), m = Array(b); ++p < b; )
        m[p] = d[c + p];
      p = -1;
      for (var A = Array(c + 1); ++p < c; )
        A[p] = d[p];
      return A[c] = l(m), a(s, this, A);
    };
  }
  return Cn = u, Cn;
}
var En, ps;
function Rv() {
  if (ps) return En;
  ps = 1;
  function a(i) {
    return function() {
      return i;
    };
  }
  return En = a, En;
}
var Rn, vs;
function jv() {
  if (vs) return Rn;
  vs = 1;
  var a = Rv(), i = al(), u = go(), s = i ? function(c, l) {
    return i(c, "toString", {
      configurable: !0,
      enumerable: !1,
      value: a(l),
      writable: !0
    });
  } : u;
  return Rn = s, Rn;
}
var jn, gs;
function Dv() {
  if (gs) return jn;
  gs = 1;
  var a = 800, i = 16, u = Date.now;
  function s(c) {
    var l = 0, d = 0;
    return function() {
      var p = u(), b = i - (p - d);
      if (d = p, b > 0) {
        if (++l >= a)
          return arguments[0];
      } else
        l = 0;
      return c.apply(void 0, arguments);
    };
  }
  return jn = s, jn;
}
var Dn, ms;
function xv() {
  if (ms) return Dn;
  ms = 1;
  var a = jv(), i = Dv(), u = i(a);
  return Dn = u, Dn;
}
var xn, bs;
function ol() {
  if (bs) return xn;
  bs = 1;
  var a = go(), i = Ev(), u = xv();
  function s(c, l) {
    return u(i(c, l, a), c + "");
  }
  return xn = s, xn;
}
var In, _s;
function ul() {
  if (_s) return In;
  _s = 1;
  var a = 9007199254740991;
  function i(u) {
    return typeof u == "number" && u > -1 && u % 1 == 0 && u <= a;
  }
  return In = i, In;
}
var Fn, Ss;
function re() {
  if (Ss) return Fn;
  Ss = 1;
  var a = Se(), i = ul();
  function u(s) {
    return s != null && i(s.length) && !a(s);
  }
  return Fn = u, Fn;
}
var Bn, As;
function sl() {
  if (As) return Bn;
  As = 1;
  var a = 9007199254740991, i = /^(?:0|[1-9]\d*)$/;
  function u(s, c) {
    var l = typeof s;
    return c = c ?? a, !!c && (l == "number" || l != "symbol" && i.test(s)) && s > -1 && s % 1 == 0 && s < c;
  }
  return Bn = u, Bn;
}
var kn, Os;
function Iv() {
  if (Os) return kn;
  Os = 1;
  var a = or(), i = re(), u = sl(), s = mt();
  function c(l, d, p) {
    if (!s(p))
      return !1;
    var b = typeof d;
    return (b == "number" ? i(p) && u(d, p.length) : b == "string" && d in p) ? a(p[d], l) : !1;
  }
  return kn = c, kn;
}
var qn, Ts;
function cl() {
  if (Ts) return qn;
  Ts = 1;
  var a = ol(), i = Iv();
  function u(s) {
    return a(function(c, l) {
      var d = -1, p = l.length, b = p > 1 ? l[p - 1] : void 0, m = p > 2 ? l[2] : void 0;
      for (b = s.length > 3 && typeof b == "function" ? (p--, b) : void 0, m && i(l[0], l[1], m) && (b = p < 3 ? void 0 : b, p = 1), c = Object(c); ++d < p; ) {
        var A = l[d];
        A && s(c, A, d, b);
      }
      return c;
    });
  }
  return qn = u, qn;
}
var Ln, ws;
function ur() {
  if (ws) return Ln;
  ws = 1;
  var a = Object.prototype;
  function i(u) {
    var s = u && u.constructor, c = typeof s == "function" && s.prototype || a;
    return u === c;
  }
  return Ln = i, Ln;
}
var Mn, Ps;
function Fv() {
  if (Ps) return Mn;
  Ps = 1;
  function a(i, u) {
    for (var s = -1, c = Array(i); ++s < i; )
      c[s] = u(s);
    return c;
  }
  return Mn = a, Mn;
}
var Vn, Cs;
function ct() {
  if (Cs) return Vn;
  Cs = 1;
  function a(i) {
    return i != null && typeof i == "object";
  }
  return Vn = a, Vn;
}
var Nn, Es;
function Bv() {
  if (Es) return Nn;
  Es = 1;
  var a = Dt(), i = ct(), u = "[object Arguments]";
  function s(c) {
    return i(c) && a(c) == u;
  }
  return Nn = s, Nn;
}
var Un, Rs;
function mo() {
  if (Rs) return Un;
  Rs = 1;
  var a = Bv(), i = ct(), u = Object.prototype, s = u.hasOwnProperty, c = u.propertyIsEnumerable, l = a(/* @__PURE__ */ function() {
    return arguments;
  }()) ? a : function(d) {
    return i(d) && s.call(d, "callee") && !c.call(d, "callee");
  };
  return Un = l, Un;
}
var zn, js;
function wt() {
  if (js) return zn;
  js = 1;
  var a = Array.isArray;
  return zn = a, zn;
}
var ve = { exports: {} }, Hn, Ds;
function kv() {
  if (Ds) return Hn;
  Ds = 1;
  function a() {
    return !1;
  }
  return Hn = a, Hn;
}
ve.exports;
var xs;
function bo() {
  return xs || (xs = 1, function(a, i) {
    var u = st(), s = kv(), c = i && !i.nodeType && i, l = c && !0 && a && !a.nodeType && a, d = l && l.exports === c, p = d ? u.Buffer : void 0, b = p ? p.isBuffer : void 0, m = b || s;
    a.exports = m;
  }(ve, ve.exports)), ve.exports;
}
var Kn, Is;
function qv() {
  if (Is) return Kn;
  Is = 1;
  var a = Dt(), i = ul(), u = ct(), s = "[object Arguments]", c = "[object Array]", l = "[object Boolean]", d = "[object Date]", p = "[object Error]", b = "[object Function]", m = "[object Map]", A = "[object Number]", w = "[object Object]", R = "[object RegExp]", F = "[object Set]", B = "[object String]", V = "[object WeakMap]", P = "[object ArrayBuffer]", C = "[object DataView]", y = "[object Float32Array]", O = "[object Float64Array]", _ = "[object Int8Array]", q = "[object Int16Array]", $ = "[object Int32Array]", U = "[object Uint8Array]", N = "[object Uint8ClampedArray]", W = "[object Uint16Array]", z = "[object Uint32Array]", j = {};
  j[y] = j[O] = j[_] = j[q] = j[$] = j[U] = j[N] = j[W] = j[z] = !0, j[s] = j[c] = j[P] = j[l] = j[C] = j[d] = j[p] = j[b] = j[m] = j[A] = j[w] = j[R] = j[F] = j[B] = j[V] = !1;
  function X(et) {
    return u(et) && i(et.length) && !!j[a(et)];
  }
  return Kn = X, Kn;
}
var Gn, Fs;
function sr() {
  if (Fs) return Gn;
  Fs = 1;
  function a(i) {
    return function(u) {
      return i(u);
    };
  }
  return Gn = a, Gn;
}
var ge = { exports: {} };
ge.exports;
var Bs;
function _o() {
  return Bs || (Bs = 1, function(a, i) {
    var u = nl(), s = i && !i.nodeType && i, c = s && !0 && a && !a.nodeType && a, l = c && c.exports === s, d = l && u.process, p = function() {
      try {
        var b = c && c.require && c.require("util").types;
        return b || d && d.binding && d.binding("util");
      } catch {
      }
    }();
    a.exports = p;
  }(ge, ge.exports)), ge.exports;
}
var $n, ks;
function fl() {
  if (ks) return $n;
  ks = 1;
  var a = qv(), i = sr(), u = _o(), s = u && u.isTypedArray, c = s ? i(s) : a;
  return $n = c, $n;
}
var Wn, qs;
function ll() {
  if (qs) return Wn;
  qs = 1;
  var a = Fv(), i = mo(), u = wt(), s = bo(), c = sl(), l = fl(), d = Object.prototype, p = d.hasOwnProperty;
  function b(m, A) {
    var w = u(m), R = !w && i(m), F = !w && !R && s(m), B = !w && !R && !F && l(m), V = w || R || F || B, P = V ? a(m.length, String) : [], C = P.length;
    for (var y in m)
      (A || p.call(m, y)) && !(V && // Safari 9 has enumerable `arguments.length` in strict mode.
      (y == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
      F && (y == "offset" || y == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      B && (y == "buffer" || y == "byteLength" || y == "byteOffset") || // Skip index properties.
      c(y, C))) && P.push(y);
    return P;
  }
  return Wn = b, Wn;
}
var Yn, Ls;
function hl() {
  if (Ls) return Yn;
  Ls = 1;
  function a(i, u) {
    return function(s) {
      return i(u(s));
    };
  }
  return Yn = a, Yn;
}
var Qn, Ms;
function Lv() {
  if (Ms) return Qn;
  Ms = 1;
  var a = hl(), i = a(Object.keys, Object);
  return Qn = i, Qn;
}
var Jn, Vs;
function Mv() {
  if (Vs) return Jn;
  Vs = 1;
  var a = ur(), i = Lv(), u = Object.prototype, s = u.hasOwnProperty;
  function c(l) {
    if (!a(l))
      return i(l);
    var d = [];
    for (var p in Object(l))
      s.call(l, p) && p != "constructor" && d.push(p);
    return d;
  }
  return Jn = c, Jn;
}
var Xn, Ns;
function ne() {
  if (Ns) return Xn;
  Ns = 1;
  var a = ll(), i = Mv(), u = re();
  function s(c) {
    return u(c) ? a(c) : i(c);
  }
  return Xn = s, Xn;
}
var Zn, Us;
function Vv() {
  if (Us) return Zn;
  Us = 1;
  var a = vo(), i = ee(), u = cl(), s = re(), c = ur(), l = ne(), d = Object.prototype, p = d.hasOwnProperty, b = u(function(m, A) {
    if (c(A) || s(A)) {
      i(A, l(A), m);
      return;
    }
    for (var w in A)
      p.call(A, w) && a(m, w, A[w]);
  });
  return Zn = b, Zn;
}
var ti, zs;
function Nv() {
  if (zs) return ti;
  zs = 1;
  function a() {
    this.__data__ = [], this.size = 0;
  }
  return ti = a, ti;
}
var ei, Hs;
function cr() {
  if (Hs) return ei;
  Hs = 1;
  var a = or();
  function i(u, s) {
    for (var c = u.length; c--; )
      if (a(u[c][0], s))
        return c;
    return -1;
  }
  return ei = i, ei;
}
var ri, Ks;
function Uv() {
  if (Ks) return ri;
  Ks = 1;
  var a = cr(), i = Array.prototype, u = i.splice;
  function s(c) {
    var l = this.__data__, d = a(l, c);
    if (d < 0)
      return !1;
    var p = l.length - 1;
    return d == p ? l.pop() : u.call(l, d, 1), --this.size, !0;
  }
  return ri = s, ri;
}
var ni, Gs;
function zv() {
  if (Gs) return ni;
  Gs = 1;
  var a = cr();
  function i(u) {
    var s = this.__data__, c = a(s, u);
    return c < 0 ? void 0 : s[c][1];
  }
  return ni = i, ni;
}
var ii, $s;
function Hv() {
  if ($s) return ii;
  $s = 1;
  var a = cr();
  function i(u) {
    return a(this.__data__, u) > -1;
  }
  return ii = i, ii;
}
var ai, Ws;
function Kv() {
  if (Ws) return ai;
  Ws = 1;
  var a = cr();
  function i(u, s) {
    var c = this.__data__, l = a(c, u);
    return l < 0 ? (++this.size, c.push([u, s])) : c[l][1] = s, this;
  }
  return ai = i, ai;
}
var oi, Ys;
function fr() {
  if (Ys) return oi;
  Ys = 1;
  var a = Nv(), i = Uv(), u = zv(), s = Hv(), c = Kv();
  function l(d) {
    var p = -1, b = d == null ? 0 : d.length;
    for (this.clear(); ++p < b; ) {
      var m = d[p];
      this.set(m[0], m[1]);
    }
  }
  return l.prototype.clear = a, l.prototype.delete = i, l.prototype.get = u, l.prototype.has = s, l.prototype.set = c, oi = l, oi;
}
var ui, Qs;
function Gv() {
  if (Qs) return ui;
  Qs = 1;
  var a = fr();
  function i() {
    this.__data__ = new a(), this.size = 0;
  }
  return ui = i, ui;
}
var si, Js;
function $v() {
  if (Js) return si;
  Js = 1;
  function a(i) {
    var u = this.__data__, s = u.delete(i);
    return this.size = u.size, s;
  }
  return si = a, si;
}
var ci, Xs;
function Wv() {
  if (Xs) return ci;
  Xs = 1;
  function a(i) {
    return this.__data__.get(i);
  }
  return ci = a, ci;
}
var fi, Zs;
function Yv() {
  if (Zs) return fi;
  Zs = 1;
  function a(i) {
    return this.__data__.has(i);
  }
  return fi = a, fi;
}
var li, tc;
function So() {
  if (tc) return li;
  tc = 1;
  var a = xt(), i = st(), u = a(i, "Map");
  return li = u, li;
}
var hi, ec;
function lr() {
  if (ec) return hi;
  ec = 1;
  var a = xt(), i = a(Object, "create");
  return hi = i, hi;
}
var di, rc;
function Qv() {
  if (rc) return di;
  rc = 1;
  var a = lr();
  function i() {
    this.__data__ = a ? a(null) : {}, this.size = 0;
  }
  return di = i, di;
}
var yi, nc;
function Jv() {
  if (nc) return yi;
  nc = 1;
  function a(i) {
    var u = this.has(i) && delete this.__data__[i];
    return this.size -= u ? 1 : 0, u;
  }
  return yi = a, yi;
}
var pi, ic;
function Xv() {
  if (ic) return pi;
  ic = 1;
  var a = lr(), i = "__lodash_hash_undefined__", u = Object.prototype, s = u.hasOwnProperty;
  function c(l) {
    var d = this.__data__;
    if (a) {
      var p = d[l];
      return p === i ? void 0 : p;
    }
    return s.call(d, l) ? d[l] : void 0;
  }
  return pi = c, pi;
}
var vi, ac;
function Zv() {
  if (ac) return vi;
  ac = 1;
  var a = lr(), i = Object.prototype, u = i.hasOwnProperty;
  function s(c) {
    var l = this.__data__;
    return a ? l[c] !== void 0 : u.call(l, c);
  }
  return vi = s, vi;
}
var gi, oc;
function tg() {
  if (oc) return gi;
  oc = 1;
  var a = lr(), i = "__lodash_hash_undefined__";
  function u(s, c) {
    var l = this.__data__;
    return this.size += this.has(s) ? 0 : 1, l[s] = a && c === void 0 ? i : c, this;
  }
  return gi = u, gi;
}
var mi, uc;
function eg() {
  if (uc) return mi;
  uc = 1;
  var a = Qv(), i = Jv(), u = Xv(), s = Zv(), c = tg();
  function l(d) {
    var p = -1, b = d == null ? 0 : d.length;
    for (this.clear(); ++p < b; ) {
      var m = d[p];
      this.set(m[0], m[1]);
    }
  }
  return l.prototype.clear = a, l.prototype.delete = i, l.prototype.get = u, l.prototype.has = s, l.prototype.set = c, mi = l, mi;
}
var bi, sc;
function rg() {
  if (sc) return bi;
  sc = 1;
  var a = eg(), i = fr(), u = So();
  function s() {
    this.size = 0, this.__data__ = {
      hash: new a(),
      map: new (u || i)(),
      string: new a()
    };
  }
  return bi = s, bi;
}
var _i, cc;
function ng() {
  if (cc) return _i;
  cc = 1;
  function a(i) {
    var u = typeof i;
    return u == "string" || u == "number" || u == "symbol" || u == "boolean" ? i !== "__proto__" : i === null;
  }
  return _i = a, _i;
}
var Si, fc;
function hr() {
  if (fc) return Si;
  fc = 1;
  var a = ng();
  function i(u, s) {
    var c = u.__data__;
    return a(s) ? c[typeof s == "string" ? "string" : "hash"] : c.map;
  }
  return Si = i, Si;
}
var Ai, lc;
function ig() {
  if (lc) return Ai;
  lc = 1;
  var a = hr();
  function i(u) {
    var s = a(this, u).delete(u);
    return this.size -= s ? 1 : 0, s;
  }
  return Ai = i, Ai;
}
var Oi, hc;
function ag() {
  if (hc) return Oi;
  hc = 1;
  var a = hr();
  function i(u) {
    return a(this, u).get(u);
  }
  return Oi = i, Oi;
}
var Ti, dc;
function og() {
  if (dc) return Ti;
  dc = 1;
  var a = hr();
  function i(u) {
    return a(this, u).has(u);
  }
  return Ti = i, Ti;
}
var wi, yc;
function ug() {
  if (yc) return wi;
  yc = 1;
  var a = hr();
  function i(u, s) {
    var c = a(this, u), l = c.size;
    return c.set(u, s), this.size += c.size == l ? 0 : 1, this;
  }
  return wi = i, wi;
}
var Pi, pc;
function dl() {
  if (pc) return Pi;
  pc = 1;
  var a = rg(), i = ig(), u = ag(), s = og(), c = ug();
  function l(d) {
    var p = -1, b = d == null ? 0 : d.length;
    for (this.clear(); ++p < b; ) {
      var m = d[p];
      this.set(m[0], m[1]);
    }
  }
  return l.prototype.clear = a, l.prototype.delete = i, l.prototype.get = u, l.prototype.has = s, l.prototype.set = c, Pi = l, Pi;
}
var Ci, vc;
function sg() {
  if (vc) return Ci;
  vc = 1;
  var a = fr(), i = So(), u = dl(), s = 200;
  function c(l, d) {
    var p = this.__data__;
    if (p instanceof a) {
      var b = p.__data__;
      if (!i || b.length < s - 1)
        return b.push([l, d]), this.size = ++p.size, this;
      p = this.__data__ = new u(b);
    }
    return p.set(l, d), this.size = p.size, this;
  }
  return Ci = c, Ci;
}
var Ei, gc;
function yl() {
  if (gc) return Ei;
  gc = 1;
  var a = fr(), i = Gv(), u = $v(), s = Wv(), c = Yv(), l = sg();
  function d(p) {
    var b = this.__data__ = new a(p);
    this.size = b.size;
  }
  return d.prototype.clear = i, d.prototype.delete = u, d.prototype.get = s, d.prototype.has = c, d.prototype.set = l, Ei = d, Ei;
}
var Ri, mc;
function cg() {
  if (mc) return Ri;
  mc = 1;
  function a(i, u) {
    for (var s = -1, c = i == null ? 0 : i.length; ++s < c && u(i[s], s, i) !== !1; )
      ;
    return i;
  }
  return Ri = a, Ri;
}
var ji, bc;
function fg() {
  if (bc) return ji;
  bc = 1;
  var a = ee(), i = ne();
  function u(s, c) {
    return s && a(c, i(c), s);
  }
  return ji = u, ji;
}
var Di, _c;
function lg() {
  if (_c) return Di;
  _c = 1;
  function a(i) {
    var u = [];
    if (i != null)
      for (var s in Object(i))
        u.push(s);
    return u;
  }
  return Di = a, Di;
}
var xi, Sc;
function hg() {
  if (Sc) return xi;
  Sc = 1;
  var a = mt(), i = ur(), u = lg(), s = Object.prototype, c = s.hasOwnProperty;
  function l(d) {
    if (!a(d))
      return u(d);
    var p = i(d), b = [];
    for (var m in d)
      m == "constructor" && (p || !c.call(d, m)) || b.push(m);
    return b;
  }
  return xi = l, xi;
}
var Ii, Ac;
function Ae() {
  if (Ac) return Ii;
  Ac = 1;
  var a = ll(), i = hg(), u = re();
  function s(c) {
    return u(c) ? a(c, !0) : i(c);
  }
  return Ii = s, Ii;
}
var Fi, Oc;
function dg() {
  if (Oc) return Fi;
  Oc = 1;
  var a = ee(), i = Ae();
  function u(s, c) {
    return s && a(c, i(c), s);
  }
  return Fi = u, Fi;
}
var me = { exports: {} };
me.exports;
var Tc;
function pl() {
  return Tc || (Tc = 1, function(a, i) {
    var u = st(), s = i && !i.nodeType && i, c = s && !0 && a && !a.nodeType && a, l = c && c.exports === s, d = l ? u.Buffer : void 0, p = d ? d.allocUnsafe : void 0;
    function b(m, A) {
      if (A)
        return m.slice();
      var w = m.length, R = p ? p(w) : new m.constructor(w);
      return m.copy(R), R;
    }
    a.exports = b;
  }(me, me.exports)), me.exports;
}
var Bi, wc;
function vl() {
  if (wc) return Bi;
  wc = 1;
  function a(i, u) {
    var s = -1, c = i.length;
    for (u || (u = Array(c)); ++s < c; )
      u[s] = i[s];
    return u;
  }
  return Bi = a, Bi;
}
var ki, Pc;
function gl() {
  if (Pc) return ki;
  Pc = 1;
  function a(i, u) {
    for (var s = -1, c = i == null ? 0 : i.length, l = 0, d = []; ++s < c; ) {
      var p = i[s];
      u(p, s, i) && (d[l++] = p);
    }
    return d;
  }
  return ki = a, ki;
}
var qi, Cc;
function ml() {
  if (Cc) return qi;
  Cc = 1;
  function a() {
    return [];
  }
  return qi = a, qi;
}
var Li, Ec;
function Ao() {
  if (Ec) return Li;
  Ec = 1;
  var a = gl(), i = ml(), u = Object.prototype, s = u.propertyIsEnumerable, c = Object.getOwnPropertySymbols, l = c ? function(d) {
    return d == null ? [] : (d = Object(d), a(c(d), function(p) {
      return s.call(d, p);
    }));
  } : i;
  return Li = l, Li;
}
var Mi, Rc;
function yg() {
  if (Rc) return Mi;
  Rc = 1;
  var a = ee(), i = Ao();
  function u(s, c) {
    return a(s, i(s), c);
  }
  return Mi = u, Mi;
}
var Vi, jc;
function Oo() {
  if (jc) return Vi;
  jc = 1;
  function a(i, u) {
    for (var s = -1, c = u.length, l = i.length; ++s < c; )
      i[l + s] = u[s];
    return i;
  }
  return Vi = a, Vi;
}
var Ni, Dc;
function To() {
  if (Dc) return Ni;
  Dc = 1;
  var a = hl(), i = a(Object.getPrototypeOf, Object);
  return Ni = i, Ni;
}
var Ui, xc;
function bl() {
  if (xc) return Ui;
  xc = 1;
  var a = Oo(), i = To(), u = Ao(), s = ml(), c = Object.getOwnPropertySymbols, l = c ? function(d) {
    for (var p = []; d; )
      a(p, u(d)), d = i(d);
    return p;
  } : s;
  return Ui = l, Ui;
}
var zi, Ic;
function pg() {
  if (Ic) return zi;
  Ic = 1;
  var a = ee(), i = bl();
  function u(s, c) {
    return a(s, i(s), c);
  }
  return zi = u, zi;
}
var Hi, Fc;
function _l() {
  if (Fc) return Hi;
  Fc = 1;
  var a = Oo(), i = wt();
  function u(s, c, l) {
    var d = c(s);
    return i(s) ? d : a(d, l(s));
  }
  return Hi = u, Hi;
}
var Ki, Bc;
function vg() {
  if (Bc) return Ki;
  Bc = 1;
  var a = _l(), i = Ao(), u = ne();
  function s(c) {
    return a(c, u, i);
  }
  return Ki = s, Ki;
}
var Gi, kc;
function gg() {
  if (kc) return Gi;
  kc = 1;
  var a = _l(), i = bl(), u = Ae();
  function s(c) {
    return a(c, u, i);
  }
  return Gi = s, Gi;
}
var $i, qc;
function mg() {
  if (qc) return $i;
  qc = 1;
  var a = xt(), i = st(), u = a(i, "DataView");
  return $i = u, $i;
}
var Wi, Lc;
function bg() {
  if (Lc) return Wi;
  Lc = 1;
  var a = xt(), i = st(), u = a(i, "Promise");
  return Wi = u, Wi;
}
var Yi, Mc;
function _g() {
  if (Mc) return Yi;
  Mc = 1;
  var a = xt(), i = st(), u = a(i, "Set");
  return Yi = u, Yi;
}
var Qi, Vc;
function Sg() {
  if (Vc) return Qi;
  Vc = 1;
  var a = xt(), i = st(), u = a(i, "WeakMap");
  return Qi = u, Qi;
}
var Ji, Nc;
function wo() {
  if (Nc) return Ji;
  Nc = 1;
  var a = mg(), i = So(), u = bg(), s = _g(), c = Sg(), l = Dt(), d = il(), p = "[object Map]", b = "[object Object]", m = "[object Promise]", A = "[object Set]", w = "[object WeakMap]", R = "[object DataView]", F = d(a), B = d(i), V = d(u), P = d(s), C = d(c), y = l;
  return (a && y(new a(new ArrayBuffer(1))) != R || i && y(new i()) != p || u && y(u.resolve()) != m || s && y(new s()) != A || c && y(new c()) != w) && (y = function(O) {
    var _ = l(O), q = _ == b ? O.constructor : void 0, $ = q ? d(q) : "";
    if ($)
      switch ($) {
        case F:
          return R;
        case B:
          return p;
        case V:
          return m;
        case P:
          return A;
        case C:
          return w;
      }
    return _;
  }), Ji = y, Ji;
}
var Xi, Uc;
function Ag() {
  if (Uc) return Xi;
  Uc = 1;
  var a = Object.prototype, i = a.hasOwnProperty;
  function u(s) {
    var c = s.length, l = new s.constructor(c);
    return c && typeof s[0] == "string" && i.call(s, "index") && (l.index = s.index, l.input = s.input), l;
  }
  return Xi = u, Xi;
}
var Zi, zc;
function Og() {
  if (zc) return Zi;
  zc = 1;
  var a = st(), i = a.Uint8Array;
  return Zi = i, Zi;
}
var ta, Hc;
function Po() {
  if (Hc) return ta;
  Hc = 1;
  var a = Og();
  function i(u) {
    var s = new u.constructor(u.byteLength);
    return new a(s).set(new a(u)), s;
  }
  return ta = i, ta;
}
var ea, Kc;
function Tg() {
  if (Kc) return ea;
  Kc = 1;
  var a = Po();
  function i(u, s) {
    var c = s ? a(u.buffer) : u.buffer;
    return new u.constructor(c, u.byteOffset, u.byteLength);
  }
  return ea = i, ea;
}
var ra, Gc;
function wg() {
  if (Gc) return ra;
  Gc = 1;
  var a = /\w*$/;
  function i(u) {
    var s = new u.constructor(u.source, a.exec(u));
    return s.lastIndex = u.lastIndex, s;
  }
  return ra = i, ra;
}
var na, $c;
function Pg() {
  if ($c) return na;
  $c = 1;
  var a = _e(), i = a ? a.prototype : void 0, u = i ? i.valueOf : void 0;
  function s(c) {
    return u ? Object(u.call(c)) : {};
  }
  return na = s, na;
}
var ia, Wc;
function Sl() {
  if (Wc) return ia;
  Wc = 1;
  var a = Po();
  function i(u, s) {
    var c = s ? a(u.buffer) : u.buffer;
    return new u.constructor(c, u.byteOffset, u.length);
  }
  return ia = i, ia;
}
var aa, Yc;
function Cg() {
  if (Yc) return aa;
  Yc = 1;
  var a = Po(), i = Tg(), u = wg(), s = Pg(), c = Sl(), l = "[object Boolean]", d = "[object Date]", p = "[object Map]", b = "[object Number]", m = "[object RegExp]", A = "[object Set]", w = "[object String]", R = "[object Symbol]", F = "[object ArrayBuffer]", B = "[object DataView]", V = "[object Float32Array]", P = "[object Float64Array]", C = "[object Int8Array]", y = "[object Int16Array]", O = "[object Int32Array]", _ = "[object Uint8Array]", q = "[object Uint8ClampedArray]", $ = "[object Uint16Array]", U = "[object Uint32Array]";
  function N(W, z, j) {
    var X = W.constructor;
    switch (z) {
      case F:
        return a(W);
      case l:
      case d:
        return new X(+W);
      case B:
        return i(W, j);
      case V:
      case P:
      case C:
      case y:
      case O:
      case _:
      case q:
      case $:
      case U:
        return c(W, j);
      case p:
        return new X();
      case b:
      case w:
        return new X(W);
      case m:
        return u(W);
      case A:
        return new X();
      case R:
        return s(W);
    }
  }
  return aa = N, aa;
}
var oa, Qc;
function Eg() {
  if (Qc) return oa;
  Qc = 1;
  var a = mt(), i = Object.create, u = /* @__PURE__ */ function() {
    function s() {
    }
    return function(c) {
      if (!a(c))
        return {};
      if (i)
        return i(c);
      s.prototype = c;
      var l = new s();
      return s.prototype = void 0, l;
    };
  }();
  return oa = u, oa;
}
var ua, Jc;
function Al() {
  if (Jc) return ua;
  Jc = 1;
  var a = Eg(), i = To(), u = ur();
  function s(c) {
    return typeof c.constructor == "function" && !u(c) ? a(i(c)) : {};
  }
  return ua = s, ua;
}
var sa, Xc;
function Rg() {
  if (Xc) return sa;
  Xc = 1;
  var a = wo(), i = ct(), u = "[object Map]";
  function s(c) {
    return i(c) && a(c) == u;
  }
  return sa = s, sa;
}
var ca, Zc;
function jg() {
  if (Zc) return ca;
  Zc = 1;
  var a = Rg(), i = sr(), u = _o(), s = u && u.isMap, c = s ? i(s) : a;
  return ca = c, ca;
}
var fa, tf;
function Dg() {
  if (tf) return fa;
  tf = 1;
  var a = wo(), i = ct(), u = "[object Set]";
  function s(c) {
    return i(c) && a(c) == u;
  }
  return fa = s, fa;
}
var la, ef;
function xg() {
  if (ef) return la;
  ef = 1;
  var a = Dg(), i = sr(), u = _o(), s = u && u.isSet, c = s ? i(s) : a;
  return la = c, la;
}
var ha, rf;
function Ig() {
  if (rf) return ha;
  rf = 1;
  var a = yl(), i = cg(), u = vo(), s = fg(), c = dg(), l = pl(), d = vl(), p = yg(), b = pg(), m = vg(), A = gg(), w = wo(), R = Ag(), F = Cg(), B = Al(), V = wt(), P = bo(), C = jg(), y = mt(), O = xg(), _ = ne(), q = Ae(), $ = 1, U = 2, N = 4, W = "[object Arguments]", z = "[object Array]", j = "[object Boolean]", X = "[object Date]", et = "[object Error]", Pt = "[object Function]", Oe = "[object GeneratorFunction]", yr = "[object Map]", Te = "[object Number]", ie = "[object Object]", pr = "[object RegExp]", vr = "[object Set]", we = "[object String]", Pe = "[object Symbol]", gr = "[object WeakMap]", Ce = "[object ArrayBuffer]", mr = "[object DataView]", Q = "[object Float32Array]", br = "[object Float64Array]", ft = "[object Int8Array]", _r = "[object Int16Array]", it = "[object Int32Array]", Sr = "[object Uint8Array]", Ee = "[object Uint8ClampedArray]", Ar = "[object Uint16Array]", Or = "[object Uint32Array]", k = {};
  k[W] = k[z] = k[Ce] = k[mr] = k[j] = k[X] = k[Q] = k[br] = k[ft] = k[_r] = k[it] = k[yr] = k[Te] = k[ie] = k[pr] = k[vr] = k[we] = k[Pe] = k[Sr] = k[Ee] = k[Ar] = k[Or] = !0, k[et] = k[Pt] = k[gr] = !1;
  function lt(I, Z, bt, H, It, K) {
    var J, G = Z & $, Ft = Z & U, ht = Z & N;
    if (bt && (J = It ? bt(I, H, It, K) : bt(I)), J !== void 0)
      return J;
    if (!y(I))
      return I;
    var Re = V(I);
    if (Re) {
      if (J = R(I), !G)
        return d(I, J);
    } else {
      var rt = w(I), je = rt == Pt || rt == Oe;
      if (P(I))
        return l(I, G);
      if (rt == ie || rt == W || je && !It) {
        if (J = Ft || je ? {} : B(I), !G)
          return Ft ? b(I, c(J, I)) : p(I, s(J, I));
      } else {
        if (!k[rt])
          return It ? I : {};
        J = F(I, rt, G);
      }
    }
    K || (K = new a());
    var L = K.get(I);
    if (L)
      return L;
    K.set(I, J), O(I) ? I.forEach(function(tt) {
      J.add(lt(tt, Z, bt, tt, I, K));
    }) : C(I) && I.forEach(function(tt, at) {
      J.set(at, lt(tt, Z, bt, at, I, K));
    });
    var Tr = ht ? Ft ? A : m : Ft ? q : _, ae = Re ? void 0 : Tr(I);
    return i(ae || I, function(tt, at) {
      ae && (at = tt, tt = I[at]), u(J, at, lt(tt, Z, bt, at, I, K));
    }), J;
  }
  return ha = lt, ha;
}
var da, nf;
function Fg() {
  if (nf) return da;
  nf = 1;
  var a = Ig(), i = 1, u = 4;
  function s(c) {
    return a(c, i | u);
  }
  return da = s, da;
}
var ya, af;
function Bg() {
  if (af) return ya;
  af = 1;
  function a(i) {
    for (var u = -1, s = i == null ? 0 : i.length, c = 0, l = []; ++u < s; ) {
      var d = i[u];
      d && (l[c++] = d);
    }
    return l;
  }
  return ya = a, ya;
}
var pa, of;
function kg() {
  if (of) return pa;
  of = 1;
  var a = "__lodash_hash_undefined__";
  function i(u) {
    return this.__data__.set(u, a), this;
  }
  return pa = i, pa;
}
var va, uf;
function qg() {
  if (uf) return va;
  uf = 1;
  function a(i) {
    return this.__data__.has(i);
  }
  return va = a, va;
}
var ga, sf;
function Lg() {
  if (sf) return ga;
  sf = 1;
  var a = dl(), i = kg(), u = qg();
  function s(c) {
    var l = -1, d = c == null ? 0 : c.length;
    for (this.__data__ = new a(); ++l < d; )
      this.add(c[l]);
  }
  return s.prototype.add = s.prototype.push = i, s.prototype.has = u, ga = s, ga;
}
var ma, cf;
function Mg() {
  if (cf) return ma;
  cf = 1;
  function a(i, u, s, c) {
    for (var l = i.length, d = s + (c ? 1 : -1); c ? d-- : ++d < l; )
      if (u(i[d], d, i))
        return d;
    return -1;
  }
  return ma = a, ma;
}
var ba, ff;
function Vg() {
  if (ff) return ba;
  ff = 1;
  function a(i) {
    return i !== i;
  }
  return ba = a, ba;
}
var _a, lf;
function Ng() {
  if (lf) return _a;
  lf = 1;
  function a(i, u, s) {
    for (var c = s - 1, l = i.length; ++c < l; )
      if (i[c] === u)
        return c;
    return -1;
  }
  return _a = a, _a;
}
var Sa, hf;
function dr() {
  if (hf) return Sa;
  hf = 1;
  var a = Mg(), i = Vg(), u = Ng();
  function s(c, l, d) {
    return l === l ? u(c, l, d) : a(c, i, d);
  }
  return Sa = s, Sa;
}
var Aa, df;
function Ug() {
  if (df) return Aa;
  df = 1;
  var a = dr();
  function i(u, s) {
    var c = u == null ? 0 : u.length;
    return !!c && a(u, s, 0) > -1;
  }
  return Aa = i, Aa;
}
var Oa, yf;
function zg() {
  if (yf) return Oa;
  yf = 1;
  function a(i, u, s) {
    for (var c = -1, l = i == null ? 0 : i.length; ++c < l; )
      if (s(u, i[c]))
        return !0;
    return !1;
  }
  return Oa = a, Oa;
}
var Ta, pf;
function Co() {
  if (pf) return Ta;
  pf = 1;
  function a(i, u) {
    for (var s = -1, c = i == null ? 0 : i.length, l = Array(c); ++s < c; )
      l[s] = u(i[s], s, i);
    return l;
  }
  return Ta = a, Ta;
}
var wa, vf;
function Hg() {
  if (vf) return wa;
  vf = 1;
  function a(i, u) {
    return i.has(u);
  }
  return wa = a, wa;
}
var Pa, gf;
function Kg() {
  if (gf) return Pa;
  gf = 1;
  var a = Lg(), i = Ug(), u = zg(), s = Co(), c = sr(), l = Hg(), d = 200;
  function p(b, m, A, w) {
    var R = -1, F = i, B = !0, V = b.length, P = [], C = m.length;
    if (!V)
      return P;
    A && (m = s(m, c(A))), w ? (F = u, B = !1) : m.length >= d && (F = l, B = !1, m = new a(m));
    t:
      for (; ++R < V; ) {
        var y = b[R], O = A == null ? y : A(y);
        if (y = w || y !== 0 ? y : 0, B && O === O) {
          for (var _ = C; _--; )
            if (m[_] === O)
              continue t;
          P.push(y);
        } else F(m, O, w) || P.push(y);
      }
    return P;
  }
  return Pa = p, Pa;
}
var Ca, mf;
function Gg() {
  if (mf) return Ca;
  mf = 1;
  var a = _e(), i = mo(), u = wt(), s = a ? a.isConcatSpreadable : void 0;
  function c(l) {
    return u(l) || i(l) || !!(s && l && l[s]);
  }
  return Ca = c, Ca;
}
var Ea, bf;
function $g() {
  if (bf) return Ea;
  bf = 1;
  var a = Oo(), i = Gg();
  function u(s, c, l, d, p) {
    var b = -1, m = s.length;
    for (l || (l = i), p || (p = []); ++b < m; ) {
      var A = s[b];
      c > 0 && l(A) ? c > 1 ? u(A, c - 1, l, d, p) : a(p, A) : d || (p[p.length] = A);
    }
    return p;
  }
  return Ea = u, Ea;
}
var Ra, _f;
function Ol() {
  if (_f) return Ra;
  _f = 1;
  var a = re(), i = ct();
  function u(s) {
    return i(s) && a(s);
  }
  return Ra = u, Ra;
}
var ja, Sf;
function Wg() {
  if (Sf) return ja;
  Sf = 1;
  var a = Kg(), i = $g(), u = ol(), s = Ol(), c = u(function(l, d) {
    return s(l) ? a(l, i(d, 1, s, !0)) : [];
  });
  return ja = c, ja;
}
var Da, Af;
function Yg() {
  if (Af) return Da;
  Af = 1;
  var a = gl(), i = Se();
  function u(s, c) {
    return a(c, function(l) {
      return i(s[l]);
    });
  }
  return Da = u, Da;
}
var xa, Of;
function Qg() {
  if (Of) return xa;
  Of = 1;
  var a = Yg(), i = ne();
  function u(s) {
    return s == null ? [] : a(s, i(s));
  }
  return xa = u, xa;
}
var Ia, Tf;
function Tl() {
  if (Tf) return Ia;
  Tf = 1;
  var a = Dt(), i = wt(), u = ct(), s = "[object String]";
  function c(l) {
    return typeof l == "string" || !i(l) && u(l) && a(l) == s;
  }
  return Ia = c, Ia;
}
var Fa, wf;
function Jg() {
  if (wf) return Fa;
  wf = 1;
  var a = /\s/;
  function i(u) {
    for (var s = u.length; s-- && a.test(u.charAt(s)); )
      ;
    return s;
  }
  return Fa = i, Fa;
}
var Ba, Pf;
function wl() {
  if (Pf) return Ba;
  Pf = 1;
  var a = Jg(), i = /^\s+/;
  function u(s) {
    return s && s.slice(0, a(s) + 1).replace(i, "");
  }
  return Ba = u, Ba;
}
var ka, Cf;
function Pl() {
  if (Cf) return ka;
  Cf = 1;
  var a = Dt(), i = ct(), u = "[object Symbol]";
  function s(c) {
    return typeof c == "symbol" || i(c) && a(c) == u;
  }
  return ka = s, ka;
}
var qa, Ef;
function Xg() {
  if (Ef) return qa;
  Ef = 1;
  var a = wl(), i = mt(), u = Pl(), s = NaN, c = /^[-+]0x[0-9a-f]+$/i, l = /^0b[01]+$/i, d = /^0o[0-7]+$/i, p = parseInt;
  function b(m) {
    if (typeof m == "number")
      return m;
    if (u(m))
      return s;
    if (i(m)) {
      var A = typeof m.valueOf == "function" ? m.valueOf() : m;
      m = i(A) ? A + "" : A;
    }
    if (typeof m != "string")
      return m === 0 ? m : +m;
    m = a(m);
    var w = l.test(m);
    return w || d.test(m) ? p(m.slice(2), w ? 2 : 8) : c.test(m) ? s : +m;
  }
  return qa = b, qa;
}
var La, Rf;
function Zg() {
  if (Rf) return La;
  Rf = 1;
  var a = Xg(), i = 1 / 0, u = 17976931348623157e292;
  function s(c) {
    if (!c)
      return c === 0 ? c : 0;
    if (c = a(c), c === i || c === -1 / 0) {
      var l = c < 0 ? -1 : 1;
      return l * u;
    }
    return c === c ? c : 0;
  }
  return La = s, La;
}
var Ma, jf;
function tm() {
  if (jf) return Ma;
  jf = 1;
  var a = Zg();
  function i(u) {
    var s = a(u), c = s % 1;
    return s === s ? c ? s - c : s : 0;
  }
  return Ma = i, Ma;
}
var Va, Df;
function em() {
  if (Df) return Va;
  Df = 1;
  var a = Co();
  function i(u, s) {
    return a(s, function(c) {
      return u[c];
    });
  }
  return Va = i, Va;
}
var Na, xf;
function rm() {
  if (xf) return Na;
  xf = 1;
  var a = em(), i = ne();
  function u(s) {
    return s == null ? [] : a(s, i(s));
  }
  return Na = u, Na;
}
var Ua, If;
function nm() {
  if (If) return Ua;
  If = 1;
  var a = dr(), i = re(), u = Tl(), s = tm(), c = rm(), l = Math.max;
  function d(p, b, m, A) {
    p = i(p) ? p : c(p), m = m && !A ? s(m) : 0;
    var w = p.length;
    return m < 0 && (m = l(w + m, 0)), u(p) ? m <= w && p.indexOf(b, m) > -1 : !!w && a(p, b, m) > -1;
  }
  return Ua = d, Ua;
}
var za, Ff;
function Eo() {
  if (Ff) return za;
  Ff = 1;
  var a = Dt(), i = To(), u = ct(), s = "[object Object]", c = Function.prototype, l = Object.prototype, d = c.toString, p = l.hasOwnProperty, b = d.call(Object);
  function m(A) {
    if (!u(A) || a(A) != s)
      return !1;
    var w = i(A);
    if (w === null)
      return !0;
    var R = p.call(w, "constructor") && w.constructor;
    return typeof R == "function" && R instanceof R && d.call(R) == b;
  }
  return za = m, za;
}
var Ha, Bf;
function im() {
  if (Bf) return Ha;
  Bf = 1;
  var a = ct(), i = Eo();
  function u(s) {
    return a(s) && s.nodeType === 1 && !i(s);
  }
  return Ha = u, Ha;
}
var Ka, kf;
function Cl() {
  if (kf) return Ka;
  kf = 1;
  var a = po(), i = or();
  function u(s, c, l) {
    (l !== void 0 && !i(s[c], l) || l === void 0 && !(c in s)) && a(s, c, l);
  }
  return Ka = u, Ka;
}
var Ga, qf;
function am() {
  if (qf) return Ga;
  qf = 1;
  function a(i) {
    return function(u, s, c) {
      for (var l = -1, d = Object(u), p = c(u), b = p.length; b--; ) {
        var m = p[i ? b : ++l];
        if (s(d[m], m, d) === !1)
          break;
      }
      return u;
    };
  }
  return Ga = a, Ga;
}
var $a, Lf;
function om() {
  if (Lf) return $a;
  Lf = 1;
  var a = am(), i = a();
  return $a = i, $a;
}
var Wa, Mf;
function El() {
  if (Mf) return Wa;
  Mf = 1;
  function a(i, u) {
    if (!(u === "constructor" && typeof i[u] == "function") && u != "__proto__")
      return i[u];
  }
  return Wa = a, Wa;
}
var Ya, Vf;
function um() {
  if (Vf) return Ya;
  Vf = 1;
  var a = ee(), i = Ae();
  function u(s) {
    return a(s, i(s));
  }
  return Ya = u, Ya;
}
var Qa, Nf;
function sm() {
  if (Nf) return Qa;
  Nf = 1;
  var a = Cl(), i = pl(), u = Sl(), s = vl(), c = Al(), l = mo(), d = wt(), p = Ol(), b = bo(), m = Se(), A = mt(), w = Eo(), R = fl(), F = El(), B = um();
  function V(P, C, y, O, _, q, $) {
    var U = F(P, y), N = F(C, y), W = $.get(N);
    if (W) {
      a(P, y, W);
      return;
    }
    var z = q ? q(U, N, y + "", P, C, $) : void 0, j = z === void 0;
    if (j) {
      var X = d(N), et = !X && b(N), Pt = !X && !et && R(N);
      z = N, X || et || Pt ? d(U) ? z = U : p(U) ? z = s(U) : et ? (j = !1, z = i(N, !0)) : Pt ? (j = !1, z = u(N, !0)) : z = [] : w(N) || l(N) ? (z = U, l(U) ? z = B(U) : (!A(U) || m(U)) && (z = c(N))) : j = !1;
    }
    j && ($.set(N, z), _(z, N, O, q, $), $.delete(N)), a(P, y, z);
  }
  return Qa = V, Qa;
}
var Ja, Uf;
function cm() {
  if (Uf) return Ja;
  Uf = 1;
  var a = yl(), i = Cl(), u = om(), s = sm(), c = mt(), l = Ae(), d = El();
  function p(b, m, A, w, R) {
    b !== m && u(m, function(F, B) {
      if (R || (R = new a()), c(F))
        s(b, m, B, A, p, w, R);
      else {
        var V = w ? w(d(b, B), F, B + "", b, m, R) : void 0;
        V === void 0 && (V = F), i(b, B, V);
      }
    }, l);
  }
  return Ja = p, Ja;
}
var Xa, zf;
function fm() {
  if (zf) return Xa;
  zf = 1;
  var a = cm(), i = cl(), u = i(function(s, c, l) {
    a(s, c, l);
  });
  return Xa = u, Xa;
}
var Za, Hf;
function Rl() {
  if (Hf) return Za;
  Hf = 1;
  var a = _e(), i = Co(), u = wt(), s = Pl(), c = a ? a.prototype : void 0, l = c ? c.toString : void 0;
  function d(p) {
    if (typeof p == "string")
      return p;
    if (u(p))
      return i(p, d) + "";
    if (s(p))
      return l ? l.call(p) : "";
    var b = p + "";
    return b == "0" && 1 / p == -1 / 0 ? "-0" : b;
  }
  return Za = d, Za;
}
var to, Kf;
function lm() {
  if (Kf) return to;
  Kf = 1;
  function a(i, u, s) {
    var c = -1, l = i.length;
    u < 0 && (u = -u > l ? 0 : l + u), s = s > l ? l : s, s < 0 && (s += l), l = u > s ? 0 : s - u >>> 0, u >>>= 0;
    for (var d = Array(l); ++c < l; )
      d[c] = i[c + u];
    return d;
  }
  return to = a, to;
}
var eo, Gf;
function hm() {
  if (Gf) return eo;
  Gf = 1;
  var a = lm();
  function i(u, s, c) {
    var l = u.length;
    return c = c === void 0 ? l : c, !s && c >= l ? u : a(u, s, c);
  }
  return eo = i, eo;
}
var ro, $f;
function dm() {
  if ($f) return ro;
  $f = 1;
  var a = dr();
  function i(u, s) {
    for (var c = u.length; c-- && a(s, u[c], 0) > -1; )
      ;
    return c;
  }
  return ro = i, ro;
}
var no, Wf;
function ym() {
  if (Wf) return no;
  Wf = 1;
  var a = dr();
  function i(u, s) {
    for (var c = -1, l = u.length; ++c < l && a(s, u[c], 0) > -1; )
      ;
    return c;
  }
  return no = i, no;
}
var io, Yf;
function pm() {
  if (Yf) return io;
  Yf = 1;
  function a(i) {
    return i.split("");
  }
  return io = a, io;
}
var ao, Qf;
function vm() {
  if (Qf) return ao;
  Qf = 1;
  var a = "\\ud800-\\udfff", i = "\\u0300-\\u036f", u = "\\ufe20-\\ufe2f", s = "\\u20d0-\\u20ff", c = i + u + s, l = "\\ufe0e\\ufe0f", d = "\\u200d", p = RegExp("[" + d + a + c + l + "]");
  function b(m) {
    return p.test(m);
  }
  return ao = b, ao;
}
var oo, Jf;
function gm() {
  if (Jf) return oo;
  Jf = 1;
  var a = "\\ud800-\\udfff", i = "\\u0300-\\u036f", u = "\\ufe20-\\ufe2f", s = "\\u20d0-\\u20ff", c = i + u + s, l = "\\ufe0e\\ufe0f", d = "[" + a + "]", p = "[" + c + "]", b = "\\ud83c[\\udffb-\\udfff]", m = "(?:" + p + "|" + b + ")", A = "[^" + a + "]", w = "(?:\\ud83c[\\udde6-\\uddff]){2}", R = "[\\ud800-\\udbff][\\udc00-\\udfff]", F = "\\u200d", B = m + "?", V = "[" + l + "]?", P = "(?:" + F + "(?:" + [A, w, R].join("|") + ")" + V + B + ")*", C = V + B + P, y = "(?:" + [A + p + "?", p, w, R, d].join("|") + ")", O = RegExp(b + "(?=" + b + ")|" + y + C, "g");
  function _(q) {
    return q.match(O) || [];
  }
  return oo = _, oo;
}
var uo, Xf;
function mm() {
  if (Xf) return uo;
  Xf = 1;
  var a = pm(), i = vm(), u = gm();
  function s(c) {
    return i(c) ? u(c) : a(c);
  }
  return uo = s, uo;
}
var so, Zf;
function bm() {
  if (Zf) return so;
  Zf = 1;
  var a = Rl();
  function i(u) {
    return u == null ? "" : a(u);
  }
  return so = i, so;
}
var co, tl;
function _m() {
  if (tl) return co;
  tl = 1;
  var a = Rl(), i = wl(), u = hm(), s = dm(), c = ym(), l = mm(), d = bm();
  function p(b, m, A) {
    if (b = d(b), b && (A || m === void 0))
      return i(b);
    if (!b || !(m = a(m)))
      return b;
    var w = l(b), R = l(m), F = c(w, R), B = s(w, R) + 1;
    return u(w, F, B).join("");
  }
  return co = p, co;
}
var Sm = er.exports, el;
function Am() {
  return el || (el = 1, function(a, i) {
    (function(s, c) {
      a.exports = c(Vv(), Fg(), Bg(), Wg(), Qg(), go(), nm(), wt(), im(), Se(), Eo(), Tl(), fm(), _m());
    })(Sm, function(u, s, c, l, d, p, b, m, A, w, R, F, B, V) {
      return (
        /******/
        function(P) {
          var C = {};
          function y(O) {
            if (C[O])
              return C[O].exports;
            var _ = C[O] = {
              /******/
              i: O,
              /******/
              l: !1,
              /******/
              exports: {}
              /******/
            };
            return P[O].call(_.exports, _, _.exports, y), _.l = !0, _.exports;
          }
          return y.m = P, y.c = C, y.d = function(O, _, q) {
            y.o(O, _) || Object.defineProperty(O, _, { enumerable: !0, get: q });
          }, y.r = function(O) {
            typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(O, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(O, "__esModule", { value: !0 });
          }, y.t = function(O, _) {
            if (_ & 1 && (O = y(O)), _ & 8 || _ & 4 && typeof O == "object" && O && O.__esModule) return O;
            var q = /* @__PURE__ */ Object.create(null);
            if (y.r(q), Object.defineProperty(q, "default", { enumerable: !0, value: O }), _ & 2 && typeof O != "string") for (var $ in O) y.d(q, $, (function(U) {
              return O[U];
            }).bind(null, $));
            return q;
          }, y.n = function(O) {
            var _ = O && O.__esModule ? (
              /******/
              function() {
                return O.default;
              }
            ) : (
              /******/
              function() {
                return O;
              }
            );
            return y.d(_, "a", _), _;
          }, y.o = function(O, _) {
            return Object.prototype.hasOwnProperty.call(O, _);
          }, y.p = "", y(y.s = "./src/namespace/cloudinary-core.js");
        }({
          /***/
          "./src/namespace/cloudinary-core.js": (
            /***/
            function(P, C, y) {
              y.r(C), y.d(C, "ClientHintsMetaTag", function() {
                return (
                  /* reexport */
                  xu
                );
              }), y.d(C, "Cloudinary", function() {
                return (
                  /* reexport */
                  Vu
                );
              }), y.d(C, "Condition", function() {
                return (
                  /* reexport */
                  Me
                );
              }), y.d(C, "Configuration", function() {
                return (
                  /* reexport */
                  Ve
                );
              }), y.d(C, "crc32", function() {
                return (
                  /* reexport */
                  U
                );
              }), y.d(C, "Expression", function() {
                return (
                  /* reexport */
                  Y
                );
              }), y.d(C, "FetchLayer", function() {
                return (
                  /* reexport */
                  He
                );
              }), y.d(C, "HtmlTag", function() {
                return (
                  /* reexport */
                  At
                );
              }), y.d(C, "ImageTag", function() {
                return (
                  /* reexport */
                  Ye
                );
              }), y.d(C, "Layer", function() {
                return (
                  /* reexport */
                  kt
                );
              }), y.d(C, "PictureTag", function() {
                return (
                  /* reexport */
                  Xr
                );
              }), y.d(C, "SubtitlesLayer", function() {
                return (
                  /* reexport */
                  Nr
                );
              }), y.d(C, "TextLayer", function() {
                return (
                  /* reexport */
                  le
                );
              }), y.d(C, "Transformation", function() {
                return (
                  /* reexport */
                  nt
                );
              }), y.d(C, "utf8_encode", function() {
                return (
                  /* reexport */
                  q
                );
              }), y.d(C, "Util", function() {
                return (
                  /* reexport */
                  _
                );
              }), y.d(C, "VideoTag", function() {
                return (
                  /* reexport */
                  tn
                );
              });
              var O = {};
              y.r(O), y.d(O, "VERSION", function() {
                return xl;
              }), y.d(O, "CF_SHARED_CDN", function() {
                return Il;
              }), y.d(O, "OLD_AKAMAI_SHARED_CDN", function() {
                return jo;
              }), y.d(O, "AKAMAI_SHARED_CDN", function() {
                return Do;
              }), y.d(O, "SHARED_CDN", function() {
                return xo;
              }), y.d(O, "DEFAULT_TIMEOUT_MS", function() {
                return Io;
              }), y.d(O, "DEFAULT_POSTER_OPTIONS", function() {
                return wr;
              }), y.d(O, "DEFAULT_VIDEO_SOURCE_TYPES", function() {
                return Fo;
              }), y.d(O, "SEO_TYPES", function() {
                return Pr;
              }), y.d(O, "DEFAULT_IMAGE_PARAMS", function() {
                return Cr;
              }), y.d(O, "DEFAULT_VIDEO_PARAMS", function() {
                return Bo;
              }), y.d(O, "DEFAULT_VIDEO_SOURCES", function() {
                return Fl;
              }), y.d(O, "DEFAULT_EXTERNAL_LIBRARIES", function() {
                return ko;
              }), y.d(O, "PLACEHOLDER_IMAGE_MODES", function() {
                return Er;
              }), y.d(O, "ACCESSIBILITY_MODES", function() {
                return Rr;
              }), y.d(O, "URL_KEYS", function() {
                return jr;
              });
              var _ = {};
              y.r(_), y.d(_, "getSDKAnalyticsSignature", function() {
                return Pe;
              }), y.d(_, "getAnalyticsOptions", function() {
                return Ce;
              }), y.d(_, "assign", function() {
                return Q.a;
              }), y.d(_, "cloneDeep", function() {
                return ft.a;
              }), y.d(_, "compact", function() {
                return it.a;
              }), y.d(_, "difference", function() {
                return Ee.a;
              }), y.d(_, "functions", function() {
                return Or.a;
              }), y.d(_, "identity", function() {
                return lt.a;
              }), y.d(_, "includes", function() {
                return Z.a;
              }), y.d(_, "isArray", function() {
                return H.a;
              }), y.d(_, "isPlainObject", function() {
                return K.a;
              }), y.d(_, "isString", function() {
                return G.a;
              }), y.d(_, "merge", function() {
                return ht.a;
              }), y.d(_, "contains", function() {
                return Z.a;
              }), y.d(_, "isIntersectionObserverSupported", function() {
                return at;
              }), y.d(_, "isNativeLazyLoadSupported", function() {
                return Ro;
              }), y.d(_, "detectIntersection", function() {
                return Dl;
              }), y.d(_, "omit", function() {
                return qo;
              }), y.d(_, "allStrings", function() {
                return Lo;
              }), y.d(_, "without", function() {
                return Bl;
              }), y.d(_, "isNumberLike", function() {
                return xe;
              }), y.d(_, "smartEscape", function() {
                return Ie;
              }), y.d(_, "defaults", function() {
                return dt;
              }), y.d(_, "objectProto", function() {
                return Mo;
              }), y.d(_, "objToString", function() {
                return Vo;
              }), y.d(_, "isObject", function() {
                return No;
              }), y.d(_, "funcTag", function() {
                return Uo;
              }), y.d(_, "reWords", function() {
                return Dr;
              }), y.d(_, "camelCase", function() {
                return oe;
              }), y.d(_, "snakeCase", function() {
                return Ct;
              }), y.d(_, "convertKeys", function() {
                return xr;
              }), y.d(_, "withCamelCaseKeys", function() {
                return Ho;
              }), y.d(_, "withSnakeCaseKeys", function() {
                return kl;
              }), y.d(_, "base64Encode", function() {
                return Ko;
              }), y.d(_, "base64EncodeURL", function() {
                return Go;
              }), y.d(_, "extractUrlParams", function() {
                return Ir;
              }), y.d(_, "patchFetchFormat", function() {
                return $o;
              }), y.d(_, "optionConsume", function() {
                return Wo;
              }), y.d(_, "isEmpty", function() {
                return x;
              }), y.d(_, "isAndroid", function() {
                return Yo;
              }), y.d(_, "isEdge", function() {
                return Fr;
              }), y.d(_, "isChrome", function() {
                return Qo;
              }), y.d(_, "isSafari", function() {
                return Jo;
              }), y.d(_, "isElement", function() {
                return rt.a;
              }), y.d(_, "isFunction", function() {
                return L.a;
              }), y.d(_, "trim", function() {
                return ae.a;
              }), y.d(_, "getData", function() {
                return _t;
              }), y.d(_, "setData", function() {
                return Be;
              }), y.d(_, "getAttribute", function() {
                return ql;
              }), y.d(_, "setAttribute", function() {
                return ue;
              }), y.d(_, "removeAttribute", function() {
                return ke;
              }), y.d(_, "setAttributes", function() {
                return Ll;
              }), y.d(_, "hasClass", function() {
                return Zo;
              }), y.d(_, "addClass", function() {
                return tu;
              }), y.d(_, "getStyles", function() {
                return Br;
              }), y.d(_, "cssExpand", function() {
                return Ml;
              }), y.d(_, "domStyle", function() {
                return eu;
              }), y.d(_, "curCSS", function() {
                return kr;
              }), y.d(_, "cssValue", function() {
                return Et;
              }), y.d(_, "augmentWidthOrHeight", function() {
                return ru;
              }), y.d(_, "getWidthOrHeight", function() {
                return iu;
              }), y.d(_, "width", function() {
                return au;
              });
              var q = function(t) {
                var r, n, o, f, h, g, v, S;
                if (t === null || typeof t > "u")
                  return "";
                for (g = t + "", S = "", h = void 0, o = void 0, v = 0, h = o = 0, v = g.length, f = 0; f < v; )
                  r = g.charCodeAt(f), n = null, r < 128 ? o++ : r > 127 && r < 2048 ? n = String.fromCharCode(r >> 6 | 192, r & 63 | 128) : n = String.fromCharCode(r >> 12 | 224, r >> 6 & 63 | 128, r & 63 | 128), n !== null && (o > h && (S += g.slice(h, o)), S += n, h = o = f + 1), f++;
                return o > h && (S += g.slice(h, v)), S;
              };
              function $(e) {
                var t, r, n, o, f, h;
                for (e = q(e), o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t = 0, f = 0, h = 0, t = t ^ -1, r = 0, n = e.length; r < n; )
                  h = (t ^ e.charCodeAt(r)) & 255, f = "0x" + o.substr(h * 9, 8), t = t >>> 8 ^ f, r++;
                return t = t ^ -1, t < 0 && (t += 4294967296), t;
              }
              var U = $;
              function N(e, t, r) {
                return t = t >> 0, r = String(typeof r < "u" ? r : " "), e.length > t ? String(e) : (t = t - e.length, t > r.length && (r += W(r, t / r.length)), r.slice(0, t) + String(e));
              }
              function W(e, t) {
                for (var r = ""; t > 0; )
                  r += e, t--;
                return r;
              }
              function z(e) {
                return Pt(e) || et(e) || X(e) || j();
              }
              function j() {
                throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
              }
              function X(e, t) {
                return Oe(e, t);
              }
              function et(e) {
                if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
              }
              function Pt(e) {
                if (Array.isArray(e)) return Oe(e);
              }
              function Oe(e, t) {
                (t == null || t > e.length) && (t = e.length);
                for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
                return n;
              }
              var yr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", Te = 0, ie = {};
              z(yr).forEach(function(e) {
                var t = Te.toString(2);
                t = N(t, 6, "0"), ie[t] = e, Te++;
              });
              var pr = ie;
              function vr(e) {
                if (e.split(".").length < 2)
                  throw new Error("invalid semVer, must have at least two segments");
                return e.split(".").reverse().map(function(t) {
                  return N(t, 2, "0");
                }).join(".");
              }
              function we(e) {
                var t = "", r = e.split(".").length, n = r * 6, o = vr(e), f = parseInt(o.split(".").join("")), h = f.toString(2);
                if (h = N(h, n, "0"), h.length % 6 !== 0)
                  throw "Version must be smaller than 43.21.26)";
                return h.match(/.{1,6}/g).forEach(function(g) {
                  t += pr[g];
                }), t;
              }
              function Pe() {
                var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                try {
                  var t = gr(e.techVersion), r = we(e.sdkSemver), n = we(t), o = e.feature, f = e.sdkCode, h = "A";
                  return "".concat(h).concat(f).concat(r).concat(n).concat(o);
                } catch {
                  return "E";
                }
              }
              function gr(e) {
                var t = e.split(".");
                return "".concat(t[0], ".").concat(t[1]);
              }
              function Ce(e) {
                var t = {
                  sdkSemver: e.sdkSemver,
                  techVersion: e.techVersion,
                  sdkCode: e.sdkCode,
                  feature: "0"
                };
                return e.urlAnalytics ? (e.accessibility && (t.feature = "D"), e.loading === "lazy" && (t.feature = "C"), e.responsive && (t.feature = "A"), e.placeholder && (t.feature = "B"), t) : {};
              }
              var mr = y("lodash/assign"), Q = /* @__PURE__ */ y.n(mr), br = y("lodash/cloneDeep"), ft = /* @__PURE__ */ y.n(br), _r = y("lodash/compact"), it = /* @__PURE__ */ y.n(_r), Sr = y("lodash/difference"), Ee = /* @__PURE__ */ y.n(Sr), Ar = y("lodash/functions"), Or = /* @__PURE__ */ y.n(Ar), k = y("lodash/identity"), lt = /* @__PURE__ */ y.n(k), I = y("lodash/includes"), Z = /* @__PURE__ */ y.n(I), bt = y("lodash/isArray"), H = /* @__PURE__ */ y.n(bt), It = y("lodash/isPlainObject"), K = /* @__PURE__ */ y.n(It), J = y("lodash/isString"), G = /* @__PURE__ */ y.n(J), Ft = y("lodash/merge"), ht = /* @__PURE__ */ y.n(Ft), Re = y("lodash/isElement"), rt = /* @__PURE__ */ y.n(Re), je = y("lodash/isFunction"), L = /* @__PURE__ */ y.n(je), Tr = y("lodash/trim"), ae = /* @__PURE__ */ y.n(Tr);
              function tt(e) {
                "@babel/helpers - typeof";
                return tt = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
                  return typeof t;
                } : function(t) {
                  return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                }, tt(e);
              }
              function at() {
                return (typeof window > "u" ? "undefined" : tt(window)) === "object" && window.IntersectionObserver;
              }
              function Ro() {
                return (typeof HTMLImageElement > "u" ? "undefined" : tt(HTMLImageElement)) === "object" && HTMLImageElement.prototype.loading;
              }
              function Dl(e, t) {
                try {
                  if (Ro() || !at()) {
                    t();
                    return;
                  }
                  var r = new IntersectionObserver(function(n) {
                    n.forEach(function(o) {
                      o.isIntersecting && (t(), r.unobserve(o.target));
                    });
                  }, {
                    threshold: [0, 0.01]
                  });
                  r.observe(e);
                } catch {
                  t();
                }
              }
              var xl = "2.5.0", Il = "d3jpl91pxevbkh.cloudfront.net", jo = "cloudinary-a.akamaihd.net", Do = "res.cloudinary.com", xo = Do, Io = 1e4, wr = {
                format: "jpg",
                resource_type: "video"
              }, Fo = ["webm", "mp4", "ogv"], Pr = {
                "image/upload": "images",
                "image/private": "private_images",
                "image/authenticated": "authenticated_images",
                "raw/upload": "files",
                "video/upload": "videos"
              }, Cr = {
                resource_type: "image",
                transformation: [],
                type: "upload"
              }, Bo = {
                fallback_content: "",
                resource_type: "video",
                source_transformation: {},
                source_types: Fo,
                transformation: [],
                type: "upload"
              }, Fl = [{
                type: "mp4",
                codecs: "hev1",
                transformations: {
                  video_codec: "h265"
                }
              }, {
                type: "webm",
                codecs: "vp9",
                transformations: {
                  video_codec: "vp9"
                }
              }, {
                type: "mp4",
                transformations: {
                  video_codec: "auto"
                }
              }, {
                type: "webm",
                transformations: {
                  video_codec: "auto"
                }
              }], ko = {
                seeThru: "https://unpkg.com/seethru@4/dist/seeThru.min.js"
              }, Er = {
                blur: [{
                  effect: "blur:2000",
                  quality: 1,
                  fetch_format: "auto"
                }],
                // Default
                pixelate: [{
                  effect: "pixelate",
                  quality: 1,
                  fetch_format: "auto"
                }],
                // Generates a pixel size image which color is the predominant color of the original image.
                "predominant-color-pixel": [{
                  width: "iw_div_2",
                  aspect_ratio: 1,
                  crop: "pad",
                  background: "auto"
                }, {
                  crop: "crop",
                  width: 1,
                  height: 1,
                  gravity: "north_east"
                }, {
                  fetch_format: "auto",
                  quality: "auto"
                }],
                // Generates an image which color is the predominant color of the original image.
                "predominant-color": [{
                  variables: [["$currWidth", "w"], ["$currHeight", "h"]]
                }, {
                  width: "iw_div_2",
                  aspect_ratio: 1,
                  crop: "pad",
                  background: "auto"
                }, {
                  crop: "crop",
                  width: 10,
                  height: 10,
                  gravity: "north_east"
                }, {
                  width: "$currWidth",
                  height: "$currHeight",
                  crop: "fill"
                }, {
                  fetch_format: "auto",
                  quality: "auto"
                }],
                vectorize: [{
                  effect: "vectorize:3:0.1",
                  fetch_format: "svg"
                }]
              }, Rr = {
                darkmode: "tint:75:black",
                brightmode: "tint:50:white",
                monochrome: "grayscale",
                colorblind: "assist_colorblind"
              }, jr = ["accessibility", "api_secret", "auth_token", "cdn_subdomain", "cloud_name", "cname", "format", "placeholder", "private_cdn", "resource_type", "secure", "secure_cdn_subdomain", "secure_distribution", "shorten", "sign_url", "signature", "ssl_detected", "type", "url_suffix", "use_root_path", "version"];
              function De(e) {
                "@babel/helpers - typeof";
                return De = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
                  return typeof t;
                } : function(t) {
                  return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                }, De(e);
              }
              function qo(e, t) {
                e = e || {};
                var r = Object.keys(e).filter(function(o) {
                  return !Z()(t, o);
                }), n = {};
                return r.forEach(function(o) {
                  return n[o] = e[o];
                }), n;
              }
              var Lo = function(t) {
                return t.length && t.every(G.a);
              }, Bl = function(t, r) {
                return t.filter(function(n) {
                  return n !== r;
                });
              }, xe = function(t) {
                return t != null && !isNaN(parseFloat(t));
              }, Ie = function(t) {
                var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : /([^a-zA-Z0-9_.\-\/:]+)/g;
                return t.replace(r, function(n) {
                  return n.split("").map(function(o) {
                    return "%" + o.charCodeAt(0).toString(16).toUpperCase();
                  }).join("");
                });
              }, dt = function(t) {
                for (var r = arguments.length, n = new Array(r > 1 ? r - 1 : 0), o = 1; o < r; o++)
                  n[o - 1] = arguments[o];
                return n.reduce(function(f, h) {
                  var g, v;
                  for (g in h)
                    v = h[g], f[g] === void 0 && (f[g] = v);
                  return f;
                }, t);
              }, Mo = Object.prototype, Vo = Mo.toString, No = function(t) {
                var r;
                return r = De(t), !!t && (r === "object" || r === "function");
              }, Uo = "[object Function]", zo = function(t) {
                return No(t) && Vo.call(t) === Uo;
              }, Dr = function() {
                var e, t;
                return t = "[A-Z]", e = "[a-z]+", RegExp(t + "+(?=" + t + e + ")|" + t + "?" + e + "|" + t + "+|[0-9]+", "g");
              }(), oe = function(t) {
                var r = t.match(Dr);
                return r = r.map(function(n) {
                  return n.charAt(0).toLocaleUpperCase() + n.slice(1).toLocaleLowerCase();
                }), r[0] = r[0].toLocaleLowerCase(), r.join("");
              }, Ct = function(t) {
                var r = t.match(Dr);
                return r = r.map(function(n) {
                  return n.toLocaleLowerCase();
                }), r.join("_");
              }, xr = function(t, r) {
                var n, o;
                n = {};
                for (var f in t)
                  o = t[f], r && (f = r(f)), x(f) || (n[f] = o);
                return n;
              }, Ho = function(t) {
                return xr(t, oe);
              }, kl = function(t) {
                return xr(t, Ct);
              }, Ko = typeof btoa < "u" && zo(btoa) ? btoa : typeof Buffer < "u" && zo(Buffer) ? function(e) {
                return e instanceof Buffer || (e = new Buffer.from(String(e), "binary")), e.toString("base64");
              } : function(e) {
                throw new Error("No base64 encoding function found");
              }, Go = function(t) {
                try {
                  t = decodeURI(t);
                } finally {
                  t = encodeURI(t);
                }
                return Ko(t);
              };
              function Ir(e) {
                return jr.reduce(function(t, r) {
                  return e[r] != null && (t[r] = e[r]), t;
                }, {});
              }
              function $o(e) {
                e == null && (e = {}), e.type === "fetch" && e.fetch_format == null && (e.fetch_format = Wo(e, "format"));
              }
              function Wo(e, t, r) {
                var n = e[t];
                return delete e[t], n ?? r;
              }
              function x(e) {
                if (e == null)
                  return !0;
                if (typeof e.length == "number")
                  return e.length === 0;
                if (typeof e.size == "number")
                  return e.size === 0;
                if (De(e) == "object") {
                  for (var t in e)
                    if (e.hasOwnProperty(t))
                      return !1;
                  return !0;
                }
                return !0;
              }
              function Fe() {
                return navigator && navigator.userAgent || "";
              }
              function Yo() {
                var e = Fe();
                return /Android/i.test(e);
              }
              function Fr() {
                var e = Fe();
                return /Edg/i.test(e);
              }
              function Qo() {
                var e = Fe();
                return !Fr() && (/Chrome/i.test(e) || /CriOS/i.test(e));
              }
              function Jo() {
                var e = Fe();
                return /Safari/i.test(e) && !Qo() && !Yo() && !Fr();
              }
              var Xo, _t = function(t, r) {
                switch (!1) {
                  case t != null:
                    return;
                  case !L()(t.getAttribute):
                    return t.getAttribute("data-".concat(r));
                  case !L()(t.getAttr):
                    return t.getAttr("data-".concat(r));
                  case !L()(t.data):
                    return t.data(r);
                  case !(L()(typeof jQuery < "u" && jQuery.fn && jQuery.fn.data) && rt()(t)):
                    return jQuery(t).data(r);
                }
              }, Be = function(t, r, n) {
                switch (!1) {
                  case t != null:
                    return;
                  case !L()(t.setAttribute):
                    return t.setAttribute("data-".concat(r), n);
                  case !L()(t.setAttr):
                    return t.setAttr("data-".concat(r), n);
                  case !L()(t.data):
                    return t.data(r, n);
                  case !(L()(typeof jQuery < "u" && jQuery.fn && jQuery.fn.data) && rt()(t)):
                    return jQuery(t).data(r, n);
                }
              }, ql = function(t, r) {
                switch (!1) {
                  case t != null:
                    return;
                  case !L()(t.getAttribute):
                    return t.getAttribute(r);
                  case !L()(t.attr):
                    return t.attr(r);
                  case !L()(t.getAttr):
                    return t.getAttr(r);
                }
              }, ue = function(t, r, n) {
                switch (!1) {
                  case t != null:
                    return;
                  case !L()(t.setAttribute):
                    return t.setAttribute(r, n);
                  case !L()(t.attr):
                    return t.attr(r, n);
                  case !L()(t.setAttr):
                    return t.setAttr(r, n);
                }
              }, ke = function(t, r) {
                switch (!1) {
                  case t != null:
                    return;
                  case !L()(t.removeAttribute):
                    return t.removeAttribute(r);
                  default:
                    return ue(t, void 0);
                }
              }, Ll = function(t, r) {
                var n, o, f;
                o = [];
                for (n in r)
                  f = r[n], f != null ? o.push(ue(t, n, f)) : o.push(ke(t, n));
                return o;
              }, Zo = function(t, r) {
                if (rt()(t))
                  return t.className.match(new RegExp("\\b".concat(r, "\\b")));
              }, tu = function(t, r) {
                if (!t.className.match(new RegExp("\\b".concat(r, "\\b"))))
                  return t.className = ae()("".concat(t.className, " ").concat(r));
              }, Br = function(t) {
                return t.ownerDocument.defaultView.opener ? t.ownerDocument.defaultView.getComputedStyle(t, null) : window.getComputedStyle(t, null);
              }, Ml = ["Top", "Right", "Bottom", "Left"];
              Xo = function(t, r) {
                var n, o;
                return n = t.nodeType === 9 ? t.documentElement : t, o = r && r.parentNode, t === o || !!(o && o.nodeType === 1 && n.contains(o));
              };
              var eu = function(t, r) {
                if (!(!t || t.nodeType === 3 || t.nodeType === 8 || !t.style))
                  return t.style[r];
              }, kr = function(t, r, n) {
                var o, f, h, g, v, S;
                return g = /^margin/, S = void 0, f = void 0, o = void 0, h = void 0, v = t.style, n = n || Br(t), n && (h = n.getPropertyValue(r) || n[r]), n && (h === "" && !Xo(t.ownerDocument, t) && (h = eu(t, r)), nu.test(h) && g.test(r) && (S = v.width, f = v.minWidth, o = v.maxWidth, v.minWidth = v.maxWidth = v.width = h, h = n.width, v.width = S, v.minWidth = f, v.maxWidth = o)), h !== void 0 ? h + "" : h;
              }, Et = function(t, r, n, o) {
                var f;
                return f = kr(t, r, o), n ? parseFloat(f) : f;
              }, ru = function(t, r, n, o, f) {
                var h, g, v, S, T;
                if (n === (o ? "border" : "content"))
                  return 0;
                for (S = r === "width" ? ["Right", "Left"] : ["Top", "Bottom"], T = 0, h = 0, g = S.length; h < g; h++)
                  v = S[h], n === "margin" && (T += Et(t, n + v, !0, f)), o ? (n === "content" && (T -= Et(t, "padding".concat(v), !0, f)), n !== "margin" && (T -= Et(t, "border".concat(v, "Width"), !0, f))) : (T += Et(t, "padding".concat(v), !0, f), n !== "padding" && (T += Et(t, "border".concat(v, "Width"), !0, f)));
                return T;
              }, Vl = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source, nu = new RegExp("^(" + Vl + ")(?!px)[a-z%]+$", "i"), iu = function(t, r, n) {
                var o, f, h, g;
                if (g = !0, h = r === "width" ? t.offsetWidth : t.offsetHeight, f = Br(t), o = Et(t, "boxSizing", !1, f) === "border-box", h <= 0 || h == null) {
                  if (h = kr(t, r, f), (h < 0 || h == null) && (h = t.style[r]), nu.test(h))
                    return h;
                  g = o && h === t.style[r], h = parseFloat(h) || 0;
                }
                return h + ru(t, r, n || (o ? "border" : "content"), g, f);
              }, au = function(t) {
                return iu(t, "width", "content");
              };
              function se(e) {
                "@babel/helpers - typeof";
                return se = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
                  return typeof t;
                } : function(t) {
                  return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                }, se(e);
              }
              function Nl(e, t) {
                if (!(e instanceof t))
                  throw new TypeError("Cannot call a class as a function");
              }
              function ou(e, t) {
                for (var r = 0; r < t.length; r++) {
                  var n = t[r];
                  n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, zl(n.key), n);
                }
              }
              function Ul(e, t, r) {
                return t && ou(e.prototype, t), r && ou(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
              }
              function zl(e) {
                var t = Hl(e, "string");
                return se(t) == "symbol" ? t : t + "";
              }
              function Hl(e, t) {
                if (se(e) != "object" || !e) return e;
                var r = e[Symbol.toPrimitive];
                if (r !== void 0) {
                  var n = r.call(e, t);
                  if (se(n) != "object") return n;
                  throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return String(e);
              }
              var qe = /* @__PURE__ */ function() {
                function e(t) {
                  Nl(this, e), this.expressions = [], t != null && this.expressions.push(e.normalize(t));
                }
                return Ul(e, [{
                  key: "serialize",
                  value: (
                    /**
                     * Serialize the expression
                     * @return {string} the expression as a string
                     */
                    function() {
                      return e.normalize(this.expressions.join("_"));
                    }
                  )
                }, {
                  key: "toString",
                  value: function() {
                    return this.serialize();
                  }
                  /**
                   * Get the parent transformation of this expression
                   * @return Transformation
                   */
                }, {
                  key: "getParent",
                  value: function() {
                    return this.parent;
                  }
                  /**
                   * Set the parent transformation of this expression
                   * @param {Transformation} the parent transformation
                   * @return {Expression} this expression
                   */
                }, {
                  key: "setParent",
                  value: function(r) {
                    return this.parent = r, this;
                  }
                  /**
                   * Add a expression
                   * @function Expression#predicate
                   * @internal
                   */
                }, {
                  key: "predicate",
                  value: function(r, n, o) {
                    return e.OPERATORS[n] != null && (n = e.OPERATORS[n]), this.expressions.push("".concat(r, "_").concat(n, "_").concat(o)), this;
                  }
                  /**
                   * @function Expression#and
                   */
                }, {
                  key: "and",
                  value: function() {
                    return this.expressions.push("and"), this;
                  }
                  /**
                   * @function Expression#or
                   */
                }, {
                  key: "or",
                  value: function() {
                    return this.expressions.push("or"), this;
                  }
                  /**
                   * Conclude expression
                   * @function Expression#then
                   * @return {Transformation} the transformation this expression is defined for
                   */
                }, {
                  key: "then",
                  value: function() {
                    return this.getParent().if(this.toString());
                  }
                  /**
                   * @function Expression#height
                   * @param {string} operator the comparison operator (e.g. "<", "lt")
                   * @param {string|number} value the right hand side value
                   * @return {Expression} this expression
                   */
                }, {
                  key: "height",
                  value: function(r, n) {
                    return this.predicate("h", r, n);
                  }
                  /**
                   * @function Expression#width
                   * @param {string} operator the comparison operator (e.g. "<", "lt")
                   * @param {string|number} value the right hand side value
                   * @return {Expression} this expression
                   */
                }, {
                  key: "width",
                  value: function(r, n) {
                    return this.predicate("w", r, n);
                  }
                  /**
                   * @function Expression#aspectRatio
                   * @param {string} operator the comparison operator (e.g. "<", "lt")
                   * @param {string|number} value the right hand side value
                   * @return {Expression} this expression
                   */
                }, {
                  key: "aspectRatio",
                  value: function(r, n) {
                    return this.predicate("ar", r, n);
                  }
                  /**
                   * @function Expression#pages
                   * @param {string} operator the comparison operator (e.g. "<", "lt")
                   * @param {string|number} value the right hand side value
                   * @return {Expression} this expression
                   */
                }, {
                  key: "pageCount",
                  value: function(r, n) {
                    return this.predicate("pc", r, n);
                  }
                  /**
                   * @function Expression#faces
                   * @param {string} operator the comparison operator (e.g. "<", "lt")
                   * @param {string|number} value the right hand side value
                   * @return {Expression} this expression
                   */
                }, {
                  key: "faceCount",
                  value: function(r, n) {
                    return this.predicate("fc", r, n);
                  }
                }, {
                  key: "value",
                  value: function(r) {
                    return this.expressions.push(r), this;
                  }
                  /**
                   */
                }], [{
                  key: "new",
                  value: function(r) {
                    return new this(r);
                  }
                  /**
                   * Normalize a string expression
                   * @function Cloudinary#normalize
                   * @param {string} expression a expression, e.g. "w gt 100", "width_gt_100", "width > 100"
                   * @return {string} the normalized form of the value expression, e.g. "w_gt_100"
                   */
                }, {
                  key: "normalize",
                  value: function(r) {
                    if (r == null)
                      return r;
                    r = String(r);
                    var n = "\\|\\||>=|<=|&&|!=|>|=|<|/|-|\\+|\\*|\\^", o = "((" + n + ")(?=[ _]))", f = new RegExp(o, "g");
                    r = r.replace(f, function(S) {
                      return e.OPERATORS[S];
                    });
                    var h = "(" + Object.keys(e.PREDEFINED_VARS).map(function(S) {
                      return ":".concat(S, "|").concat(S);
                    }).join("|") + ")", g = "(\\$_*[^_ ]+)", v = new RegExp("".concat(g, "|").concat(h), "g");
                    return r = r.replace(v, function(S) {
                      return e.PREDEFINED_VARS[S] || S;
                    }), r.replace(/[ _]+/g, "_");
                  }
                }, {
                  key: "variable",
                  value: function(r, n) {
                    return new this(r).value(n);
                  }
                  /**
                   * @returns Expression a new expression with the predefined variable "width"
                   * @function Expression.width
                   */
                }, {
                  key: "width",
                  value: function() {
                    return new this("width");
                  }
                  /**
                   * @returns Expression a new expression with the predefined variable "height"
                   * @function Expression.height
                   */
                }, {
                  key: "height",
                  value: function() {
                    return new this("height");
                  }
                  /**
                   * @returns Expression a new expression with the predefined variable "initialWidth"
                   * @function Expression.initialWidth
                   */
                }, {
                  key: "initialWidth",
                  value: function() {
                    return new this("initialWidth");
                  }
                  /**
                   * @returns Expression a new expression with the predefined variable "initialHeight"
                   * @function Expression.initialHeight
                   */
                }, {
                  key: "initialHeight",
                  value: function() {
                    return new this("initialHeight");
                  }
                  /**
                   * @returns Expression a new expression with the predefined variable "aspectRatio"
                   * @function Expression.aspectRatio
                   */
                }, {
                  key: "aspectRatio",
                  value: function() {
                    return new this("aspectRatio");
                  }
                  /**
                   * @returns Expression a new expression with the predefined variable "initialAspectRatio"
                   * @function Expression.initialAspectRatio
                   */
                }, {
                  key: "initialAspectRatio",
                  value: function() {
                    return new this("initialAspectRatio");
                  }
                  /**
                   * @returns Expression a new expression with the predefined variable "pageCount"
                   * @function Expression.pageCount
                   */
                }, {
                  key: "pageCount",
                  value: function() {
                    return new this("pageCount");
                  }
                  /**
                   * @returns Expression new expression with the predefined variable "faceCount"
                   * @function Expression.faceCount
                   */
                }, {
                  key: "faceCount",
                  value: function() {
                    return new this("faceCount");
                  }
                  /**
                   * @returns Expression a new expression with the predefined variable "currentPage"
                   * @function Expression.currentPage
                   */
                }, {
                  key: "currentPage",
                  value: function() {
                    return new this("currentPage");
                  }
                  /**
                   * @returns Expression a new expression with the predefined variable "tags"
                   * @function Expression.tags
                   */
                }, {
                  key: "tags",
                  value: function() {
                    return new this("tags");
                  }
                  /**
                   * @returns Expression a new expression with the predefined variable "pageX"
                   * @function Expression.pageX
                   */
                }, {
                  key: "pageX",
                  value: function() {
                    return new this("pageX");
                  }
                  /**
                   * @returns Expression a new expression with the predefined variable "pageY"
                   * @function Expression.pageY
                   */
                }, {
                  key: "pageY",
                  value: function() {
                    return new this("pageY");
                  }
                }]);
              }();
              qe.OPERATORS = {
                "=": "eq",
                "!=": "ne",
                "<": "lt",
                ">": "gt",
                "<=": "lte",
                ">=": "gte",
                "&&": "and",
                "||": "or",
                "*": "mul",
                "/": "div",
                "+": "add",
                "-": "sub",
                "^": "pow"
              }, qe.PREDEFINED_VARS = {
                aspect_ratio: "ar",
                aspectRatio: "ar",
                current_page: "cp",
                currentPage: "cp",
                duration: "du",
                face_count: "fc",
                faceCount: "fc",
                height: "h",
                initial_aspect_ratio: "iar",
                initial_duration: "idu",
                initial_height: "ih",
                initial_width: "iw",
                initialAspectRatio: "iar",
                initialDuration: "idu",
                initialHeight: "ih",
                initialWidth: "iw",
                page_count: "pc",
                page_x: "px",
                page_y: "py",
                pageCount: "pc",
                pageX: "px",
                pageY: "py",
                tags: "tags",
                width: "w"
              }, qe.BOUNDRY = "[ _]+";
              var Y = qe;
              function Bt(e) {
                "@babel/helpers - typeof";
                return Bt = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
                  return typeof t;
                } : function(t) {
                  return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                }, Bt(e);
              }
              function Kl(e, t) {
                if (!(e instanceof t))
                  throw new TypeError("Cannot call a class as a function");
              }
              function Gl(e, t) {
                for (var r = 0; r < t.length; r++) {
                  var n = t[r];
                  n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Wl(n.key), n);
                }
              }
              function $l(e, t, r) {
                return t && Gl(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
              }
              function Wl(e) {
                var t = Yl(e, "string");
                return Bt(t) == "symbol" ? t : t + "";
              }
              function Yl(e, t) {
                if (Bt(e) != "object" || !e) return e;
                var r = e[Symbol.toPrimitive];
                if (r !== void 0) {
                  var n = r.call(e, t);
                  if (Bt(n) != "object") return n;
                  throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return String(e);
              }
              function Ql(e, t, r) {
                return t = Le(t), Jl(e, uu() ? Reflect.construct(t, r || [], Le(e).constructor) : t.apply(e, r));
              }
              function Jl(e, t) {
                if (t && (Bt(t) === "object" || typeof t == "function"))
                  return t;
                if (t !== void 0)
                  throw new TypeError("Derived constructors may only return object or undefined");
                return Xl(e);
              }
              function Xl(e) {
                if (e === void 0)
                  throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return e;
              }
              function uu() {
                try {
                  var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
                  }));
                } catch {
                }
                return (uu = function() {
                  return !!e;
                })();
              }
              function Le(e) {
                return Le = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
                  return r.__proto__ || Object.getPrototypeOf(r);
                }, Le(e);
              }
              function Zl(e, t) {
                if (typeof t != "function" && t !== null)
                  throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && qr(e, t);
              }
              function qr(e, t) {
                return qr = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, o) {
                  return n.__proto__ = o, n;
                }, qr(e, t);
              }
              var th = /* @__PURE__ */ function(e) {
                function t(r) {
                  return Kl(this, t), Ql(this, t, [r]);
                }
                return Zl(t, e), $l(t, [{
                  key: "height",
                  value: function(n, o) {
                    return this.predicate("h", n, o);
                  }
                  /**
                   * @function Condition#width
                   * @param {string} operator the comparison operator (e.g. "<", "lt")
                   * @param {string|number} value the right hand side value
                   * @return {Condition} this condition
                   */
                }, {
                  key: "width",
                  value: function(n, o) {
                    return this.predicate("w", n, o);
                  }
                  /**
                   * @function Condition#aspectRatio
                   * @param {string} operator the comparison operator (e.g. "<", "lt")
                   * @param {string|number} value the right hand side value
                   * @return {Condition} this condition
                   */
                }, {
                  key: "aspectRatio",
                  value: function(n, o) {
                    return this.predicate("ar", n, o);
                  }
                  /**
                   * @function Condition#pages
                   * @param {string} operator the comparison operator (e.g. "<", "lt")
                   * @param {string|number} value the right hand side value
                   * @return {Condition} this condition
                   */
                }, {
                  key: "pageCount",
                  value: function(n, o) {
                    return this.predicate("pc", n, o);
                  }
                  /**
                   * @function Condition#faces
                   * @param {string} operator the comparison operator (e.g. "<", "lt")
                   * @param {string|number} value the right hand side value
                   * @return {Condition} this condition
                   */
                }, {
                  key: "faceCount",
                  value: function(n, o) {
                    return this.predicate("fc", n, o);
                  }
                  /**
                   * @function Condition#duration
                   * @param {string} operator the comparison operator (e.g. "<", "lt")
                   * @param {string|number} value the right hand side value
                   * @return {Condition} this condition
                   */
                }, {
                  key: "duration",
                  value: function(n, o) {
                    return this.predicate("du", n, o);
                  }
                  /**
                   * @function Condition#initialDuration
                   * @param {string} operator the comparison operator (e.g. "<", "lt")
                   * @param {string|number} value the right hand side value
                   * @return {Condition} this condition
                   */
                }, {
                  key: "initialDuration",
                  value: function(n, o) {
                    return this.predicate("idu", n, o);
                  }
                }]);
              }(Y), Me = th;
              function ce(e) {
                "@babel/helpers - typeof";
                return ce = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
                  return typeof t;
                } : function(t) {
                  return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                }, ce(e);
              }
              function eh(e, t) {
                return ah(e) || ih(e, t) || nh(e, t) || rh();
              }
              function rh() {
                throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
              }
              function nh(e, t) {
                if (e) {
                  if (typeof e == "string") return su(e, t);
                  var r = Object.prototype.toString.call(e).slice(8, -1);
                  if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
                  if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return su(e, t);
                }
              }
              function su(e, t) {
                (t == null || t > e.length) && (t = e.length);
                for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
                return n;
              }
              function ih(e, t) {
                var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
                if (r != null) {
                  var n, o, f, h, g = [], v = !0, S = !1;
                  try {
                    if (f = (r = r.call(e)).next, t !== 0) for (; !(v = (n = f.call(r)).done) && (g.push(n.value), g.length !== t); v = !0) ;
                  } catch (T) {
                    S = !0, o = T;
                  } finally {
                    try {
                      if (!v && r.return != null && (h = r.return(), Object(h) !== h)) return;
                    } finally {
                      if (S) throw o;
                    }
                  }
                  return g;
                }
              }
              function ah(e) {
                if (Array.isArray(e)) return e;
              }
              function oh(e, t) {
                if (!(e instanceof t))
                  throw new TypeError("Cannot call a class as a function");
              }
              function uh(e, t) {
                for (var r = 0; r < t.length; r++) {
                  var n = t[r];
                  n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, ch(n.key), n);
                }
              }
              function sh(e, t, r) {
                return t && uh(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
              }
              function ch(e) {
                var t = fh(e, "string");
                return ce(t) == "symbol" ? t : t + "";
              }
              function fh(e, t) {
                if (ce(e) != "object" || !e) return e;
                var r = e[Symbol.toPrimitive];
                if (r !== void 0) {
                  var n = r.call(e, t);
                  if (ce(n) != "object") return n;
                  throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return String(e);
              }
              var cu = /* @__PURE__ */ function() {
                function e(t) {
                  oh(this, e), this.configuration = t == null ? {} : ft()(t), dt(this.configuration, lh);
                }
                return sh(e, [{
                  key: "init",
                  value: function() {
                    return this.fromEnvironment(), this.fromDocument(), this;
                  }
                  /**
                   * Set a new configuration item
                   * @function Configuration#set
                   * @param {string} name - the name of the item to set
                   * @param {*} value - the value to be set
                   * @return {Configuration}
                   *
                   */
                }, {
                  key: "set",
                  value: function(r, n) {
                    return this.configuration[r] = n, this;
                  }
                  /**
                   * Get the value of a configuration item
                   * @function Configuration#get
                   * @param {string} name - the name of the item to set
                   * @return {*} the configuration item
                   */
                }, {
                  key: "get",
                  value: function(r) {
                    return this.configuration[r];
                  }
                }, {
                  key: "merge",
                  value: function(r) {
                    return Q()(this.configuration, ft()(r)), this;
                  }
                  /**
                   * Initialize Cloudinary from HTML meta tags.
                   * @function Configuration#fromDocument
                   * @return {Configuration}
                   * @example <meta name="cloudinary_cloud_name" content="mycloud">
                   *
                   */
                }, {
                  key: "fromDocument",
                  value: function() {
                    var r, n, o, f;
                    if (f = typeof document < "u" && document !== null ? document.querySelectorAll('meta[name^="cloudinary_"]') : void 0, f)
                      for (n = 0, o = f.length; n < o; n++)
                        r = f[n], this.configuration[r.getAttribute("name").replace("cloudinary_", "")] = r.getAttribute("content");
                    return this;
                  }
                  /**
                   * Initialize Cloudinary from the `CLOUDINARY_URL` environment variable.
                   *
                   * This function will only run under Node.js environment.
                   * @function Configuration#fromEnvironment
                   * @requires Node.js
                   */
                }, {
                  key: "fromEnvironment",
                  value: function() {
                    var r = this, n, o, f, h;
                    return typeof process < "u" && process !== null && process.env && process.env.CLOUDINARY_URL && (n = process.env.CLOUDINARY_URL, h = /cloudinary:\/\/(?:(\w+)(?:\:([\w-]+))?@)?([\w\.-]+)(?:\/([^?]*))?(?:\?(.+))?/, f = h.exec(n), f && (f[3] != null && (this.configuration.cloud_name = f[3]), f[1] != null && (this.configuration.api_key = f[1]), f[2] != null && (this.configuration.api_secret = f[2]), f[4] != null && (this.configuration.private_cdn = f[4] != null), f[4] != null && (this.configuration.secure_distribution = f[4]), o = f[5], o != null && o.split("&").forEach(function(g) {
                      var v = g.split("="), S = eh(v, 2), T = S[0], E = S[1];
                      E == null && (E = !0), r.configuration[T] = E;
                    }))), this;
                  }
                  /**
                   * Create or modify the Cloudinary client configuration
                   *
                   * Warning: `config()` returns the actual internal configuration object. modifying it will change the configuration.
                   *
                   * This is a backward compatibility method. For new code, use get(), merge() etc.
                   * @function Configuration#config
                   * @param {hash|string|boolean} new_config
                   * @param {string} new_value
                   * @returns {*} configuration, or value
                   *
                   * @see {@link fromEnvironment} for initialization using environment variables
                   * @see {@link fromDocument} for initialization using HTML meta tags
                   */
                }, {
                  key: "config",
                  value: function(r, n) {
                    switch (!1) {
                      case n === void 0:
                        return this.set(r, n), this.configuration;
                      case !G()(r):
                        return this.get(r);
                      case !K()(r):
                        return this.merge(r), this.configuration;
                      default:
                        return this.configuration;
                    }
                  }
                  /**
                   * Returns a copy of the configuration parameters
                   * @function Configuration#toOptions
                   * @returns {Object} a key:value collection of the configuration parameters
                   */
                }, {
                  key: "toOptions",
                  value: function() {
                    return ft()(this.configuration);
                  }
                }]);
              }(), lh = {
                responsive_class: "cld-responsive",
                responsive_use_breakpoints: !0,
                round_dpr: !0,
                secure: (typeof window < "u" && window !== null && window.location ? window.location.protocol : void 0) === "https:"
              };
              cu.CONFIG_PARAMS = ["api_key", "api_secret", "callback", "cdn_subdomain", "cloud_name", "cname", "private_cdn", "protocol", "resource_type", "responsive", "responsive_class", "responsive_use_breakpoints", "responsive_width", "round_dpr", "secure", "secure_cdn_subdomain", "secure_distribution", "shorten", "type", "upload_preset", "url_suffix", "use_root_path", "version", "externalLibraries", "max_timeout_ms"];
              var Ve = cu;
              function fe(e) {
                "@babel/helpers - typeof";
                return fe = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
                  return typeof t;
                } : function(t) {
                  return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                }, fe(e);
              }
              function hh(e, t) {
                if (!(e instanceof t))
                  throw new TypeError("Cannot call a class as a function");
              }
              function dh(e, t) {
                for (var r = 0; r < t.length; r++) {
                  var n = t[r];
                  n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, ph(n.key), n);
                }
              }
              function yh(e, t, r) {
                return t && dh(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
              }
              function ph(e) {
                var t = vh(e, "string");
                return fe(t) == "symbol" ? t : t + "";
              }
              function vh(e, t) {
                if (fe(e) != "object" || !e) return e;
                var r = e[Symbol.toPrimitive];
                if (r !== void 0) {
                  var n = r.call(e, t);
                  if (fe(n) != "object") return n;
                  throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return String(e);
              }
              var gh = /* @__PURE__ */ function() {
                function e(t) {
                  var r = this;
                  hh(this, e), this.options = {}, t != null && ["resourceType", "type", "publicId", "format"].forEach(function(n) {
                    var o;
                    return r.options[n] = (o = t[n]) != null ? o : t[Ct(n)];
                  });
                }
                return yh(e, [{
                  key: "resourceType",
                  value: function(r) {
                    return this.options.resourceType = r, this;
                  }
                }, {
                  key: "type",
                  value: function(r) {
                    return this.options.type = r, this;
                  }
                }, {
                  key: "publicId",
                  value: function(r) {
                    return this.options.publicId = r, this;
                  }
                  /**
                   * Get the public ID, formatted for layer parameter
                   * @function Layer#getPublicId
                   * @return {String} public ID
                   */
                }, {
                  key: "getPublicId",
                  value: function() {
                    var r;
                    return (r = this.options.publicId) != null ? r.replace(/\//g, ":") : void 0;
                  }
                  /**
                   * Get the public ID, with format if present
                   * @function Layer#getFullPublicId
                   * @return {String} public ID
                   */
                }, {
                  key: "getFullPublicId",
                  value: function() {
                    return this.options.format != null ? this.getPublicId() + "." + this.options.format : this.getPublicId();
                  }
                }, {
                  key: "format",
                  value: function(r) {
                    return this.options.format = r, this;
                  }
                  /**
                   * generate the string representation of the layer
                   * @function Layer#toString
                   */
                }, {
                  key: "toString",
                  value: function() {
                    var r;
                    if (r = [], this.options.publicId == null)
                      throw "Must supply publicId";
                    return this.options.resourceType !== "image" && r.push(this.options.resourceType), this.options.type !== "upload" && r.push(this.options.type), r.push(this.getFullPublicId()), it()(r).join(":");
                  }
                }, {
                  key: "clone",
                  value: function() {
                    return new this.constructor(this.options);
                  }
                }]);
              }(), kt = gh;
              function qt(e) {
                "@babel/helpers - typeof";
                return qt = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
                  return typeof t;
                } : function(t) {
                  return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                }, qt(e);
              }
              function mh(e, t) {
                if (!(e instanceof t))
                  throw new TypeError("Cannot call a class as a function");
              }
              function bh(e, t) {
                for (var r = 0; r < t.length; r++) {
                  var n = t[r];
                  n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Sh(n.key), n);
                }
              }
              function _h(e, t, r) {
                return t && bh(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
              }
              function Sh(e) {
                var t = Ah(e, "string");
                return qt(t) == "symbol" ? t : t + "";
              }
              function Ah(e, t) {
                if (qt(e) != "object" || !e) return e;
                var r = e[Symbol.toPrimitive];
                if (r !== void 0) {
                  var n = r.call(e, t);
                  if (qt(n) != "object") return n;
                  throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return String(e);
              }
              function Oh(e, t, r) {
                return t = Ne(t), Th(e, fu() ? Reflect.construct(t, r || [], Ne(e).constructor) : t.apply(e, r));
              }
              function Th(e, t) {
                if (t && (qt(t) === "object" || typeof t == "function"))
                  return t;
                if (t !== void 0)
                  throw new TypeError("Derived constructors may only return object or undefined");
                return wh(e);
              }
              function wh(e) {
                if (e === void 0)
                  throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return e;
              }
              function fu() {
                try {
                  var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
                  }));
                } catch {
                }
                return (fu = function() {
                  return !!e;
                })();
              }
              function Ne(e) {
                return Ne = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
                  return r.__proto__ || Object.getPrototypeOf(r);
                }, Ne(e);
              }
              function Ph(e, t) {
                if (typeof t != "function" && t !== null)
                  throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Lr(e, t);
              }
              function Lr(e, t) {
                return Lr = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, o) {
                  return n.__proto__ = o, n;
                }, Lr(e, t);
              }
              var Ch = /* @__PURE__ */ function(e) {
                function t(r) {
                  var n;
                  mh(this, t);
                  var o;
                  return n = Oh(this, t, [r]), o = ["resourceType", "resourceType", "fontFamily", "fontSize", "fontWeight", "fontStyle", "textDecoration", "textAlign", "stroke", "letterSpacing", "lineSpacing", "fontHinting", "fontAntialiasing", "text", "textStyle"], r != null && o.forEach(function(f) {
                    var h;
                    return n.options[f] = (h = r[f]) != null ? h : r[Ct(f)];
                  }), n.options.resourceType = "text", n;
                }
                return Ph(t, e), _h(t, [{
                  key: "resourceType",
                  value: function(n) {
                    throw "Cannot modify resourceType for text layers";
                  }
                }, {
                  key: "type",
                  value: function(n) {
                    throw "Cannot modify type for text layers";
                  }
                }, {
                  key: "format",
                  value: function(n) {
                    throw "Cannot modify format for text layers";
                  }
                }, {
                  key: "fontFamily",
                  value: function(n) {
                    return this.options.fontFamily = n, this;
                  }
                }, {
                  key: "fontSize",
                  value: function(n) {
                    return this.options.fontSize = n, this;
                  }
                }, {
                  key: "fontWeight",
                  value: function(n) {
                    return this.options.fontWeight = n, this;
                  }
                }, {
                  key: "fontStyle",
                  value: function(n) {
                    return this.options.fontStyle = n, this;
                  }
                }, {
                  key: "textDecoration",
                  value: function(n) {
                    return this.options.textDecoration = n, this;
                  }
                }, {
                  key: "textAlign",
                  value: function(n) {
                    return this.options.textAlign = n, this;
                  }
                }, {
                  key: "stroke",
                  value: function(n) {
                    return this.options.stroke = n, this;
                  }
                }, {
                  key: "letterSpacing",
                  value: function(n) {
                    return this.options.letterSpacing = n, this;
                  }
                }, {
                  key: "lineSpacing",
                  value: function(n) {
                    return this.options.lineSpacing = n, this;
                  }
                }, {
                  key: "fontHinting",
                  value: function(n) {
                    return this.options.fontHinting = n, this;
                  }
                }, {
                  key: "fontAntialiasing",
                  value: function(n) {
                    return this.options.fontAntialiasing = n, this;
                  }
                }, {
                  key: "text",
                  value: function(n) {
                    return this.options.text = n, this;
                  }
                }, {
                  key: "textStyle",
                  value: function(n) {
                    return this.options.textStyle = n, this;
                  }
                  /**
                   * generate the string representation of the layer
                   * @function TextLayer#toString
                   * @return {String}
                   */
                }, {
                  key: "toString",
                  value: function() {
                    var n, o, f, h, g, v, S, T, E, D;
                    if (T = this.textStyleIdentifier(), this.options.publicId != null && (h = this.getFullPublicId()), this.options.text != null) {
                      if (o = !x(h), f = !x(T), o && f || !o && !f)
                        throw "Must supply either style parameters or a public_id when providing text parameter in a text overlay/underlay, but not both!";
                      for (g = /\$\([a-zA-Z]\w*\)/g, S = 0, D = Ie(this.options.text, /[,\/]/g), E = ""; v = g.exec(D); )
                        E += Ie(D.slice(S, v.index)), E += v[0], S = v.index + v[0].length;
                      E += Ie(D.slice(S));
                    }
                    return n = [this.options.resourceType, T, h, E], it()(n).join(":");
                  }
                }, {
                  key: "textStyleIdentifier",
                  value: function() {
                    if (!x(this.options.textStyle))
                      return this.options.textStyle;
                    var n;
                    if (n = [], this.options.fontWeight !== "normal" && n.push(this.options.fontWeight), this.options.fontStyle !== "normal" && n.push(this.options.fontStyle), this.options.textDecoration !== "none" && n.push(this.options.textDecoration), n.push(this.options.textAlign), this.options.stroke !== "none" && n.push(this.options.stroke), x(this.options.letterSpacing) && !xe(this.options.letterSpacing) || n.push("letter_spacing_" + this.options.letterSpacing), x(this.options.lineSpacing) && !xe(this.options.lineSpacing) || n.push("line_spacing_" + this.options.lineSpacing), x(this.options.fontAntialiasing) || n.push("antialias_" + this.options.fontAntialiasing), x(this.options.fontHinting) || n.push("hinting_" + this.options.fontHinting), !x(it()(n))) {
                      if (x(this.options.fontFamily))
                        throw "Must supply fontFamily. ".concat(n);
                      if (x(this.options.fontSize) && !xe(this.options.fontSize))
                        throw "Must supply fontSize.";
                    }
                    return n.unshift(this.options.fontFamily, this.options.fontSize), n = it()(n).join("_"), n;
                  }
                }]);
              }(kt), le = Ch;
              function Mr(e) {
                "@babel/helpers - typeof";
                return Mr = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
                  return typeof t;
                } : function(t) {
                  return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                }, Mr(e);
              }
              function Eh(e, t, r) {
                return Object.defineProperty(e, "prototype", { writable: !1 }), e;
              }
              function Rh(e, t) {
                if (!(e instanceof t))
                  throw new TypeError("Cannot call a class as a function");
              }
              function jh(e, t, r) {
                return t = Ue(t), Dh(e, lu() ? Reflect.construct(t, r || [], Ue(e).constructor) : t.apply(e, r));
              }
              function Dh(e, t) {
                if (t && (Mr(t) === "object" || typeof t == "function"))
                  return t;
                if (t !== void 0)
                  throw new TypeError("Derived constructors may only return object or undefined");
                return xh(e);
              }
              function xh(e) {
                if (e === void 0)
                  throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return e;
              }
              function lu() {
                try {
                  var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
                  }));
                } catch {
                }
                return (lu = function() {
                  return !!e;
                })();
              }
              function Ue(e) {
                return Ue = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
                  return r.__proto__ || Object.getPrototypeOf(r);
                }, Ue(e);
              }
              function Ih(e, t) {
                if (typeof t != "function" && t !== null)
                  throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Vr(e, t);
              }
              function Vr(e, t) {
                return Vr = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, o) {
                  return n.__proto__ = o, n;
                }, Vr(e, t);
              }
              var Fh = /* @__PURE__ */ function(e) {
                function t(r) {
                  var n;
                  return Rh(this, t), n = jh(this, t, [r]), n.options.resourceType = "subtitles", n;
                }
                return Ih(t, e), Eh(t);
              }(le), Nr = Fh;
              function Lt(e) {
                "@babel/helpers - typeof";
                return Lt = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
                  return typeof t;
                } : function(t) {
                  return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                }, Lt(e);
              }
              function Bh(e, t) {
                if (!(e instanceof t))
                  throw new TypeError("Cannot call a class as a function");
              }
              function kh(e, t) {
                for (var r = 0; r < t.length; r++) {
                  var n = t[r];
                  n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Lh(n.key), n);
                }
              }
              function qh(e, t, r) {
                return t && kh(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
              }
              function Lh(e) {
                var t = Mh(e, "string");
                return Lt(t) == "symbol" ? t : t + "";
              }
              function Mh(e, t) {
                if (Lt(e) != "object" || !e) return e;
                var r = e[Symbol.toPrimitive];
                if (r !== void 0) {
                  var n = r.call(e, t);
                  if (Lt(n) != "object") return n;
                  throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return String(e);
              }
              function Vh(e, t, r) {
                return t = ze(t), Nh(e, hu() ? Reflect.construct(t, r || [], ze(e).constructor) : t.apply(e, r));
              }
              function Nh(e, t) {
                if (t && (Lt(t) === "object" || typeof t == "function"))
                  return t;
                if (t !== void 0)
                  throw new TypeError("Derived constructors may only return object or undefined");
                return Uh(e);
              }
              function Uh(e) {
                if (e === void 0)
                  throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return e;
              }
              function hu() {
                try {
                  var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
                  }));
                } catch {
                }
                return (hu = function() {
                  return !!e;
                })();
              }
              function ze(e) {
                return ze = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
                  return r.__proto__ || Object.getPrototypeOf(r);
                }, ze(e);
              }
              function zh(e, t) {
                if (typeof t != "function" && t !== null)
                  throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Ur(e, t);
              }
              function Ur(e, t) {
                return Ur = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, o) {
                  return n.__proto__ = o, n;
                }, Ur(e, t);
              }
              var Hh = /* @__PURE__ */ function(e) {
                function t(r) {
                  var n;
                  return Bh(this, t), n = Vh(this, t, [r]), G()(r) ? n.options.url = r : r != null && r.url && (n.options.url = r.url), n;
                }
                return zh(t, e), qh(t, [{
                  key: "url",
                  value: function(n) {
                    return this.options.url = n, this;
                  }
                  /**
                   * generate the string representation of the layer
                   * @function FetchLayer#toString
                   * @return {String}
                   */
                }, {
                  key: "toString",
                  value: function() {
                    return "fetch:".concat(Go(this.options.url));
                  }
                }]);
              }(kt), He = Hh;
              function he(e, t, r) {
                return t = yt(t), Kh(e, du() ? Reflect.construct(t, r || [], yt(e).constructor) : t.apply(e, r));
              }
              function Kh(e, t) {
                if (t && (Mt(t) === "object" || typeof t == "function"))
                  return t;
                if (t !== void 0)
                  throw new TypeError("Derived constructors may only return object or undefined");
                return Gh(e);
              }
              function Gh(e) {
                if (e === void 0)
                  throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return e;
              }
              function du() {
                try {
                  var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
                  }));
                } catch {
                }
                return (du = function() {
                  return !!e;
                })();
              }
              function Rt() {
                return typeof Reflect < "u" && Reflect.get ? Rt = Reflect.get.bind() : Rt = function(t, r, n) {
                  var o = $h(t, r);
                  if (o) {
                    var f = Object.getOwnPropertyDescriptor(o, r);
                    return f.get ? f.get.call(arguments.length < 3 ? t : n) : f.value;
                  }
                }, Rt.apply(this, arguments);
              }
              function $h(e, t) {
                for (; !Object.prototype.hasOwnProperty.call(e, t) && (e = yt(e), e !== null); )
                  ;
                return e;
              }
              function yt(e) {
                return yt = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
                  return r.__proto__ || Object.getPrototypeOf(r);
                }, yt(e);
              }
              function de(e, t) {
                if (typeof t != "function" && t !== null)
                  throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && zr(e, t);
              }
              function zr(e, t) {
                return zr = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, o) {
                  return n.__proto__ = o, n;
                }, zr(e, t);
              }
              function Mt(e) {
                "@babel/helpers - typeof";
                return Mt = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
                  return typeof t;
                } : function(t) {
                  return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                }, Mt(e);
              }
              function Vt(e, t) {
                if (!(e instanceof t))
                  throw new TypeError("Cannot call a class as a function");
              }
              function yu(e, t) {
                for (var r = 0; r < t.length; r++) {
                  var n = t[r];
                  n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Wh(n.key), n);
                }
              }
              function Nt(e, t, r) {
                return t && yu(e.prototype, t), r && yu(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
              }
              function Wh(e) {
                var t = Yh(e, "string");
                return Mt(t) == "symbol" ? t : t + "";
              }
              function Yh(e, t) {
                if (Mt(e) != "object" || !e) return e;
                var r = e[Symbol.toPrimitive];
                if (r !== void 0) {
                  var n = r.call(e, t);
                  if (Mt(n) != "object") return n;
                  throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return String(e);
              }
              var ot = /* @__PURE__ */ function() {
                function e(t, r) {
                  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : lt.a;
                  Vt(this, e), this.name = t, this.shortName = r, this.process = n;
                }
                return Nt(e, [{
                  key: "set",
                  value: function(r) {
                    return this.origValue = r, this;
                  }
                  /**
                   * Generate the serialized form of the parameter
                   * @function Param#serialize
                   * @return {string} the serialized form of the parameter
                   */
                }, {
                  key: "serialize",
                  value: function() {
                    var r, n;
                    return r = this.value(), n = H()(r) || K()(r) || G()(r) ? !x(r) : r != null, this.shortName != null && n ? "".concat(this.shortName, "_").concat(r) : "";
                  }
                  /**
                   * Return the processed value of the parameter
                   * @function Param#value
                   */
                }, {
                  key: "value",
                  value: function() {
                    return this.process(this.origValue);
                  }
                }], [{
                  key: "norm_color",
                  value: function(r) {
                    return r != null ? r.replace(/^#/, "rgb:") : void 0;
                  }
                }, {
                  key: "build_array",
                  value: function(r) {
                    return r == null ? [] : H()(r) ? r : [r];
                  }
                  /**
                  * Covert value to video codec string.
                  *
                  * If the parameter is an object,
                  * @param {(string|Object)} param - the video codec as either a String or a Hash
                  * @return {string} the video codec string in the format codec:profile:level:b_frames
                  * @example
                  * vc_[ :profile : [level : [b_frames]]]
                  * or
                    { codec: 'h264', profile: 'basic', level: '3.1', b_frames: false }
                  * @ignore
                   */
                }, {
                  key: "process_video_params",
                  value: function(r) {
                    var n;
                    switch (r.constructor) {
                      case Object:
                        return n = "", "codec" in r && (n = r.codec, "profile" in r && (n += ":" + r.profile, "level" in r && (n += ":" + r.level, "b_frames" in r && r.b_frames === !1 && (n += ":bframes_no")))), n;
                      case String:
                        return r;
                      default:
                        return null;
                    }
                  }
                }]);
              }(), Qh = /* @__PURE__ */ function(e) {
                function t(r, n) {
                  var o, f = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ".", h = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : void 0;
                  return Vt(this, t), o = he(this, t, [r, n, h]), o.sep = f, o;
                }
                return de(t, e), Nt(t, [{
                  key: "serialize",
                  value: function() {
                    if (this.shortName != null) {
                      var n = this.value();
                      if (x(n))
                        return "";
                      if (G()(n))
                        return "".concat(this.shortName, "_").concat(n);
                      var o = n.map(function(f) {
                        return L()(f.serialize) ? f.serialize() : f;
                      }).join(this.sep);
                      return "".concat(this.shortName, "_").concat(o);
                    } else
                      return "";
                  }
                }, {
                  key: "value",
                  value: function() {
                    var n = this;
                    return H()(this.origValue) ? this.origValue.map(function(o) {
                      return n.process(o);
                    }) : this.process(this.origValue);
                  }
                }, {
                  key: "set",
                  value: function(n) {
                    return n == null || H()(n) ? Rt(yt(t.prototype), "set", this).call(this, n) : Rt(yt(t.prototype), "set", this).call(this, [n]);
                  }
                }]);
              }(ot), Jh = /* @__PURE__ */ function(e) {
                function t(r) {
                  var n, o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "t", f = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ".", h = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : void 0;
                  return Vt(this, t), n = he(this, t, [r, o, h]), n.sep = f, n;
                }
                return de(t, e), Nt(t, [{
                  key: "serialize",
                  value: function() {
                    var n = this, o = "", f = this.value();
                    if (x(f))
                      return o;
                    if (Lo(f)) {
                      var h = f.join(this.sep);
                      x(h) || (o = "".concat(this.shortName, "_").concat(h));
                    } else
                      o = f.map(function(g) {
                        if (G()(g) && !x(g))
                          return "".concat(n.shortName, "_").concat(g);
                        if (L()(g.serialize))
                          return g.serialize();
                        if (K()(g) && !x(g))
                          return new nt(g).serialize();
                      }).filter(function(g) {
                        return g;
                      });
                    return o;
                  }
                }, {
                  key: "set",
                  value: function(n) {
                    return this.origValue = n, H()(this.origValue) ? Rt(yt(t.prototype), "set", this).call(this, this.origValue) : Rt(yt(t.prototype), "set", this).call(this, [this.origValue]);
                  }
                }]);
              }(ot), Xh = "([0-9]*)\\.([0-9]+)|([0-9]+)", Zh = "(" + Xh + ")([%pP])?", td = /* @__PURE__ */ function(e) {
                function t(r, n) {
                  var o = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : t.norm_range_value;
                  return Vt(this, t), he(this, t, [r, n, o]);
                }
                return de(t, e), Nt(t, null, [{
                  key: "norm_range_value",
                  value: function(n) {
                    var o = String(n).match(new RegExp("^" + Zh + "$"));
                    if (o) {
                      var f = o[5] != null ? "p" : "";
                      n = (o[1] || o[4]) + f;
                    }
                    return Y.normalize(n);
                  }
                }]);
              }(ot), ed = /* @__PURE__ */ function(e) {
                function t(r, n) {
                  var o = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : lt.a;
                  return Vt(this, t), he(this, t, [r, n, o]);
                }
                return de(t, e), Nt(t, [{
                  key: "serialize",
                  value: function() {
                    return this.value();
                  }
                }]);
              }(ot), rd = /* @__PURE__ */ function(e) {
                function t() {
                  return Vt(this, t), he(this, t, arguments);
                }
                return de(t, e), Nt(t, [{
                  key: "value",
                  value: (
                    // Parse layer options
                    // @return [string] layer transformation string
                    // @private
                    function() {
                      if (this.origValue == null)
                        return "";
                      var n;
                      if (this.origValue instanceof kt)
                        n = this.origValue;
                      else if (K()(this.origValue)) {
                        var o = Ho(this.origValue);
                        o.resourceType === "text" || o.text != null ? n = new le(o) : o.resourceType === "subtitles" ? n = new Nr(o) : o.resourceType === "fetch" || o.url != null ? n = new He(o) : n = new kt(o);
                      } else G()(this.origValue) ? /^fetch:.+/.test(this.origValue) ? n = new He(this.origValue.substr(6)) : n = this.origValue : n = "";
                      return n.toString();
                    }
                  )
                }], [{
                  key: "textStyle",
                  value: function(n) {
                    return new le(n).textStyleIdentifier();
                  }
                }]);
              }(ot);
              function nd(e, t, r) {
                return t = Ke(t), id(e, pu() ? Reflect.construct(t, r || [], Ke(e).constructor) : t.apply(e, r));
              }
              function id(e, t) {
                if (t && (Ut(t) === "object" || typeof t == "function"))
                  return t;
                if (t !== void 0)
                  throw new TypeError("Derived constructors may only return object or undefined");
                return ad(e);
              }
              function ad(e) {
                if (e === void 0)
                  throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return e;
              }
              function pu() {
                try {
                  var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
                  }));
                } catch {
                }
                return (pu = function() {
                  return !!e;
                })();
              }
              function Ke(e) {
                return Ke = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
                  return r.__proto__ || Object.getPrototypeOf(r);
                }, Ke(e);
              }
              function od(e, t) {
                if (typeof t != "function" && t !== null)
                  throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Hr(e, t);
              }
              function Hr(e, t) {
                return Hr = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, o) {
                  return n.__proto__ = o, n;
                }, Hr(e, t);
              }
              function Kr(e, t) {
                return fd(e) || cd(e, t) || sd(e, t) || ud();
              }
              function ud() {
                throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
              }
              function sd(e, t) {
                if (e) {
                  if (typeof e == "string") return vu(e, t);
                  var r = Object.prototype.toString.call(e).slice(8, -1);
                  if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
                  if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return vu(e, t);
                }
              }
              function vu(e, t) {
                (t == null || t > e.length) && (t = e.length);
                for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
                return n;
              }
              function cd(e, t) {
                var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
                if (r != null) {
                  var n, o, f, h, g = [], v = !0, S = !1;
                  try {
                    if (f = (r = r.call(e)).next, t !== 0) for (; !(v = (n = f.call(r)).done) && (g.push(n.value), g.length !== t); v = !0) ;
                  } catch (T) {
                    S = !0, o = T;
                  } finally {
                    try {
                      if (!v && r.return != null && (h = r.return(), Object(h) !== h)) return;
                    } finally {
                      if (S) throw o;
                    }
                  }
                  return g;
                }
              }
              function fd(e) {
                if (Array.isArray(e)) return e;
              }
              function Ut(e) {
                "@babel/helpers - typeof";
                return Ut = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
                  return typeof t;
                } : function(t) {
                  return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                }, Ut(e);
              }
              function gu(e, t) {
                if (!(e instanceof t))
                  throw new TypeError("Cannot call a class as a function");
              }
              function mu(e, t) {
                for (var r = 0; r < t.length; r++) {
                  var n = t[r];
                  n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, ld(n.key), n);
                }
              }
              function bu(e, t, r) {
                return t && mu(e.prototype, t), r && mu(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
              }
              function ld(e) {
                var t = hd(e, "string");
                return Ut(t) == "symbol" ? t : t + "";
              }
              function hd(e, t) {
                if (Ut(e) != "object" || !e) return e;
                var r = e[Symbol.toPrimitive];
                if (r !== void 0) {
                  var n = r.call(e, t);
                  if (Ut(n) != "object") return n;
                  throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return String(e);
              }
              function _u(e) {
                for (var t = arguments.length, r = new Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++)
                  r[n - 1] = arguments[n];
                return r.forEach(function(o) {
                  Object.keys(o).forEach(function(f) {
                    o[f] != null && (e[f] = o[f]);
                  });
                }), e;
              }
              var Gr = /* @__PURE__ */ function() {
                function e(t) {
                  gu(this, e);
                  var r, n;
                  r = void 0, n = {}, this.toOptions = function(o) {
                    var f = {};
                    if (o == null && (o = !0), Object.keys(n).forEach(function(g) {
                      return f[g] = n[g].origValue;
                    }), _u(f, this.otherOptions), o && !x(this.chained)) {
                      var h = this.chained.map(function(g) {
                        return g.toOptions();
                      });
                      h.push(f), f = {}, _u(f, this.otherOptions), f.transformation = h;
                    }
                    return f;
                  }, this.setParent = function(o) {
                    return r = o, o != null && this.fromOptions(typeof o.toOptions == "function" ? o.toOptions() : void 0), this;
                  }, this.getParent = function() {
                    return r;
                  }, this.param = function(o, f, h, g, v) {
                    return v == null && (L()(g) ? v = g : v = lt.a), n[f] = new ot(f, h, v).set(o), this;
                  }, this.rawParam = function(o, f, h, g, v) {
                    return v = Ge(arguments), n[f] = new ed(f, h, v).set(o), this;
                  }, this.rangeParam = function(o, f, h, g, v) {
                    return v = Ge(arguments), n[f] = new td(f, h, v).set(o), this;
                  }, this.arrayParam = function(o, f, h) {
                    var g = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : ":", v = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : void 0;
                    return v = Ge(arguments), n[f] = new Qh(f, h, g, v).set(o), this;
                  }, this.transformationParam = function(o, f, h) {
                    var g = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : ".", v = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : void 0;
                    return v = Ge(arguments), n[f] = new Jh(f, h, g, v).set(o), this;
                  }, this.layerParam = function(o, f, h) {
                    return n[f] = new rd(f, h).set(o), this;
                  }, this.getValue = function(o) {
                    var f = n[o] && n[o].value();
                    return f ?? this.otherOptions[o];
                  }, this.get = function(o) {
                    return n[o];
                  }, this.remove = function(o) {
                    var f;
                    switch (!1) {
                      case n[o] == null:
                        return f = n[o], delete n[o], f.origValue;
                      case this.otherOptions[o] == null:
                        return f = this.otherOptions[o], delete this.otherOptions[o], f;
                      default:
                        return null;
                    }
                  }, this.keys = function() {
                    var o;
                    return function() {
                      var f;
                      f = [];
                      for (o in n)
                        o != null && f.push(o.match($r) ? o : Ct(o));
                      return f;
                    }().sort();
                  }, this.toPlainObject = function() {
                    var o, f, h;
                    o = {};
                    for (f in n)
                      o[f] = n[f].value(), K()(o[f]) && (o[f] = ft()(o[f]));
                    return x(this.chained) || (h = this.chained.map(function(g) {
                      return g.toPlainObject();
                    }), h.push(o), o = {
                      transformation: h
                    }), o;
                  }, this.chain = function() {
                    var o, f;
                    return o = Object.getOwnPropertyNames(n), o.length !== 0 && (f = new this.constructor(this.toOptions(!1)), this.resetTransformations(), this.chained.push(f)), this;
                  }, this.resetTransformations = function() {
                    return n = {}, this;
                  }, this.otherOptions = {}, this.chained = [], this.fromOptions(t);
                }
                return bu(e, [{
                  key: "fromOptions",
                  value: function() {
                    var r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                    if (r instanceof e)
                      this.fromTransformation(r);
                    else {
                      (G()(r) || H()(r)) && (r = {
                        transformation: r
                      }), r = ft()(r, function(f) {
                        if (f instanceof e || f instanceof Layer)
                          return new f.clone();
                      }), r.if && (this.set("if", r.if), delete r.if);
                      for (var n in r) {
                        var o = r[n];
                        o != null && (n.match($r) ? n !== "$attr" && this.set("variable", n, o) : this.set(n, o));
                      }
                    }
                    return this;
                  }
                }, {
                  key: "fromTransformation",
                  value: function(r) {
                    var n = this;
                    return r instanceof e && r.keys().forEach(function(o) {
                      return n.set(o, r.get(o).origValue);
                    }), this;
                  }
                  /**
                   * Set a parameter.
                   * The parameter name `key` is converted to
                   * @param {string} key - the name of the parameter
                   * @param {*} values - the value of the parameter
                   * @returns {Transformation} Returns this instance for chaining
                   */
                }, {
                  key: "set",
                  value: function(r) {
                    var n;
                    n = oe(r);
                    for (var o = arguments.length, f = new Array(o > 1 ? o - 1 : 0), h = 1; h < o; h++)
                      f[h - 1] = arguments[h];
                    return Z()(St.methods, n) ? this[n].apply(this, f) : this.otherOptions[r] = f[0], this;
                  }
                }, {
                  key: "hasLayer",
                  value: function() {
                    return this.getValue("overlay") || this.getValue("underlay");
                  }
                  /**
                   * Generate a string representation of the transformation.
                   * @function Transformation#serialize
                   * @return {string} Returns the transformation as a string
                   */
                }, {
                  key: "serialize",
                  value: function() {
                    var r, n, o, f, h, g, v, S, T, E, D, M, vt, Ot, ut, Xt, Zt;
                    for (E = this.chained.map(function(gt) {
                      return gt.serialize();
                    }), f = this.keys(), Ot = (h = this.get("transformation")) != null ? h.serialize() : void 0, r = (g = this.get("if")) != null ? g.serialize() : void 0, Xt = dd((v = this.get("variables")) != null ? v.value() : void 0), f = Ee()(f, ["transformation", "if", "variables"]), Zt = [], M = [], n = 0, o = f.length; n < o; n++)
                      D = f[n], D.match($r) ? Zt.push(D + "_" + Y.normalize((S = this.get(D)) != null ? S.value() : void 0)) : M.push((T = this.get(D)) != null ? T.serialize() : void 0);
                    switch (!1) {
                      case !G()(Ot):
                        M.push(Ot);
                        break;
                      case !H()(Ot):
                        E = E.concat(Ot);
                    }
                    return M = function() {
                      var gt, te, an;
                      for (an = [], gt = 0, te = M.length; gt < te; gt++)
                        ut = M[gt], (H()(ut) && !x(ut) || !H()(ut) && ut) && an.push(ut);
                      return an;
                    }(), M = Zt.sort().concat(Xt).concat(M.sort()), r === "if_end" ? M.push(r) : x(r) || M.unshift(r), vt = it()(M).join(this.param_separator), x(vt) || E.push(vt), it()(E).join(this.trans_separator);
                  }
                  /**
                   * Provide a list of all the valid transformation option names
                   * @function Transformation#listNames
                   * @private
                   * @return {Array<string>} a array of all the valid option names
                   */
                }, {
                  key: "toHtmlAttributes",
                  value: (
                    /**
                     * Returns the attributes for an HTML tag.
                     * @function Cloudinary.toHtmlAttributes
                     * @return PlainObject
                     */
                    function() {
                      var r = this, n, o, f, h, g, v, S;
                      f = {};
                      var T;
                      return Object.keys(this.otherOptions).forEach(function(E) {
                        v = r.otherOptions[E], T = Ct(E), !Z()(St.PARAM_NAMES, T) && !Z()(jr, T) && (n = /^html_/.test(E) ? E.slice(5) : E, f[n] = v);
                      }), this.keys().forEach(function(E) {
                        /^html_/.test(E) && (f[oe(E.slice(5))] = r.getValue(E));
                      }), this.hasLayer() || this.getValue("angle") || Z()(["fit", "limit", "lfill"], this.getValue("crop")) || (S = (h = this.get("width")) != null ? h.origValue : void 0, o = (g = this.get("height")) != null ? g.origValue : void 0, parseFloat(S) >= 1 && f.width == null && (f.width = S), parseFloat(o) >= 1 && f.height == null && (f.height = o)), f;
                    }
                  )
                }, {
                  key: "toHtml",
                  value: (
                    /**
                     * Delegate to the parent (up the call chain) to produce HTML
                     * @function Transformation#toHtml
                     * @return {string} HTML representation of the parent if possible.
                     * @example
                     * tag = cloudinary.ImageTag.new("sample", {cloud_name: "demo"})
                     * // ImageTag {name: "img", publicId: "sample"}
                     * tag.toHtml()
                     * // <img src="http://res.cloudinary.com/demo/image/upload/sample">
                     * tag.transformation().crop("fit").width(300).toHtml()
                     * // <img src="http://res.cloudinary.com/demo/image/upload/c_fit,w_300/sample">
                     */
                    function() {
                      var r;
                      return (r = this.getParent()) != null && typeof r.toHtml == "function" ? r.toHtml() : void 0;
                    }
                  )
                }, {
                  key: "toString",
                  value: function() {
                    return this.serialize();
                  }
                }, {
                  key: "clone",
                  value: function() {
                    return new this.constructor(this.toOptions(!0));
                  }
                }], [{
                  key: "listNames",
                  value: function() {
                    return St.methods;
                  }
                }, {
                  key: "isValidParamName",
                  value: function(r) {
                    return St.methods.indexOf(oe(r)) >= 0;
                  }
                }]);
              }(), $r = /^\$[a-zA-Z0-9]+$/;
              Gr.prototype.trans_separator = "/", Gr.prototype.param_separator = ",";
              function Ge(e) {
                var t;
                if (t = e != null ? e[e.length - 1] : void 0, L()(t))
                  return t;
              }
              function dd(e) {
                var t, r, n, o, f;
                if (H()(e)) {
                  for (o = [], t = 0, r = e.length; t < r; t++) {
                    var h = Kr(e[t], 2);
                    n = h[0], f = h[1], o.push("".concat(n, "_").concat(Y.normalize(f)));
                  }
                  return o;
                } else
                  return e;
              }
              function Su(e) {
                var t = e.function_type, r = e.source;
                if (t === "remote")
                  return [t, btoa(r)].join(":");
                if (t === "wasm")
                  return [t, r].join(":");
              }
              var St = /* @__PURE__ */ function(e) {
                function t(r) {
                  return gu(this, t), nd(this, t, [r]);
                }
                return od(t, e), bu(t, [{
                  key: "angle",
                  value: (
                    /*
                      Transformation Parameters
                    */
                    function(n) {
                      return this.arrayParam(n, "angle", "a", ".", Y.normalize);
                    }
                  )
                }, {
                  key: "audioCodec",
                  value: function(n) {
                    return this.param(n, "audio_codec", "ac");
                  }
                }, {
                  key: "audioFrequency",
                  value: function(n) {
                    return this.param(n, "audio_frequency", "af");
                  }
                }, {
                  key: "aspectRatio",
                  value: function(n) {
                    return this.param(n, "aspect_ratio", "ar", Y.normalize);
                  }
                }, {
                  key: "background",
                  value: function(n) {
                    return this.param(n, "background", "b", ot.norm_color);
                  }
                }, {
                  key: "bitRate",
                  value: function(n) {
                    return this.param(n, "bit_rate", "br");
                  }
                }, {
                  key: "border",
                  value: function(n) {
                    return this.param(n, "border", "bo", function(o) {
                      return K()(o) ? (o = Q()({}, {
                        color: "black",
                        width: 2
                      }, o), "".concat(o.width, "px_solid_").concat(ot.norm_color(o.color))) : o;
                    });
                  }
                }, {
                  key: "color",
                  value: function(n) {
                    return this.param(n, "color", "co", ot.norm_color);
                  }
                }, {
                  key: "colorSpace",
                  value: function(n) {
                    return this.param(n, "color_space", "cs");
                  }
                }, {
                  key: "crop",
                  value: function(n) {
                    return this.param(n, "crop", "c");
                  }
                }, {
                  key: "customFunction",
                  value: function(n) {
                    return this.param(n, "custom_function", "fn", function() {
                      return Su(n);
                    });
                  }
                }, {
                  key: "customPreFunction",
                  value: function(n) {
                    if (!this.get("custom_function"))
                      return this.rawParam(n, "custom_function", "", function() {
                        return n = Su(n), n && "fn_pre:".concat(n);
                      });
                  }
                }, {
                  key: "defaultImage",
                  value: function(n) {
                    return this.param(n, "default_image", "d");
                  }
                }, {
                  key: "delay",
                  value: function(n) {
                    return this.param(n, "delay", "dl");
                  }
                }, {
                  key: "density",
                  value: function(n) {
                    return this.param(n, "density", "dn");
                  }
                }, {
                  key: "duration",
                  value: function(n) {
                    return this.rangeParam(n, "duration", "du");
                  }
                }, {
                  key: "dpr",
                  value: function(n) {
                    return this.param(n, "dpr", "dpr", function(o) {
                      return o = o.toString(), o != null && o.match(/^\d+$/) ? o + ".0" : Y.normalize(o);
                    });
                  }
                }, {
                  key: "effect",
                  value: function(n) {
                    return this.arrayParam(n, "effect", "e", ":", Y.normalize);
                  }
                }, {
                  key: "else",
                  value: function() {
                    return this.if("else");
                  }
                }, {
                  key: "endIf",
                  value: function() {
                    return this.if("end");
                  }
                }, {
                  key: "endOffset",
                  value: function(n) {
                    return this.rangeParam(n, "end_offset", "eo");
                  }
                }, {
                  key: "fallbackContent",
                  value: function(n) {
                    return this.param(n, "fallback_content");
                  }
                }, {
                  key: "fetchFormat",
                  value: function(n) {
                    return this.param(n, "fetch_format", "f");
                  }
                }, {
                  key: "format",
                  value: function(n) {
                    return this.param(n, "format");
                  }
                }, {
                  key: "flags",
                  value: function(n) {
                    return this.arrayParam(n, "flags", "fl", ".");
                  }
                }, {
                  key: "gravity",
                  value: function(n) {
                    return this.param(n, "gravity", "g");
                  }
                }, {
                  key: "fps",
                  value: function(n) {
                    return this.param(n, "fps", "fps", function(o) {
                      return G()(o) ? o : H()(o) ? o.join("-") : o;
                    });
                  }
                }, {
                  key: "height",
                  value: function(n) {
                    var o = this;
                    return this.param(n, "height", "h", function() {
                      return o.getValue("crop") || o.getValue("overlay") || o.getValue("underlay") ? Y.normalize(n) : null;
                    });
                  }
                }, {
                  key: "htmlHeight",
                  value: function(n) {
                    return this.param(n, "html_height");
                  }
                }, {
                  key: "htmlWidth",
                  value: function(n) {
                    return this.param(n, "html_width");
                  }
                }, {
                  key: "if",
                  value: function() {
                    var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", o, f, h, g, v;
                    switch (n) {
                      case "else":
                        return this.chain(), this.param(n, "if", "if");
                      case "end":
                        for (this.chain(), o = h = this.chained.length - 1; h >= 0 && (f = this.chained[o].getValue("if"), f !== "end"); o = h += -1)
                          if (f != null && (g = t.new().if(f), this.chained[o].remove("if"), v = this.chained[o], this.chained[o] = t.new().transformation([g, v]), f !== "else"))
                            break;
                        return this.param(n, "if", "if");
                      case "":
                        return Me.new().setParent(this);
                      default:
                        return this.param(n, "if", "if", function(S) {
                          return Me.new(S).toString();
                        });
                    }
                  }
                }, {
                  key: "keyframeInterval",
                  value: function(n) {
                    return this.param(n, "keyframe_interval", "ki");
                  }
                }, {
                  key: "ocr",
                  value: function(n) {
                    return this.param(n, "ocr", "ocr");
                  }
                }, {
                  key: "offset",
                  value: function(n) {
                    var o, f, h = L()(n != null ? n.split : void 0) ? n.split("..") : H()(n) ? n : [null, null], g = Kr(h, 2);
                    if (f = g[0], o = g[1], f != null && this.startOffset(f), o != null)
                      return this.endOffset(o);
                  }
                }, {
                  key: "opacity",
                  value: function(n) {
                    return this.param(n, "opacity", "o", Y.normalize);
                  }
                }, {
                  key: "overlay",
                  value: function(n) {
                    return this.layerParam(n, "overlay", "l");
                  }
                }, {
                  key: "page",
                  value: function(n) {
                    return this.param(n, "page", "pg");
                  }
                }, {
                  key: "poster",
                  value: function(n) {
                    return this.param(n, "poster");
                  }
                }, {
                  key: "prefix",
                  value: function(n) {
                    return this.param(n, "prefix", "p");
                  }
                }, {
                  key: "quality",
                  value: function(n) {
                    return this.param(n, "quality", "q", Y.normalize);
                  }
                }, {
                  key: "radius",
                  value: function(n) {
                    return this.arrayParam(n, "radius", "r", ":", Y.normalize);
                  }
                }, {
                  key: "rawTransformation",
                  value: function(n) {
                    return this.rawParam(n, "raw_transformation");
                  }
                }, {
                  key: "size",
                  value: function(n) {
                    var o, f;
                    if (L()(n != null ? n.split : void 0)) {
                      var h = n.split("x"), g = Kr(h, 2);
                      return f = g[0], o = g[1], this.width(f), this.height(o);
                    }
                  }
                }, {
                  key: "sourceTypes",
                  value: function(n) {
                    return this.param(n, "source_types");
                  }
                }, {
                  key: "sourceTransformation",
                  value: function(n) {
                    return this.param(n, "source_transformation");
                  }
                }, {
                  key: "startOffset",
                  value: function(n) {
                    return this.rangeParam(n, "start_offset", "so");
                  }
                }, {
                  key: "streamingProfile",
                  value: function(n) {
                    return this.param(n, "streaming_profile", "sp");
                  }
                }, {
                  key: "transformation",
                  value: function(n) {
                    return this.transformationParam(n, "transformation", "t");
                  }
                }, {
                  key: "underlay",
                  value: function(n) {
                    return this.layerParam(n, "underlay", "u");
                  }
                }, {
                  key: "variable",
                  value: function(n, o) {
                    return this.param(o, n, n);
                  }
                }, {
                  key: "variables",
                  value: function(n) {
                    return this.arrayParam(n, "variables");
                  }
                }, {
                  key: "videoCodec",
                  value: function(n) {
                    return this.param(n, "video_codec", "vc", ot.process_video_params);
                  }
                }, {
                  key: "videoSampling",
                  value: function(n) {
                    return this.param(n, "video_sampling", "vs");
                  }
                }, {
                  key: "width",
                  value: function(n) {
                    var o = this;
                    return this.param(n, "width", "w", function() {
                      return o.getValue("crop") || o.getValue("overlay") || o.getValue("underlay") ? Y.normalize(n) : null;
                    });
                  }
                }, {
                  key: "x",
                  value: function(n) {
                    return this.param(n, "x", "x", Y.normalize);
                  }
                }, {
                  key: "y",
                  value: function(n) {
                    return this.param(n, "y", "y", Y.normalize);
                  }
                }, {
                  key: "zoom",
                  value: function(n) {
                    return this.param(n, "zoom", "z", Y.normalize);
                  }
                }], [{
                  key: "new",
                  value: function(n) {
                    return new t(n);
                  }
                }]);
              }(Gr);
              St.methods = ["angle", "audioCodec", "audioFrequency", "aspectRatio", "background", "bitRate", "border", "color", "colorSpace", "crop", "customFunction", "customPreFunction", "defaultImage", "delay", "density", "duration", "dpr", "effect", "else", "endIf", "endOffset", "fallbackContent", "fetchFormat", "format", "flags", "gravity", "fps", "height", "htmlHeight", "htmlWidth", "if", "keyframeInterval", "ocr", "offset", "opacity", "overlay", "page", "poster", "prefix", "quality", "radius", "rawTransformation", "size", "sourceTypes", "sourceTransformation", "startOffset", "streamingProfile", "transformation", "underlay", "variable", "variables", "videoCodec", "videoSampling", "width", "x", "y", "zoom"], St.PARAM_NAMES = St.methods.map(Ct).concat(Ve.CONFIG_PARAMS);
              var nt = St;
              function ye(e) {
                "@babel/helpers - typeof";
                return ye = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
                  return typeof t;
                } : function(t) {
                  return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                }, ye(e);
              }
              function yd(e, t) {
                if (!(e instanceof t))
                  throw new TypeError("Cannot call a class as a function");
              }
              function Au(e, t) {
                for (var r = 0; r < t.length; r++) {
                  var n = t[r];
                  n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, vd(n.key), n);
                }
              }
              function pd(e, t, r) {
                return t && Au(e.prototype, t), r && Au(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
              }
              function vd(e) {
                var t = gd(e, "string");
                return ye(t) == "symbol" ? t : t + "";
              }
              function gd(e, t) {
                if (ye(e) != "object" || !e) return e;
                var r = e[Symbol.toPrimitive];
                if (r !== void 0) {
                  var n = r.call(e, t);
                  if (ye(n) != "object") return n;
                  throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return String(e);
              }
              var md = /* @__PURE__ */ function() {
                function e(t, r, n) {
                  yd(this, e);
                  var o;
                  this.name = t, this.publicId = r, n == null && (K()(r) ? (n = r, this.publicId = void 0) : n = {}), o = new nt(n), o.setParent(this), this.transformation = function() {
                    return o;
                  };
                }
                return pd(e, [{
                  key: "htmlAttrs",
                  value: (
                    /**
                     * combine key and value from the `attr` to generate an HTML tag attributes string.
                     * `Transformation::toHtmlTagOptions` is used to filter out transformation and configuration keys.
                     * @protected
                     * @param {Object} attrs
                     * @return {string} the attributes in the format `'key1="value1" key2="value2"'`
                     * @ignore
                     */
                    function(r) {
                      var n, o;
                      return function() {
                        var f;
                        f = [];
                        for (n in r)
                          o = _d(r[n]), o && f.push(bd(n, o));
                        return f;
                      }().sort().join(" ");
                    }
                  )
                  /**
                   * Get all options related to this tag.
                   * @function HtmlTag#getOptions
                   * @returns {Object} the options
                   *
                   */
                }, {
                  key: "getOptions",
                  value: function() {
                    return this.transformation().toOptions();
                  }
                  /**
                   * Get the value of option `name`
                   * @function HtmlTag#getOption
                   * @param {string} name - the name of the option
                   * @returns {*} Returns the value of the option
                   *
                   */
                }, {
                  key: "getOption",
                  value: function(r) {
                    return this.transformation().getValue(r);
                  }
                  /**
                   * Get the attributes of the tag.
                   * @function HtmlTag#attributes
                   * @returns {Object} attributes
                   */
                }, {
                  key: "attributes",
                  value: function() {
                    var r = this.transformation().toHtmlAttributes();
                    return Object.keys(r).forEach(function(n) {
                      K()(r[n]) && delete r[n];
                    }), r.attributes && (ht()(r, r.attributes), delete r.attributes), r;
                  }
                  /**
                   * Set a tag attribute named `name` to `value`
                   * @function HtmlTag#setAttr
                   * @param {string} name - the name of the attribute
                   * @param {string} value - the value of the attribute
                   */
                }, {
                  key: "setAttr",
                  value: function(r, n) {
                    return this.transformation().set("html_".concat(r), n), this;
                  }
                  /**
                   * Get the value of the tag attribute `name`
                   * @function HtmlTag#getAttr
                   * @param {string} name - the name of the attribute
                   * @returns {*}
                   */
                }, {
                  key: "getAttr",
                  value: function(r) {
                    return this.attributes()["html_".concat(r)] || this.attributes()[r];
                  }
                  /**
                   * Remove the tag attributed named `name`
                   * @function HtmlTag#removeAttr
                   * @param {string} name - the name of the attribute
                   * @returns {*}
                   */
                }, {
                  key: "removeAttr",
                  value: function(r) {
                    var n;
                    return (n = this.transformation().remove("html_".concat(r))) != null ? n : this.transformation().remove(r);
                  }
                  /**
                   * @function HtmlTag#content
                   * @protected
                   * @ignore
                   */
                }, {
                  key: "content",
                  value: function() {
                    return "";
                  }
                  /**
                   * @function HtmlTag#openTag
                   * @protected
                   * @ignore
                   */
                }, {
                  key: "openTag",
                  value: function() {
                    var r = "<" + this.name, n = this.htmlAttrs(this.attributes());
                    return n && n.length > 0 && (r += " " + n), r + ">";
                  }
                  /**
                   * @function HtmlTag#closeTag
                   * @protected
                   * @ignore
                   */
                }, {
                  key: "closeTag",
                  value: function() {
                    return "</".concat(this.name, ">");
                  }
                  /**
                   * Generates an HTML representation of the tag.
                   * @function HtmlTag#toHtml
                   * @returns {string} Returns HTML in string format
                   */
                }, {
                  key: "toHtml",
                  value: function() {
                    return this.openTag() + this.content() + this.closeTag();
                  }
                  /**
                   * Creates a DOM object representing the tag.
                   * @function HtmlTag#toDOM
                   * @returns {Element}
                   */
                }, {
                  key: "toDOM",
                  value: function() {
                    var r, n, o, f;
                    if (!L()(typeof document < "u" && document !== null ? document.createElement : void 0))
                      throw "Can't create DOM if document is not present!";
                    r = document.createElement(this.name), o = this.attributes();
                    for (n in o)
                      f = o[n], r.setAttribute(n, f);
                    return r;
                  }
                }], [{
                  key: "new",
                  value: function(r, n, o) {
                    return new this(r, n, o);
                  }
                }, {
                  key: "isResponsive",
                  value: function(r, n) {
                    var o;
                    return o = _t(r, "src-cache") || _t(r, "src"), Zo(r, n) && /\bw_auto\b/.exec(o);
                  }
                }]);
              }();
              function bd(e, t) {
                if (t)
                  return t === !0 ? e : "".concat(e, '="').concat(t, '"');
              }
              function _d(e) {
                return G()(e) ? e.replace('"', "&#34;").replace("'", "&#39;") : e;
              }
              var At = md, Sd = ["placeholder", "accessibility"];
              function Ad(e, t) {
                if (e == null) return {};
                var r = Od(e, t), n, o;
                if (Object.getOwnPropertySymbols) {
                  var f = Object.getOwnPropertySymbols(e);
                  for (o = 0; o < f.length; o++)
                    n = f[o], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
                }
                return r;
              }
              function Od(e, t) {
                if (e == null) return {};
                var r = {}, n = Object.keys(e), o, f;
                for (f = 0; f < n.length; f++)
                  o = n[f], !(t.indexOf(o) >= 0) && (r[o] = e[o]);
                return r;
              }
              function Td(e) {
                var t = document.location.protocol + "//" + document.location.host;
                return e[0] === "?" ? t += document.location.pathname : e[0] !== "/" && (t += document.location.pathname.replace(/\/[^\/]*$/, "/")), t + e;
              }
              function $e(e) {
                return e ? !!e.match(/^https?:\//) : !1;
              }
              function wd(e) {
                return U(e) % 5 + 1;
              }
              function Pd(e) {
                var t = e.signature, r = !t || t.indexOf("s--") === 0 && t.substr(-2) === "--";
                return delete e.signature, r ? t : "s--".concat(t, "--");
              }
              function Cd(e, t) {
                if (t.cloud_name && t.cloud_name[0] === "/")
                  return "/res" + t.cloud_name;
                var r = "http://", n = "", o = "res", f = ".cloudinary.com", h = "/" + t.cloud_name;
                return t.protocol && (r = t.protocol + "//"), t.private_cdn && (n = t.cloud_name + "-", h = ""), t.cdn_subdomain && (o = "res-" + wd(e)), t.secure ? (r = "https://", t.secure_cdn_subdomain === !1 && (o = "res"), t.secure_distribution != null && t.secure_distribution !== jo && t.secure_distribution !== xo && (n = "", o = "", f = t.secure_distribution)) : t.cname && (r = "http://", n = "", o = t.cdn_subdomain ? "a" + (U(e) % 5 + 1) + "." : "", f = t.cname), [r, n, o, f, h].join("");
              }
              function Ed(e) {
                var t = e.resource_type, r = t === void 0 ? "image" : t, n = e.type, o = n === void 0 ? "upload" : n, f = e.url_suffix, h = e.use_root_path, g = e.shorten, v, S = r;
                if (K()(S) && (v = S, S = v.resource_type, o = v.type, g = v.shorten), o == null && (o = "upload"), f != null && (S = Pr["".concat(S, "/").concat(o)], o = null, S == null))
                  throw new Error("URL Suffix only supported for ".concat(Object.keys(Pr).join(", ")));
                if (h)
                  if (S === "image" && o === "upload" || S === "images")
                    S = null, o = null;
                  else
                    throw new Error("Root path only supported for image/upload");
                return g && S === "image" && o === "upload" && (S = "iu", o = null), [S, o].join("/");
              }
              function Ou(e) {
                return encodeURIComponent(e).replace(/%3A/g, ":").replace(/%2F/g, "/");
              }
              function Rd(e, t) {
                if ($e(e))
                  e = Ou(e);
                else {
                  try {
                    e = decodeURIComponent(e);
                  } catch {
                  }
                  e = Ou(e), t.url_suffix && (e = e + "/" + t.url_suffix), t.format && (t.trust_public_id || (e = e.replace(/\.(jpg|png|gif|webp)$/, "")), e = e + "." + t.format);
                }
                return e;
              }
              function jd(e) {
                var t = e.cloud_name, r = e.url_suffix;
                if (!t)
                  return "Unknown cloud_name";
                if (r && r.match(/[\.\/]/))
                  return "url_suffix should not include . or /";
              }
              function Dd(e, t) {
                var r = t.force_version || typeof t.force_version > "u", n = e.indexOf("/") < 0 || e.match(/^v[0-9]+/) || $e(e) || t.version;
                return r && !n && (t.version = 1), t.version ? "v".concat(t.version) : "";
              }
              function xd(e) {
                var t = e || {}, r = t.placeholder, n = t.accessibility, o = Ad(t, Sd), f = new nt(o);
                if (n && Rr[n] && f.chain().effect(Rr[n]), r) {
                  r === "predominant-color" && f.getValue("width") && f.getValue("height") && (r += "-pixel");
                  var h = Er[r] || Er.blur;
                  h.forEach(function(g) {
                    return f.chain().transformation(g);
                  });
                }
                return f.serialize();
              }
              function Id(e, t) {
                var r = t.type;
                return !$e(e) && r === "fetch" ? Td(e) : e;
              }
              function Fd(e, t) {
                if ($e(e) && (t.type === "upload" || t.type === "asset"))
                  return e;
                var r = Dd(e, t), n = xd(t), o = Cd(e, t), f = Pd(t), h = Ed(t);
                return e = Rd(e, t), it()([o, h, f, n, r, e]).join("/").replace(/([^:])\/+/g, "$1/").replace(" ", "%20");
              }
              function Bd(e, t) {
                return e instanceof nt && (e = e.toOptions()), e = dt({}, e, t, Cr), e.type === "fetch" && (e.fetch_format = e.fetch_format || e.format), e;
              }
              function pt(e) {
                var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
                if (!e)
                  return e;
                t = Bd(t, r), e = Id(e, t);
                var n = jd(t);
                if (n)
                  throw n;
                var o = Fd(e, t);
                if (t.urlAnalytics) {
                  var f = Ce(t), h = Pe(f), g = "?";
                  o.indexOf("?") >= 0 && (g = "&"), o = "".concat(o).concat(g, "_a=").concat(h);
                }
                if (t.auth_token) {
                  var v = o.indexOf("?") >= 0 ? "&" : "?";
                  o = "".concat(o).concat(v, "__cld_token__=").concat(t.auth_token);
                }
                return o;
              }
              function kd(e, t) {
                return Vd(e) || Md(e, t) || Ld(e, t) || qd();
              }
              function qd() {
                throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
              }
              function Ld(e, t) {
                if (e) {
                  if (typeof e == "string") return Tu(e, t);
                  var r = Object.prototype.toString.call(e).slice(8, -1);
                  if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
                  if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return Tu(e, t);
                }
              }
              function Tu(e, t) {
                (t == null || t > e.length) && (t = e.length);
                for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
                return n;
              }
              function Md(e, t) {
                var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
                if (r != null) {
                  var n, o, f, h, g = [], v = !0, S = !1;
                  try {
                    if (f = (r = r.call(e)).next, t !== 0) for (; !(v = (n = f.call(r)).done) && (g.push(n.value), g.length !== t); v = !0) ;
                  } catch (T) {
                    S = !0, o = T;
                  } finally {
                    try {
                      if (!v && r.return != null && (h = r.return(), Object(h) !== h)) return;
                    } finally {
                      if (S) throw o;
                    }
                  }
                  return g;
                }
              }
              function Vd(e) {
                if (Array.isArray(e)) return e;
              }
              function Nd(e) {
                var t = e.breakpoints || [];
                if (t.length)
                  return t;
                var r = [e.min_width, e.max_width, e.max_images].map(Number), n = kd(r, 3), o = n[0], f = n[1], h = n[2];
                if ([o, f, h].some(isNaN))
                  throw "Either (min_width, max_width, max_images) or breakpoints must be provided to the image srcset attribute";
                if (o > f)
                  throw "min_width must be less than max_width";
                if (h <= 0)
                  throw "max_images must be a positive integer";
                h === 1 && (o = f);
                for (var g = Math.ceil((f - o) / Math.max(h - 1, 1)), v = o; v < f; v += g)
                  t.push(v);
                return t.push(f), t;
              }
              var Wr = x;
              function Ud(e, t, r) {
                var n = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, o = Ir(n);
                return r = r || n, o.raw_transformation = new nt([ht.a({}, r), {
                  crop: "scale",
                  width: t
                }]).toString(), pt(e, o);
              }
              function zd(e) {
                var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                return Nd(t);
              }
              function Hd(e, t, r, n) {
                return n = ft.a(n), $o(n), t.map(function(o) {
                  return "".concat(Ud(e, o, r, n), " ").concat(o, "w");
                }).join(", ");
              }
              function Kd(e) {
                return e == null ? "" : e.map(function(t) {
                  return "(max-width: ".concat(t, "px) ").concat(t, "px");
                }).join(", ");
              }
              function wu(e) {
                var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, n = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, o = {};
                if (Wr(r))
                  return o;
                var f = !t.sizes && r.sizes === !0, h = !t.srcset;
                if (h || f) {
                  var g = zd(e, r, n);
                  if (h) {
                    var v = r.transformation, S = Hd(e, g, v, n);
                    Wr(S) || (o.srcset = S);
                  }
                  if (f) {
                    var T = Kd(g);
                    Wr(T) || (o.sizes = T);
                  }
                }
                return o;
              }
              function Gd(e) {
                var t = [];
                return e != null && (e.min_width != null && t.push("(min-width: ".concat(e.min_width, "px)")), e.max_width != null && t.push("(max-width: ".concat(e.max_width, "px)"))), t.join(" and ");
              }
              function zt(e) {
                "@babel/helpers - typeof";
                return zt = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
                  return typeof t;
                } : function(t) {
                  return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                }, zt(e);
              }
              function $d(e, t) {
                if (!(e instanceof t))
                  throw new TypeError("Cannot call a class as a function");
              }
              function Wd(e, t) {
                for (var r = 0; r < t.length; r++) {
                  var n = t[r];
                  n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Qd(n.key), n);
                }
              }
              function Yd(e, t, r) {
                return t && Wd(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
              }
              function Qd(e) {
                var t = Jd(e, "string");
                return zt(t) == "symbol" ? t : t + "";
              }
              function Jd(e, t) {
                if (zt(e) != "object" || !e) return e;
                var r = e[Symbol.toPrimitive];
                if (r !== void 0) {
                  var n = r.call(e, t);
                  if (zt(n) != "object") return n;
                  throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return String(e);
              }
              function Xd(e, t, r) {
                return t = Ht(t), Zd(e, Pu() ? Reflect.construct(t, r || [], Ht(e).constructor) : t.apply(e, r));
              }
              function Zd(e, t) {
                if (t && (zt(t) === "object" || typeof t == "function"))
                  return t;
                if (t !== void 0)
                  throw new TypeError("Derived constructors may only return object or undefined");
                return ty(e);
              }
              function ty(e) {
                if (e === void 0)
                  throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return e;
              }
              function Pu() {
                try {
                  var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
                  }));
                } catch {
                }
                return (Pu = function() {
                  return !!e;
                })();
              }
              function We() {
                return typeof Reflect < "u" && Reflect.get ? We = Reflect.get.bind() : We = function(t, r, n) {
                  var o = ey(t, r);
                  if (o) {
                    var f = Object.getOwnPropertyDescriptor(o, r);
                    return f.get ? f.get.call(arguments.length < 3 ? t : n) : f.value;
                  }
                }, We.apply(this, arguments);
              }
              function ey(e, t) {
                for (; !Object.prototype.hasOwnProperty.call(e, t) && (e = Ht(e), e !== null); )
                  ;
                return e;
              }
              function Ht(e) {
                return Ht = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
                  return r.__proto__ || Object.getPrototypeOf(r);
                }, Ht(e);
              }
              function ry(e, t) {
                if (typeof t != "function" && t !== null)
                  throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Yr(e, t);
              }
              function Yr(e, t) {
                return Yr = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, o) {
                  return n.__proto__ = o, n;
                }, Yr(e, t);
              }
              var ny = /* @__PURE__ */ function(e) {
                function t(r) {
                  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                  return $d(this, t), Xd(this, t, ["img", r, n]);
                }
                return ry(t, e), Yd(t, [{
                  key: "closeTag",
                  value: function() {
                    return "";
                  }
                  /** @override */
                }, {
                  key: "attributes",
                  value: function() {
                    var n, o, f;
                    n = We(Ht(t.prototype), "attributes", this).call(this) || {}, o = this.getOptions();
                    var h = this.getOption("attributes") || {}, g = this.getOption("srcset") || h.srcset, v = {};
                    return G()(g) ? v.srcset = g : v = wu(this.publicId, h, g, o), x(v) || (delete n.width, delete n.height), ht()(n, v), f = o.responsive && !o.client_hints ? "data-src" : "src", n[f] == null && (n[f] = pt(this.publicId, this.getOptions())), n;
                  }
                }]);
              }(At), Ye = ny;
              function Kt(e) {
                "@babel/helpers - typeof";
                return Kt = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
                  return typeof t;
                } : function(t) {
                  return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                }, Kt(e);
              }
              function iy(e, t) {
                if (!(e instanceof t))
                  throw new TypeError("Cannot call a class as a function");
              }
              function ay(e, t) {
                for (var r = 0; r < t.length; r++) {
                  var n = t[r];
                  n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, uy(n.key), n);
                }
              }
              function oy(e, t, r) {
                return t && ay(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
              }
              function uy(e) {
                var t = sy(e, "string");
                return Kt(t) == "symbol" ? t : t + "";
              }
              function sy(e, t) {
                if (Kt(e) != "object" || !e) return e;
                var r = e[Symbol.toPrimitive];
                if (r !== void 0) {
                  var n = r.call(e, t);
                  if (Kt(n) != "object") return n;
                  throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return String(e);
              }
              function cy(e, t, r) {
                return t = Gt(t), fy(e, Cu() ? Reflect.construct(t, r || [], Gt(e).constructor) : t.apply(e, r));
              }
              function fy(e, t) {
                if (t && (Kt(t) === "object" || typeof t == "function"))
                  return t;
                if (t !== void 0)
                  throw new TypeError("Derived constructors may only return object or undefined");
                return ly(e);
              }
              function ly(e) {
                if (e === void 0)
                  throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return e;
              }
              function Cu() {
                try {
                  var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
                  }));
                } catch {
                }
                return (Cu = function() {
                  return !!e;
                })();
              }
              function Qe() {
                return typeof Reflect < "u" && Reflect.get ? Qe = Reflect.get.bind() : Qe = function(t, r, n) {
                  var o = hy(t, r);
                  if (o) {
                    var f = Object.getOwnPropertyDescriptor(o, r);
                    return f.get ? f.get.call(arguments.length < 3 ? t : n) : f.value;
                  }
                }, Qe.apply(this, arguments);
              }
              function hy(e, t) {
                for (; !Object.prototype.hasOwnProperty.call(e, t) && (e = Gt(e), e !== null); )
                  ;
                return e;
              }
              function Gt(e) {
                return Gt = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
                  return r.__proto__ || Object.getPrototypeOf(r);
                }, Gt(e);
              }
              function dy(e, t) {
                if (typeof t != "function" && t !== null)
                  throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Qr(e, t);
              }
              function Qr(e, t) {
                return Qr = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, o) {
                  return n.__proto__ = o, n;
                }, Qr(e, t);
              }
              var yy = /* @__PURE__ */ function(e) {
                function t(r) {
                  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                  return iy(this, t), cy(this, t, ["source", r, n]);
                }
                return dy(t, e), oy(t, [{
                  key: "closeTag",
                  value: function() {
                    return "";
                  }
                  /** @override */
                }, {
                  key: "attributes",
                  value: function() {
                    var n = this.getOption("srcset"), o = Qe(Gt(t.prototype), "attributes", this).call(this) || {}, f = this.getOptions();
                    return ht()(o, wu(this.publicId, o, n, f)), o.srcset || (o.srcset = pt(this.publicId, f)), !o.media && f.media && (o.media = Gd(f.media)), o;
                  }
                }]);
              }(At), Eu = yy;
              function $t(e) {
                "@babel/helpers - typeof";
                return $t = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
                  return typeof t;
                } : function(t) {
                  return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                }, $t(e);
              }
              function py(e, t) {
                if (!(e instanceof t))
                  throw new TypeError("Cannot call a class as a function");
              }
              function vy(e, t) {
                for (var r = 0; r < t.length; r++) {
                  var n = t[r];
                  n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, my(n.key), n);
                }
              }
              function gy(e, t, r) {
                return t && vy(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
              }
              function my(e) {
                var t = by(e, "string");
                return $t(t) == "symbol" ? t : t + "";
              }
              function by(e, t) {
                if ($t(e) != "object" || !e) return e;
                var r = e[Symbol.toPrimitive];
                if (r !== void 0) {
                  var n = r.call(e, t);
                  if ($t(n) != "object") return n;
                  throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return String(e);
              }
              function _y(e, t, r) {
                return t = Wt(t), Sy(e, Ru() ? Reflect.construct(t, r || [], Wt(e).constructor) : t.apply(e, r));
              }
              function Sy(e, t) {
                if (t && ($t(t) === "object" || typeof t == "function"))
                  return t;
                if (t !== void 0)
                  throw new TypeError("Derived constructors may only return object or undefined");
                return Ay(e);
              }
              function Ay(e) {
                if (e === void 0)
                  throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return e;
              }
              function Ru() {
                try {
                  var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
                  }));
                } catch {
                }
                return (Ru = function() {
                  return !!e;
                })();
              }
              function Je() {
                return typeof Reflect < "u" && Reflect.get ? Je = Reflect.get.bind() : Je = function(t, r, n) {
                  var o = Oy(t, r);
                  if (o) {
                    var f = Object.getOwnPropertyDescriptor(o, r);
                    return f.get ? f.get.call(arguments.length < 3 ? t : n) : f.value;
                  }
                }, Je.apply(this, arguments);
              }
              function Oy(e, t) {
                for (; !Object.prototype.hasOwnProperty.call(e, t) && (e = Wt(e), e !== null); )
                  ;
                return e;
              }
              function Wt(e) {
                return Wt = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
                  return r.__proto__ || Object.getPrototypeOf(r);
                }, Wt(e);
              }
              function Ty(e, t) {
                if (typeof t != "function" && t !== null)
                  throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Jr(e, t);
              }
              function Jr(e, t) {
                return Jr = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, o) {
                  return n.__proto__ = o, n;
                }, Jr(e, t);
              }
              var wy = /* @__PURE__ */ function(e) {
                function t(r) {
                  var n, o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, f = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
                  return py(this, t), n = _y(this, t, ["picture", r, o]), n.widthList = f, n;
                }
                return Ty(t, e), gy(t, [{
                  key: "content",
                  value: function() {
                    var n = this;
                    return this.widthList.map(function(o) {
                      var f = o.min_width, h = o.max_width, g = o.transformation, v = n.getOptions(), S = new nt(v);
                      return S.chain().fromOptions(typeof g == "string" ? {
                        raw_transformation: g
                      } : g), v = Ir(v), v.media = {
                        min_width: f,
                        max_width: h
                      }, v.transformation = S, new Eu(n.publicId, v).toHtml();
                    }).join("") + new Ye(this.publicId, this.getOptions()).toHtml();
                  }
                  /** @override */
                }, {
                  key: "attributes",
                  value: function() {
                    var n = Je(Wt(t.prototype), "attributes", this).call(this);
                    return delete n.width, delete n.height, n;
                  }
                  /** @override */
                }, {
                  key: "closeTag",
                  value: function() {
                    return "</" + this.name + ">";
                  }
                }]);
              }(At), Xr = wy;
              function Yt(e) {
                "@babel/helpers - typeof";
                return Yt = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
                  return typeof t;
                } : function(t) {
                  return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                }, Yt(e);
              }
              function Py(e, t) {
                if (!(e instanceof t))
                  throw new TypeError("Cannot call a class as a function");
              }
              function Cy(e, t) {
                for (var r = 0; r < t.length; r++) {
                  var n = t[r];
                  n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Ry(n.key), n);
                }
              }
              function Ey(e, t, r) {
                return t && Cy(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
              }
              function Ry(e) {
                var t = jy(e, "string");
                return Yt(t) == "symbol" ? t : t + "";
              }
              function jy(e, t) {
                if (Yt(e) != "object" || !e) return e;
                var r = e[Symbol.toPrimitive];
                if (r !== void 0) {
                  var n = r.call(e, t);
                  if (Yt(n) != "object") return n;
                  throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return String(e);
              }
              function Dy(e, t, r) {
                return t = Qt(t), xy(e, ju() ? Reflect.construct(t, r || [], Qt(e).constructor) : t.apply(e, r));
              }
              function xy(e, t) {
                if (t && (Yt(t) === "object" || typeof t == "function"))
                  return t;
                if (t !== void 0)
                  throw new TypeError("Derived constructors may only return object or undefined");
                return Iy(e);
              }
              function Iy(e) {
                if (e === void 0)
                  throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return e;
              }
              function ju() {
                try {
                  var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
                  }));
                } catch {
                }
                return (ju = function() {
                  return !!e;
                })();
              }
              function Xe() {
                return typeof Reflect < "u" && Reflect.get ? Xe = Reflect.get.bind() : Xe = function(t, r, n) {
                  var o = Fy(t, r);
                  if (o) {
                    var f = Object.getOwnPropertyDescriptor(o, r);
                    return f.get ? f.get.call(arguments.length < 3 ? t : n) : f.value;
                  }
                }, Xe.apply(this, arguments);
              }
              function Fy(e, t) {
                for (; !Object.prototype.hasOwnProperty.call(e, t) && (e = Qt(e), e !== null); )
                  ;
                return e;
              }
              function Qt(e) {
                return Qt = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
                  return r.__proto__ || Object.getPrototypeOf(r);
                }, Qt(e);
              }
              function By(e, t) {
                if (typeof t != "function" && t !== null)
                  throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Zr(e, t);
              }
              function Zr(e, t) {
                return Zr = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, o) {
                  return n.__proto__ = o, n;
                }, Zr(e, t);
              }
              var ky = ["source_types", "source_transformation", "fallback_content", "poster", "sources"], qy = ["webm", "mp4", "ogv"], Ly = {
                format: "jpg",
                resource_type: "video"
              }, My = /* @__PURE__ */ function(e) {
                function t(r) {
                  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                  return Py(this, t), n = dt({}, n, Bo), Dy(this, t, ["video", r.replace(/\.(mp4|ogv|webm)$/, ""), n]);
                }
                return By(t, e), Ey(t, [{
                  key: "setSourceTransformation",
                  value: function(n) {
                    return this.transformation().sourceTransformation(n), this;
                  }
                  /**
                   * Set the source types to include in the video tag
                   * @function VideoTag#setSourceTypes
                   * @param {Array<string>} an array of source types
                   * @returns {VideoTag} Returns this instance for chaining purposes.
                   */
                }, {
                  key: "setSourceTypes",
                  value: function(n) {
                    return this.transformation().sourceTypes(n), this;
                  }
                  /**
                   * Set the poster to be used in the video tag
                   * @function VideoTag#setPoster
                   * @param {string|Object} value
                   * - string: a URL to use for the poster
                   * - Object: transformation parameters to apply to the poster. May optionally include a public_id to use instead of the video public_id.
                   * @returns {VideoTag} Returns this instance for chaining purposes.
                   */
                }, {
                  key: "setPoster",
                  value: function(n) {
                    return this.transformation().poster(n), this;
                  }
                  /**
                   * Set the content to use as fallback in the video tag
                   * @function VideoTag#setFallbackContent
                   * @param {string} value - the content to use, in HTML format
                   * @returns {VideoTag} Returns this instance for chaining purposes.
                   */
                }, {
                  key: "setFallbackContent",
                  value: function(n) {
                    return this.transformation().fallbackContent(n), this;
                  }
                }, {
                  key: "content",
                  value: function() {
                    var n = this, o = this.transformation().getValue("source_types"), f = this.transformation().getValue("source_transformation"), h = this.transformation().getValue("fallback_content"), g = this.getOption("sources"), v = [];
                    return H()(g) && !x(g) ? v = g.map(function(S) {
                      var T = pt(n.publicId, dt({}, S.transformations || {}, {
                        resource_type: "video",
                        format: S.type
                      }), n.getOptions());
                      return n.createSourceTag(T, S.type, S.codecs);
                    }) : (x(o) && (o = qy), H()(o) && (v = o.map(function(S) {
                      var T = pt(n.publicId, dt({}, f[S] || {}, {
                        resource_type: "video",
                        format: S
                      }), n.getOptions());
                      return n.createSourceTag(T, S);
                    }))), v.join("") + h;
                  }
                }, {
                  key: "attributes",
                  value: function() {
                    var n = this.getOption("source_types"), o = this.getOption("poster");
                    if (o === void 0 && (o = {}), K()(o)) {
                      var f = o.public_id != null ? Cr : Ly;
                      o = pt(o.public_id || this.publicId, dt({}, o, f, this.getOptions()));
                    }
                    var h = Xe(Qt(t.prototype), "attributes", this).call(this) || {};
                    h = qo(h, ky);
                    var g = this.getOption("sources"), v = !x(g) || x(n) || H()(n);
                    return v || (h.src = pt(this.publicId, this.getOptions(), {
                      resource_type: "video",
                      format: n
                    })), o != null && (h.poster = o), h;
                  }
                }, {
                  key: "createSourceTag",
                  value: function(n, o) {
                    var f = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, h = null;
                    if (!x(o)) {
                      var g = o === "ogv" ? "ogg" : o;
                      if (h = "video/" + g, !x(f)) {
                        var v = H()(f) ? f.join(", ") : f;
                        h += "; codecs=" + v;
                      }
                    }
                    return "<source " + this.htmlAttrs({
                      src: n,
                      type: h
                    }) + ">";
                  }
                }]);
              }(At), tn = My;
              function Jt(e) {
                "@babel/helpers - typeof";
                return Jt = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
                  return typeof t;
                } : function(t) {
                  return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                }, Jt(e);
              }
              function Vy(e, t) {
                if (!(e instanceof t))
                  throw new TypeError("Cannot call a class as a function");
              }
              function Ny(e, t) {
                for (var r = 0; r < t.length; r++) {
                  var n = t[r];
                  n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, zy(n.key), n);
                }
              }
              function Uy(e, t, r) {
                return t && Ny(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
              }
              function zy(e) {
                var t = Hy(e, "string");
                return Jt(t) == "symbol" ? t : t + "";
              }
              function Hy(e, t) {
                if (Jt(e) != "object" || !e) return e;
                var r = e[Symbol.toPrimitive];
                if (r !== void 0) {
                  var n = r.call(e, t);
                  if (Jt(n) != "object") return n;
                  throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return String(e);
              }
              function Ky(e, t, r) {
                return t = Ze(t), Gy(e, Du() ? Reflect.construct(t, r || [], Ze(e).constructor) : t.apply(e, r));
              }
              function Gy(e, t) {
                if (t && (Jt(t) === "object" || typeof t == "function"))
                  return t;
                if (t !== void 0)
                  throw new TypeError("Derived constructors may only return object or undefined");
                return $y(e);
              }
              function $y(e) {
                if (e === void 0)
                  throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return e;
              }
              function Du() {
                try {
                  var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
                  }));
                } catch {
                }
                return (Du = function() {
                  return !!e;
                })();
              }
              function Ze(e) {
                return Ze = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
                  return r.__proto__ || Object.getPrototypeOf(r);
                }, Ze(e);
              }
              function Wy(e, t) {
                if (typeof t != "function" && t !== null)
                  throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && en(e, t);
              }
              function en(e, t) {
                return en = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, o) {
                  return n.__proto__ = o, n;
                }, en(e, t);
              }
              var Yy = /* @__PURE__ */ function(e) {
                function t(r) {
                  return Vy(this, t), Ky(this, t, ["meta", void 0, Q()({
                    "http-equiv": "Accept-CH",
                    content: "DPR, Viewport-Width, Width"
                  }, r)]);
                }
                return Wy(t, e), Uy(t, [{
                  key: "closeTag",
                  value: function() {
                    return "";
                  }
                }]);
              }(At), xu = Yy;
              function Qy(e) {
                return tp(e) || Zy(e) || Xy(e) || Jy();
              }
              function Jy() {
                throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
              }
              function Xy(e, t) {
                if (e) {
                  if (typeof e == "string") return rn(e, t);
                  var r = Object.prototype.toString.call(e).slice(8, -1);
                  if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
                  if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return rn(e, t);
                }
              }
              function Zy(e) {
                if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
              }
              function tp(e) {
                if (Array.isArray(e)) return rn(e);
              }
              function rn(e, t) {
                (t == null || t > e.length) && (t = e.length);
                for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
                return n;
              }
              function ep(e) {
                return H()(e) ? e : e.constructor.name === "NodeList" ? Qy(e) : G()(e) ? Array.prototype.slice.call(document.querySelectorAll(e), 0) : [e];
              }
              function rp(e, t, r, n) {
                return new Promise(function(o, f) {
                  e.innerHTML = t.videoTag(r, n).toHtml();
                  var h = e.querySelector(".cld-transparent-video");
                  h.style.width = "100%", o(e);
                });
              }
              var np = rp;
              function ip(e, t) {
                e.transformation ? e.transformation.push({
                  flags: [t]
                }) : (e.flags || (e.flags = []), typeof e.flags == "string" && (e.flags = [e.flags]), e.flags.push(t));
              }
              var ap = ip;
              function op(e) {
                e.autoplay = !0, e.muted = !0, e.controls = !1, e.max_timeout_ms = e.max_timeout_ms || Io, e.class = e.class || "", e.class += " cld-transparent-video", e.externalLibraries = e.externalLibraries || {}, e.externalLibraries.seeThru || (e.externalLibraries.seeThru = ko.seeThru), ap(e, "alpha");
              }
              var up = op;
              function sp(e, t, r) {
                return new Promise(function(n, o) {
                  if (r)
                    n();
                  else {
                    var f = document.createElement("script");
                    f.src = e;
                    var h = setTimeout(function() {
                      o({
                        status: "error",
                        message: "Timeout loading script ".concat(e)
                      });
                    }, t);
                    f.onerror = function() {
                      clearTimeout(h), o({
                        status: "error",
                        message: "Error loading ".concat(e)
                      });
                    }, f.onload = function() {
                      clearTimeout(h), n();
                    }, document.head.appendChild(f);
                  }
                });
              }
              var cp = sp;
              function fp(e, t) {
                return setTimeout(function() {
                  t({
                    status: "error",
                    message: "Timeout loading Blob URL"
                  });
                }, e);
              }
              function lp(e, t) {
                return new Promise(function(r, n) {
                  var o = fp(t, n), f = typeof fetch < "u" && fetch ? hp : dp;
                  f(e).then(function(h) {
                    r({
                      status: "success",
                      payload: {
                        blobURL: URL.createObjectURL(h)
                      }
                    });
                  }).catch(function() {
                    n({
                      status: "error",
                      message: "Error loading Blob URL"
                    });
                  }).finally(function() {
                    clearTimeout(o);
                  });
                });
              }
              function hp(e) {
                return new Promise(function(t, r) {
                  fetch(e).then(function(n) {
                    n.blob().then(function(o) {
                      t(o);
                    });
                  }).catch(function() {
                    r("error");
                  });
                });
              }
              function dp(e) {
                return new Promise(function(t, r) {
                  var n = new XMLHttpRequest();
                  n.responseType = "blob", n.onload = function(o) {
                    t(n.response);
                  }, n.onerror = function() {
                    r("error");
                  }, n.open("GET", e, !0), n.send();
                });
              }
              var yp = lp;
              function pp(e) {
                var t = e.autoplay, r = e.playsinline, n = e.loop, o = e.muted, f = e.poster, h = e.blobURL, g = e.videoURL, v = document.createElement("video");
                return v.style.visibility = "hidden", v.position = "absolute", v.x = 0, v.y = 0, v.src = h, v.setAttribute("data-video-url", g), t && v.setAttribute("autoplay", t), r && v.setAttribute("playsinline", r), n && v.setAttribute("loop", n), o && v.setAttribute("muted", o), o && (v.muted = o), f && v.setAttribute("poster", f), v.onload = function() {
                  URL.revokeObjectURL(h);
                }, v;
              }
              var vp = pp;
              function gp(e, t, r, n) {
                var o = window, f = o.seeThru, h = o.setTimeout, g = o.clearTimeout;
                return new Promise(function(v, S) {
                  var T = h(function() {
                    S({
                      status: "error",
                      message: "Timeout instantiating seeThru instance"
                    });
                  }, t);
                  if (f)
                    var E = f.create(e).ready(function() {
                      g(T);
                      var D = E.getCanvas();
                      D.style.width = "100%", D.className += " " + r, n && E.play(), v(E);
                    });
                  else
                    S({
                      status: "error",
                      message: "Error instantiating seeThru instance"
                    });
                });
              }
              var mp = gp;
              function bp(e, t, r) {
                var n = r.poster, o = r.autoplay, f = r.playsinline, h = r.loop, g = r.muted;
                return t = t + ".mp4", new Promise(function(v, S) {
                  cp(r.externalLibraries.seeThru, r.max_timeout_ms, window.seeThru).then(function() {
                    yp(t, r.max_timeout_ms).then(function(T) {
                      var E = T.payload, D = vp({
                        blobURL: E.blobURL,
                        videoURL: t,
                        // for debugging/testing
                        poster: n,
                        autoplay: o,
                        playsinline: f,
                        loop: h,
                        muted: g
                      });
                      e.appendChild(D), mp(D, r.max_timeout_ms, r.class, r.autoplay).then(function() {
                        v(e);
                      }).catch(function(M) {
                        S(M);
                      });
                    }).catch(function(T) {
                      var E = T.status, D = T.message;
                      S({
                        status: E,
                        message: D
                      });
                    });
                  }).catch(function(T) {
                    var E = T.status, D = T.message;
                    S({
                      status: E,
                      message: D
                    });
                  });
                });
              }
              var _p = bp;
              function Sp() {
                return new Promise(function(e, t) {
                  Jo() && e(!1);
                  var r = document.createElement("video"), n = r.canPlayType && r.canPlayType('video/webm; codecs="vp9"');
                  e(n === "maybe" || n === "probably");
                });
              }
              var Ap = Sp;
              function pe(e) {
                "@babel/helpers - typeof";
                return pe = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
                  return typeof t;
                } : function(t) {
                  return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                }, pe(e);
              }
              function Op(e, t) {
                if (!(e instanceof t))
                  throw new TypeError("Cannot call a class as a function");
              }
              function Iu(e, t) {
                for (var r = 0; r < t.length; r++) {
                  var n = t[r];
                  n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, wp(n.key), n);
                }
              }
              function Tp(e, t, r) {
                return t && Iu(e.prototype, t), r && Iu(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
              }
              function wp(e) {
                var t = Pp(e, "string");
                return pe(t) == "symbol" ? t : t + "";
              }
              function Pp(e, t) {
                if (pe(e) != "object" || !e) return e;
                var r = e[Symbol.toPrimitive];
                if (r !== void 0) {
                  var n = r.call(e, t);
                  if (pe(n) != "object") return n;
                  throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return String(e);
              }
              var Fu, Bu, ku, qu, nn, Lu;
              ku = function(t) {
                var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 100;
                return r * Math.ceil(t / r);
              }, Bu = function(t, r) {
                var n;
                for (n = t.length - 2; n >= 0 && t[n] >= r; )
                  n--;
                return t[n + 1];
              }, Fu = function(t, r, n, o) {
                var f, h, g, v;
                return v = (f = (h = (g = o.responsive_use_breakpoints) != null ? g : o.responsive_use_stoppoints) != null ? h : this.config("responsive_use_breakpoints")) != null ? f : this.config("responsive_use_stoppoints"), !v || v === "resize" && !o.resizing ? r : this.calc_breakpoint(t, r, n);
              }, qu = function(t) {
                var r, n;
                for (r = 0; (t = t != null ? t.parentNode : void 0) instanceof Element && !r; )
                  n = window.getComputedStyle(t), /^inline/.test(n.display) || (r = au(t));
                return r;
              }, Lu = function(t, r) {
                return t.replace(/\bdpr_(1\.0|auto)\b/g, "dpr_" + this.device_pixel_ratio(r));
              }, nn = function(t, r) {
                var n;
                return n = _t(r, "width") || 0, t > n && (n = t, Be(r, "width", t)), n;
              };
              var Mu = /* @__PURE__ */ function() {
                function e(t) {
                  Op(this, e);
                  var r;
                  this.devicePixelRatioCache = {}, this.responsiveConfig = {}, this.responsiveResizeInitialized = !1, r = new Ve(t), this.config = function(n, o) {
                    return r.config(n, o);
                  }, this.fromDocument = function() {
                    return r.fromDocument(), this;
                  }, this.fromEnvironment = function() {
                    return r.fromEnvironment(), this;
                  }, this.init = function() {
                    return r.init(), this;
                  };
                }
                return Tp(e, [{
                  key: "url",
                  value: (
                    /**
                     * Generates a URL for any asset in your Media library.
                     * @function Cloudinary#url
                     * @param {string} publicId - The public ID of the media asset.
                     * @param {Object} [options] - The {@link Transformation} parameters to include in the URL.
                     * @param {type} [options.type='upload'] - The asset's storage type.
                     *  For details on all fetch types, see
                     * <a href="https://cloudinary.com/documentation/image_transformations#fetching_images_from_remote_locations"
                     *  target="_blank">Fetch types</a>.
                     * @param {resourceType} [options.resource_type='image'] - The type of asset. Possible values:<br/>
                     *  - `image`<br/>
                     *  - `video`<br/>
                     *  - `raw`
                     * @return {string} The media asset URL.
                     * @see <a href="https://cloudinary.com/documentation/image_transformation_reference" target="_blank">
                     *  Available image transformations</a>
                     * @see <a href="https://cloudinary.com/documentation/video_transformation_reference" target="_blank">
                     *  Available video transformations</a>
                     */
                    function(r) {
                      var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                      return pt(r, n, this.config());
                    }
                  )
                  /**
                   * Generates a video asset URL.
                   * @function Cloudinary#video_url
                   * @param {string} publicId - The public ID of the video.
                   * @param {Object} [options] - The {@link Transformation} parameters to include in the URL.
                   * @param {type} [options.type='upload'] - The asset's storage type.
                   *  For details on all fetch types, see
                   *  <a href="https://cloudinary.com/documentation/image_transformations#fetching_images_from_remote_locations"
                   *  target="_blank">Fetch types</a>.
                   * @return {string} The video URL.
                   * @see <a href="https://cloudinary.com/documentation/video_transformation_reference"
                   *  target="_blank">Available video transformations</a>
                   */
                }, {
                  key: "video_url",
                  value: function(r, n) {
                    return n = Q()({
                      resource_type: "video"
                    }, n), this.url(r, n);
                  }
                  /**
                   * Generates a URL for an image intended to be used as a thumbnail for the specified video.
                   *  Identical to {@link Cloudinary#url|url}, except that the `resource_type` is `video`
                   *  and the default `format` is `jpg`.
                   * @function Cloudinary#video_thumbnail_url
                   * @param {string} publicId -  The unique identifier of the video from which you want to generate a thumbnail image.
                   * @param {Object} [options] - The image {@link Transformation} parameters to apply to the thumbnail.
                   * In addition to standard image transformations, you can also use the `start_offset` transformation parameter
                   * to instruct Cloudinary to generate the thumbnail from a frame other than the middle frame of the video.
                   * For details, see
                   * <a href="https://cloudinary.com/documentation/video_manipulation_and_delivery#generating_video_thumbnails"
                   * target="_blank">Generating video thumbnails</a> in the Cloudinary documentation.
                   * @param {type} [options.type='upload'] - The asset's storage type.
                   * @return {string} The URL of the video thumbnail image.
                   * @see <a href="https://cloudinary.com/documentation/image_transformation_reference" target="_blank">
                   *  Available image transformations</a>
                   */
                }, {
                  key: "video_thumbnail_url",
                  value: function(r, n) {
                    return n = Q()({}, wr, n), this.url(r, n);
                  }
                  /**
                   * Generates a string representation of the specified transformation options.
                   * @function Cloudinary#transformation_string
                   * @param {Object} options - The {@link Transformation} options.
                   * @returns {string} The transformation string.
                   * @see <a href="https://cloudinary.com/documentation/image_transformation_reference" target="_blank">
                   *  Available image transformations</a>
                   * @see <a href="https://cloudinary.com/documentation/video_transformation_reference" target="_blank">
                   *  Available video transformations</a>
                   */
                }, {
                  key: "transformation_string",
                  value: function(r) {
                    return new nt(r).serialize();
                  }
                  /**
                   * Generates an image tag.
                   * @function Cloudinary#image
                   * @param {string} publicId - The public ID of the image.
                   * @param {Object} options - The {@link Transformation} parameters, {@link Configuration} parameters,
                   *  and standard HTML &lt;img&gt; tag attributes to apply to the image tag.
                   * @return {HTMLImageElement} An image tag DOM element.
                   * @see <a href="https://cloudinary.com/documentation/image_transformation_reference" target="_blank">
                   *  Available image transformations</a>
                   * @see <a href="https://cloudinary.com/documentation/solution_overview#configuration_parameters"
                   *  target="_blank">Available configuration options</a>
                   */
                }, {
                  key: "image",
                  value: function(r) {
                    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, o, f, h;
                    return f = this.imageTag(r, n), o = (h = n.client_hints != null ? n.client_hints : this.config("client_hints")) != null ? h : !1, n.src == null && !o && f.setAttr("src", ""), f = f.toDOM(), o || (Be(f, "src-cache", this.url(r, n)), this.cloudinary_update(f, n)), f;
                  }
                  /**
                   * Creates a new ImageTag instance using the configuration defined for this `cloudinary` instance.
                   * @function Cloudinary#imageTag
                   * @param {string} publicId - The public ID of the image.
                   * @param {Object} [options] - The {@link Transformation} parameters, {@link Configuration} parameters,
                   *  and standard HTML &lt;img&gt; tag attributes to apply to the image tag.
                   * @return {ImageTag} An ImageTag instance that is attached (chained) to this Cloudinary instance.
                   * @see <a href="https://cloudinary.com/documentation/image_transformation_reference" target="_blank">
                   *  Available image transformations</a>
                   * @see <a href="https://cloudinary.com/documentation/solution_overview#configuration_parameters"
                   *  target="_blank">Available configuration options</a>
                   */
                }, {
                  key: "imageTag",
                  value: function(r, n) {
                    var o;
                    return o = new Ye(r, this.config()), o.transformation().fromOptions(n), o;
                  }
                  /**
                   * Creates a new PictureTag instance, configured using this `cloudinary` instance.
                   * @function Cloudinary#PictureTag
                   * @param {string} publicId - the public ID of the resource
                   * @param {Object} options - additional options to pass to the new ImageTag instance
                   * @param {Array<Object>} sources - the sources definitions
                   * @return {PictureTag} A PictureTag that is attached (chained) to this Cloudinary instance
                   */
                }, {
                  key: "pictureTag",
                  value: function(r, n, o) {
                    var f;
                    return f = new Xr(r, this.config(), o), f.transformation().fromOptions(n), f;
                  }
                  /**
                   * Creates a new SourceTag instance, configured using this `cloudinary` instance.
                   * @function Cloudinary#SourceTag
                   * @param {string} publicId - the public ID of the resource.
                   * @param {Object} options - additional options to pass to the new instance.
                   * @return {SourceTag} A SourceTag that is attached (chained) to this Cloudinary instance
                   */
                }, {
                  key: "sourceTag",
                  value: function(r, n) {
                    var o;
                    return o = new Eu(r, this.config()), o.transformation().fromOptions(n), o;
                  }
                  /**
                   * Generates a video thumbnail URL from the specified remote video and includes it in an image tag.
                   * @function Cloudinary#video_thumbnail
                   * @param {string} publicId - The unique identifier of the video from the relevant video site.
                   *  Additionally, either append the image extension type to the identifier value or set
                   *  the image delivery format in the 'options' parameter using the 'format' transformation option.
                   *  For example, a YouTube video might have the identifier: 'o-urnlaJpOA.jpg'.
                   * @param {Object} [options] - The {@link Transformation} parameters to apply.
                   * @return {HTMLImageElement} An HTML image tag element
                   * @see <a href="https://cloudinary.com/documentation/video_transformation_reference" target="_blank">
                   *  Available video transformations</a>
                   * @see <a href="https://cloudinary.com/documentation/solution_overview#configuration_parameters"
                   *  target="_blank">Available configuration options</a>
                   */
                }, {
                  key: "video_thumbnail",
                  value: function(r, n) {
                    return this.image(r, ht()({}, wr, n));
                  }
                  /**
                   * Fetches a facebook profile image and delivers it in an image tag element.
                   * @function Cloudinary#facebook_profile_image
                   * @param {string} publicId - The Facebook numeric ID. Additionally, either append the image extension type
                   *  to the ID or set the image delivery format in the 'options' parameter using the 'format' transformation option.
                   * @param {Object} [options] - The {@link Transformation} parameters, {@link Configuration} parameters,
                   *  and standard HTML &lt;img&gt; tag attributes to apply to the image tag.
                   * @return {HTMLImageElement} An image tag element.
                   * @see <a href="https://cloudinary.com/documentation/image_transformation_reference" target="_blank">
                   *  Available image transformations</a>
                   * @see <a href="https://cloudinary.com/documentation/solution_overview#configuration_parameters"
                   *  target="_blank">Available configuration options</a>
                   */
                }, {
                  key: "facebook_profile_image",
                  value: function(r, n) {
                    return this.image(r, Q()({
                      type: "facebook"
                    }, n));
                  }
                  /**
                   * Fetches a Twitter profile image by ID and delivers it in an image tag element.
                   * @function Cloudinary#twitter_profile_image
                   * @param {string} publicId - The Twitter numeric ID. Additionally, either append the image extension type
                   *  to the ID or set the image delivery format in the 'options' parameter using the 'format' transformation option.
                   * @param {Object} [options] - The {@link Transformation} parameters, {@link Configuration} parameters,
                   *  and standard HTML &lt;img&gt; tag attributes to apply to the image tag.
                   * @return {HTMLImageElement} An image tag element.
                   * @see <a href="https://cloudinary.com/documentation/image_transformation_reference" target="_blank">
                   *  Available image transformations</a>
                   * @see <a href="https://cloudinary.com/documentation/solution_overview#configuration_parameters"
                   *  target="_blank">Available configuration options</a>
                   */
                }, {
                  key: "twitter_profile_image",
                  value: function(r, n) {
                    return this.image(r, Q()({
                      type: "twitter"
                    }, n));
                  }
                  /**
                   * Fetches a Twitter profile image by name and delivers it in an image tag element.
                   * @function Cloudinary#twitter_name_profile_image
                   * @param {string} publicId - The Twitter screen name. Additionally, either append the image extension type
                   *  to the screen name or set the image delivery format in the 'options' parameter using the 'format' transformation option.
                   * @param {Object} [options] - The {@link Transformation} parameters, {@link Configuration} parameters,
                   *  and standard HTML &lt;img&gt; tag attributes to apply to the image tag.
                   * @return {HTMLImageElement} An image tag element.
                   * @see <a href="https://cloudinary.com/documentation/image_transformation_reference" target="_blank">
                   *  Available image transformations</a>
                   * @see <a href="https://cloudinary.com/documentation/solution_overview#configuration_parameters"
                   *  target="_blank">Available configuration options</a>
                   */
                }, {
                  key: "twitter_name_profile_image",
                  value: function(r, n) {
                    return this.image(r, Q()({
                      type: "twitter_name"
                    }, n));
                  }
                  /**
                   * Fetches a Gravatar profile image and delivers it in an image tag element.
                   * @function Cloudinary#gravatar_image
                   * @param {string} publicId - The calculated hash for the Gravatar email address.
                   *  Additionally, either append the image extension type to the screen name or set the image delivery format
                   *  in the 'options' parameter using the 'format' transformation option.
                   * @param {Object} [options] - The {@link Transformation} parameters, {@link Configuration} parameters,
                   *  and standard HTML &lt;img&gt; tag attributes to apply to the image tag.
                   * @return {HTMLImageElement} An image tag element.
                   * @see <a href="https://cloudinary.com/documentation/image_transformation_reference" target="_blank">
                   *  Available image transformations</a>
                   * @see <a href="https://cloudinary.com/documentation/solution_overview#configuration_parameters"
                   *  target="_blank">Available configuration options</a>
                   */
                }, {
                  key: "gravatar_image",
                  value: function(r, n) {
                    return this.image(r, Q()({
                      type: "gravatar"
                    }, n));
                  }
                  /**
                   * Fetches an image from a remote URL and delivers it in an image tag element.
                   * @function Cloudinary#fetch_image
                   * @param {string} publicId - The full URL of the image to fetch, including the extension.
                   * @param {Object} [options] - The {@link Transformation} parameters, {@link Configuration} parameters,
                   *  and standard HTML &lt;img&gt; tag attributes to apply to the image tag.
                   * @return {HTMLImageElement} An image tag element.
                   * @see <a href="https://cloudinary.com/documentation/image_transformation_reference" target="_blank">
                   *  Available image transformations</a>
                   * @see <a href="https://cloudinary.com/documentation/solution_overview#configuration_parameters"
                   *  target="_blank">Available configuration options</a>
                   */
                }, {
                  key: "fetch_image",
                  value: function(r, n) {
                    return this.image(r, Q()({
                      type: "fetch"
                    }, n));
                  }
                  /**
                   * Generates a video tag.
                   * @function Cloudinary#video
                   * @param {string} publicId - The public ID of the video.
                   * @param {Object} [options] - The {@link Transformation} parameters, {@link Configuration} parameters,
                   *  and standard HTML &lt;img&gt; tag attributes to apply to the image tag.
                   * @return {HTMLVideoElement} A video tag DOM element.
                   * @see <a href="https://cloudinary.com/documentation/video_transformation_reference" target="_blank">
                   *  Available video transformations</a>
                   * @see <a href="https://cloudinary.com/documentation/solution_overview#configuration_parameters"
                   *  target="_blank">Available configuration options</a>
                   */
                }, {
                  key: "video",
                  value: function(r) {
                    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                    return this.videoTag(r, n).toHtml();
                  }
                  /**
                   * Creates a new VideoTag instance using the configuration defined for this `cloudinary` instance.
                   * @function Cloudinary#videoTag
                   * @param {string} publicId - The public ID of the video.
                   * @param {Object} options - The {@link Transformation} parameters, {@link Configuration} parameters,
                   *  and standard HTML &lt;img&gt; tag attributes to apply to the image tag.
                   * @return {VideoTag} A VideoTag that is attached (chained) to this `cloudinary` instance.
                   * @see <a href="https://cloudinary.com/documentation/video_transformation_reference" target="_blank">
                   *  Available video transformations</a>
                   * @see <a href="https://cloudinary.com/documentation/solution_overview#configuration_parameters"
                   *  target="_blank">Available configuration options</a>
                   */
                }, {
                  key: "videoTag",
                  value: function(r, n) {
                    return n = dt({}, n, this.config()), new tn(r, n);
                  }
                  /**
                   * Generates a sprite PNG image that contains all images with the specified tag and the corresponding css file.
                   * @function Cloudinary#sprite_css
                   * @param {string} publicId - The tag on which to base the sprite image.
                   * @param {Object} [options] - The {@link Transformation} parameters to include in the URL.
                   * @return {string} The URL of the generated CSS file. The sprite image has the same URL, but with a PNG extension.
                   * @see <a href="https://cloudinary.com/documentation/sprite_generation" target="_blank">
                   *  Sprite generation</a>
                   * @see <a href="https://cloudinary.com/documentation/image_transformation_reference" target="_blank">
                   *  Available image transformations</a>
                   */
                }, {
                  key: "sprite_css",
                  value: function(r, n) {
                    return n = Q()({
                      type: "sprite"
                    }, n), r.match(/.css$/) || (n.format = "css"), this.url(r, n);
                  }
                  /**
                   * Initializes responsive image behavior for all image tags with the 'cld-responsive'
                   *  (or other defined {@link Cloudinary#responsive|responsive} class).<br/>
                   *  This method should be invoked after the page has loaded.<br/>
                   *  <b>Note</b>: Calls {@link Cloudinary#cloudinary_update|cloudinary_update} to modify image tags.
                   * @function Cloudinary#responsive
                   * @param {Object} options
                   * @param {String} [options.responsive_class='cld-responsive'] - An alternative class
                   *  to locate the relevant &lt;img&gt; tags.
                   * @param {number} [options.responsive_debounce=100] - The debounce interval in milliseconds.
                   * @param {boolean} [bootstrap=true] If true, processes the &lt;img&gt; tags by calling
                   *  {@link Cloudinary#cloudinary_update|cloudinary_update}. When false, the tags are processed
                   *  only after a resize event.
                   * @see {@link Cloudinary#cloudinary_update|cloudinary_update} for additional configuration parameters
                   * @see <a href="https://cloudinary.com/documentation/responsive_images#automating_responsive_images_with_javascript"
                   *  target="_blank">Automating responsive images with JavaScript</a>
                   * @return {function} that when called, removes the resize EventListener added by this function
                   */
                }, {
                  key: "responsive",
                  value: function(r) {
                    var n = this, o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0, f, h, g, v, S, T;
                    if (this.responsiveConfig = ht()(this.responsiveConfig || {}, r), v = (f = this.responsiveConfig.responsive_class) != null ? f : this.config("responsive_class"), o && this.cloudinary_update("img.".concat(v, ", img.cld-hidpi"), this.responsiveConfig), S = (h = (g = this.responsiveConfig.responsive_resize) != null ? g : this.config("responsive_resize")) != null ? h : !0, S && !this.responsiveResizeInitialized) {
                      this.responsiveConfig.resizing = this.responsiveResizeInitialized = !0, T = null;
                      var E = function() {
                        var M, vt, Ot, ut, Xt, Zt, gt;
                        return M = (vt = (Ot = n.responsiveConfig.responsive_debounce) != null ? Ot : n.config("responsive_debounce")) != null ? vt : 100, ut = function() {
                          T && (clearTimeout(T), T = null);
                        }, Xt = function() {
                          return n.cloudinary_update("img.".concat(v), n.responsiveConfig);
                        }, gt = function() {
                          return ut(), Xt();
                        }, Zt = function() {
                          ut(), T = setTimeout(gt, M);
                        }, M ? Zt() : Xt();
                      };
                      return window.addEventListener("resize", E), function() {
                        return window.removeEventListener("resize", E);
                      };
                    }
                  }
                  /**
                   * @function Cloudinary#calc_breakpoint
                   * @private
                   * @ignore
                   */
                }, {
                  key: "calc_breakpoint",
                  value: function(r, n, o) {
                    var f = _t(r, "breakpoints") || _t(r, "stoppoints") || this.config("breakpoints") || this.config("stoppoints") || ku;
                    return L()(f) ? f(n, o) : (G()(f) && (f = f.split(",").map(function(h) {
                      return parseInt(h);
                    }).sort(function(h, g) {
                      return h - g;
                    })), Bu(f, n));
                  }
                  /**
                   * @function Cloudinary#calc_stoppoint
                   * @deprecated Use {@link calc_breakpoint} instead.
                   * @private
                   * @ignore
                   */
                }, {
                  key: "calc_stoppoint",
                  value: function(r, n, o) {
                    return this.calc_breakpoint(r, n, o);
                  }
                  /**
                   * @function Cloudinary#device_pixel_ratio
                   * @private
                   */
                }, {
                  key: "device_pixel_ratio",
                  value: function(r) {
                    r = r ?? !0;
                    var n = (typeof window < "u" && window !== null ? window.devicePixelRatio : void 0) || 1;
                    r && (n = Math.ceil(n)), (n <= 0 || n === NaN) && (n = 1);
                    var o = n.toString();
                    return o.match(/^\d+$/) && (o += ".0"), o;
                  }
                  /**
                  * Applies responsiveness to all <code>&lt;img&gt;</code> tags under each relevant node
                  *  (regardless of whether the tag contains the {@link Cloudinary#responsive|responsive} class).
                  * @param {Element[]} nodes The parent nodes where you want to search for &lt;img&gt; tags.
                  * @param {Object} [options] The {@link Cloudinary#cloudinary_update|cloudinary_update} options to apply.
                  * @see <a href="https://cloudinary.com/documentation/image_transformation_reference"
                  *  target="_blank">Available image transformations</a>
                  * @function Cloudinary#processImageTags
                  */
                }, {
                  key: "processImageTags",
                  value: function(r, n) {
                    if (x(r))
                      return this;
                    n = dt({}, n || {}, this.config());
                    var o = r.filter(function(f) {
                      return /^img$/i.test(f.tagName);
                    }).map(function(f) {
                      var h = Q()({
                        width: f.getAttribute("width"),
                        height: f.getAttribute("height"),
                        src: f.getAttribute("src")
                      }, n), g = h.source || h.src;
                      delete h.source, delete h.src;
                      var v = new nt(h).toHtmlAttributes();
                      return Be(f, "src-cache", pt(g, h)), f.setAttribute("width", v.width), f.setAttribute("height", v.height), f;
                    });
                    return this.cloudinary_update(o, n), this;
                  }
                  /**
                  * Updates the dpr (for `dpr_auto`) and responsive (for `w_auto`) fields according to
                  *  the current container size and the device pixel ratio.<br/>
                  *  <b>Note</b>:`w_auto` is updated only for images marked with the `cld-responsive`
                  *  (or other defined {@link Cloudinary#responsive|responsive}) class.
                  * @function Cloudinary#cloudinary_update
                  * @param {(Array|string|NodeList)} elements - The HTML image elements to modify.
                  * @param {Object} options
                  * @param {boolean|string} [options.responsive_use_breakpoints=true]
                  * Possible values:<br/>
                  *  - `true`: Always use breakpoints for width.<br/>
                  *  - `resize`: Use exact width on first render and breakpoints on resize.<br/>
                  *  - `false`: Always use exact width.
                  * @param {boolean} [options.responsive] - If `true`, enable responsive on all specified elements.
                  *  Alternatively, you can define specific HTML elements to modify by adding the `cld-responsive`
                  *  (or other custom-defined {@link Cloudinary#responsive|responsive_class}) class to those elements.
                  * @param {boolean} [options.responsive_preserve_height] - If `true`, original css height is preserved.
                  *  Should be used only if the transformation supports different aspect ratios.
                  */
                }, {
                  key: "cloudinary_update",
                  value: function(r, n) {
                    var o = this, f, h, g, v;
                    if (r === null)
                      return this;
                    n == null && (n = {});
                    var S = n.responsive != null ? n.responsive : this.config("responsive");
                    r = ep(r);
                    var T;
                    this.responsiveConfig && this.responsiveConfig.responsive_class != null ? T = this.responsiveConfig.responsive_class : n.responsive_class != null ? T = n.responsive_class : T = this.config("responsive_class");
                    var E = n.round_dpr != null ? n.round_dpr : this.config("round_dpr");
                    return r.forEach(function(D) {
                      if (/img/i.test(D.tagName)) {
                        var M = !0;
                        if (S && tu(D, T), h = _t(D, "src-cache") || _t(D, "src"), !x(h)) {
                          h = Lu.call(o, h, E), At.isResponsive(D, T) && (f = qu(D), f !== 0 ? (/w_auto:breakpoints/.test(h) ? (v = nn(f, D), v ? h = h.replace(/w_auto:breakpoints([_0-9]*)(:[0-9]+)?/, "w_auto:breakpoints$1:".concat(v)) : M = !1) : (g = /w_auto(:(\d+))?/.exec(h), g && (v = Fu.call(o, D, f, g[2], n), v = nn(v, D), v ? h = h.replace(/w_auto[^,\/]*/g, "w_".concat(v)) : M = !1)), ke(D, "width"), n.responsive_preserve_height || ke(D, "height")) : M = !1);
                          var vt = n.loading === "lazy" && !o.isNativeLazyLoadSupported() && o.isLazyLoadSupported() && !r[0].getAttribute("src");
                          (M || vt) && o.setAttributeIfExists(r[0], "width", "data-width"), M && !vt && ue(D, "src", h);
                        }
                      }
                    }), this;
                  }
                  /**
                   * Sets element[toAttribute] = element[fromAttribute] if element[fromAttribute] is set
                   * @param element
                   * @param toAttribute
                   * @param fromAttribute
                   */
                }, {
                  key: "setAttributeIfExists",
                  value: function(r, n, o) {
                    var f = r.getAttribute(o);
                    f != null && ue(r, n, f);
                  }
                  /**
                   * Returns true if Intersection Observer API is supported
                   * @returns {boolean}
                   */
                }, {
                  key: "isLazyLoadSupported",
                  value: function() {
                    return window && "IntersectionObserver" in window;
                  }
                  /**
                   * Returns true if using Chrome
                   * @returns {boolean}
                   */
                }, {
                  key: "isNativeLazyLoadSupported",
                  value: function() {
                    return "loading" in HTMLImageElement.prototype;
                  }
                  /**
                   * Returns a {@link Transformation} object, initialized with the specified options, for chaining purposes.
                   * @function Cloudinary#transformation
                   * @param {Object} options The {@link Transformation} options to apply.
                   * @return {Transformation}
                   * @see Transformation
                   * @see <a href="https://cloudinary.com/documentation/image_transformation_reference" target="_blank">
                   *  Available image transformations</a>
                   * @see <a href="https://cloudinary.com/documentation/video_transformation_reference" target="_blank">
                   *  Available video transformations</a>
                   */
                }, {
                  key: "transformation",
                  value: function(r) {
                    return nt.new(this.config()).fromOptions(r).setParent(this);
                  }
                  /**
                   * @description This function will append a TransparentVideo element to the htmlElContainer passed to it.
                   *              TransparentVideo can either be an HTML Video tag, or an HTML Canvas Tag.
                   * @param {HTMLElement} htmlElContainer
                   * @param {string} publicId
                   * @param {object} options The {@link TransparentVideoOptions} options to apply - Extends TransformationOptions
                   *                 options.playsinline    - HTML Video Tag's native playsinline - passed to video element.
                   *                 options.poster         - HTML Video Tag's native poster - passed to video element.
                   *                 options.loop           - HTML Video Tag's native loop - passed to video element.
                   *                 options?.externalLibraries = { [key: string]: string} - map of external libraries to be loaded
                   * @return {Promise<HTMLElement | {status:string, message:string}>}
                   */
                }, {
                  key: "injectTransparentVideoElement",
                  value: function(r, n) {
                    var o = this, f = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
                    return new Promise(function(h, g) {
                      r || g({
                        status: "error",
                        message: "Expecting htmlElContainer to be HTMLElement"
                      }), up(f);
                      var v = o.video_url(n, f);
                      Ap().then(function(S) {
                        var T;
                        S ? (T = np(r, o, n, f), h(r)) : T = _p(r, v, f), T.then(function() {
                          h(r);
                        }).catch(function(E) {
                          var D = E.status, M = E.message;
                          g({
                            status: D,
                            message: M
                          });
                        });
                      }).catch(function(S) {
                        var T = S.status, E = S.message;
                        g({
                          status: T,
                          message: E
                        });
                      });
                    });
                  }
                }], [{
                  key: "new",
                  value: function(r) {
                    return new this(r);
                  }
                }]);
              }();
              Q()(Mu, O);
              var Vu = Mu;
              C.default = {
                ClientHintsMetaTag: xu,
                Cloudinary: Vu,
                Condition: Me,
                Configuration: Ve,
                crc32: U,
                Expression: Y,
                FetchLayer: He,
                HtmlTag: At,
                ImageTag: Ye,
                Layer: kt,
                PictureTag: Xr,
                SubtitlesLayer: Nr,
                TextLayer: le,
                Transformation: nt,
                utf8_encode: q,
                Util: _,
                VideoTag: tn
              };
            }
          ),
          /***/
          "lodash/assign": (
            /***/
            function(P, C) {
              P.exports = u;
            }
          ),
          /***/
          "lodash/cloneDeep": (
            /***/
            function(P, C) {
              P.exports = s;
            }
          ),
          /***/
          "lodash/compact": (
            /***/
            function(P, C) {
              P.exports = c;
            }
          ),
          /***/
          "lodash/difference": (
            /***/
            function(P, C) {
              P.exports = l;
            }
          ),
          /***/
          "lodash/functions": (
            /***/
            function(P, C) {
              P.exports = d;
            }
          ),
          /***/
          "lodash/identity": (
            /***/
            function(P, C) {
              P.exports = p;
            }
          ),
          /***/
          "lodash/includes": (
            /***/
            function(P, C) {
              P.exports = b;
            }
          ),
          /***/
          "lodash/isArray": (
            /***/
            function(P, C) {
              P.exports = m;
            }
          ),
          /***/
          "lodash/isElement": (
            /***/
            function(P, C) {
              P.exports = A;
            }
          ),
          /***/
          "lodash/isFunction": (
            /***/
            function(P, C) {
              P.exports = w;
            }
          ),
          /***/
          "lodash/isPlainObject": (
            /***/
            function(P, C) {
              P.exports = R;
            }
          ),
          /***/
          "lodash/isString": (
            /***/
            function(P, C) {
              P.exports = F;
            }
          ),
          /***/
          "lodash/merge": (
            /***/
            function(P, C) {
              P.exports = B;
            }
          ),
          /***/
          "lodash/trim": (
            /***/
            function(P, C) {
              P.exports = V;
            }
          )
          /******/
        })
      );
    });
  }(er)), er.exports;
}
var Om = Am();
const jl = "bolt-energie", Tm = new _v({
  cloud: {
    cloudName: jl
  },
  url: {
    secure: !0
  }
}), Pm = new Om.Cloudinary({ cloud_name: jl }), Cm = (a, i) => Tm.image(a).format("auto").quality(i || "auto:best");
export {
  Tm as cld,
  Pm as cld_core,
  Cm as getCloudinaryImage
};
